import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_engine_unit_proto from './dcei_engine_unit_proto';
import * as dcei_engine_ability_proto from './dcei_engine_ability_proto';
import * as dcei_engine_weapon_proto from './dcei_engine_weapon_proto';
import * as dcei_engine_effect_proto from './dcei_engine_effect_proto';
import * as dcei_engine_behavior_proto from './dcei_engine_behavior_proto';
import * as dcei_engine_upgrade_proto from './dcei_engine_upgrade_proto';
import * as dcei_engine_actor_proto from './dcei_engine_actor_proto';
import * as dcei_engine_spawn_pattern_proto from './dcei_engine_spawn_pattern_proto';
import * as dcei_engine_spawn_wave_proto from './dcei_engine_spawn_wave_proto';
import * as dcei_engine_mover_proto from './dcei_engine_mover_proto';
import * as dcei_engine_validator_proto from './dcei_engine_validator_proto';
import * as dcei_engine_expression_proto from './dcei_engine_expression_proto';
import * as dcei_engine_trigger_proto from './dcei_engine_trigger_proto';
import * as dcei_engine_input_keys_proto from './dcei_engine_input_keys_proto';
import * as dcei_engine_localization_proto from './dcei_engine_localization_proto';
import * as dcei_engine_user_data_proto from './dcei_engine_user_data_proto';
class DataFile_UnitsEntry {
  get descriptor() {
    return DataFile_UnitsEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataFile_UnitsEntry) {
      return value;
    }
    return DataFile_UnitsEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataFile_UnitsEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = dcei_engine_unit_proto.Unit.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = dcei_engine_unit_proto.Unit.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_engine_unit_proto.Unit}
   */
  get value() {
    return this._hasValue ? this._value : dcei_engine_unit_proto.Unit.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_UnitsEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new DataFile_UnitsEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_UnitsEntry(this);
              copy._hasValue = true;
              copy._value = dcei_engine_unit_proto.Unit.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new DataFile_UnitsEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new DataFile_UnitsEntry(this);
            copy._hasValue = true;
            copy._value = dcei_engine_unit_proto.Unit.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new DataFile_UnitsEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataFile_UnitsEntry} other
   * @returns {DataFile_UnitsEntry}
   */
  merge(other) {
    const copy = new DataFile_UnitsEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
DataFile_UnitsEntry.default = new DataFile_UnitsEntry();
class DataFile_UnitsEntry_Builder {
  constructor(value) {
    this._value = new DataFile_UnitsEntry(value);
  }
  build() {
    return new DataFile_UnitsEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
DataFile_UnitsEntry.Builder = DataFile_UnitsEntry_Builder;
class DataFile_UnitsEntry_WithParent {
  /**
   * @param {DataFile_UnitsEntry} value
   * @param {DataFile_UnitsEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataFile_UnitsEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new dcei_engine_unit_proto.Unit.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new dcei_engine_unit_proto.Unit.WithParent(dcei_engine_unit_proto.Unit.default, this._parent.value) : dcei_engine_unit_proto.Unit.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new DataFile_UnitsEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
DataFile_UnitsEntry_WithParent.default = new DataFile_UnitsEntry_WithParent(DataFile_UnitsEntry.default, null);
DataFile_UnitsEntry.WithParent = DataFile_UnitsEntry_WithParent;
class DataFile_UnitsEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: dcei_engine_unit_proto.Unit,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
DataFile_UnitsEntry.descriptor = new DataFile_UnitsEntry_Descriptor();
class DataFile_WeaponsEntry {
  get descriptor() {
    return DataFile_WeaponsEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataFile_WeaponsEntry) {
      return value;
    }
    return DataFile_WeaponsEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataFile_WeaponsEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = dcei_engine_weapon_proto.Weapon.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = dcei_engine_weapon_proto.Weapon.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_engine_weapon_proto.Weapon}
   */
  get value() {
    return this._hasValue ? this._value : dcei_engine_weapon_proto.Weapon.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_WeaponsEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new DataFile_WeaponsEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_WeaponsEntry(this);
              copy._hasValue = true;
              copy._value = dcei_engine_weapon_proto.Weapon.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new DataFile_WeaponsEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new DataFile_WeaponsEntry(this);
            copy._hasValue = true;
            copy._value = dcei_engine_weapon_proto.Weapon.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new DataFile_WeaponsEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataFile_WeaponsEntry} other
   * @returns {DataFile_WeaponsEntry}
   */
  merge(other) {
    const copy = new DataFile_WeaponsEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
DataFile_WeaponsEntry.default = new DataFile_WeaponsEntry();
class DataFile_WeaponsEntry_Builder {
  constructor(value) {
    this._value = new DataFile_WeaponsEntry(value);
  }
  build() {
    return new DataFile_WeaponsEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
DataFile_WeaponsEntry.Builder = DataFile_WeaponsEntry_Builder;
class DataFile_WeaponsEntry_WithParent {
  /**
   * @param {DataFile_WeaponsEntry} value
   * @param {DataFile_WeaponsEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataFile_WeaponsEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new dcei_engine_weapon_proto.Weapon.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new dcei_engine_weapon_proto.Weapon.WithParent(dcei_engine_weapon_proto.Weapon.default, this._parent.value) : dcei_engine_weapon_proto.Weapon.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new DataFile_WeaponsEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
DataFile_WeaponsEntry_WithParent.default = new DataFile_WeaponsEntry_WithParent(DataFile_WeaponsEntry.default, null);
DataFile_WeaponsEntry.WithParent = DataFile_WeaponsEntry_WithParent;
class DataFile_WeaponsEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: dcei_engine_weapon_proto.Weapon,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
DataFile_WeaponsEntry.descriptor = new DataFile_WeaponsEntry_Descriptor();
class DataFile_AbilitiesEntry {
  get descriptor() {
    return DataFile_AbilitiesEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataFile_AbilitiesEntry) {
      return value;
    }
    return DataFile_AbilitiesEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataFile_AbilitiesEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = dcei_engine_ability_proto.Ability.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = dcei_engine_ability_proto.Ability.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_engine_ability_proto.Ability}
   */
  get value() {
    return this._hasValue ? this._value : dcei_engine_ability_proto.Ability.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_AbilitiesEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new DataFile_AbilitiesEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_AbilitiesEntry(this);
              copy._hasValue = true;
              copy._value = dcei_engine_ability_proto.Ability.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new DataFile_AbilitiesEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new DataFile_AbilitiesEntry(this);
            copy._hasValue = true;
            copy._value = dcei_engine_ability_proto.Ability.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new DataFile_AbilitiesEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataFile_AbilitiesEntry} other
   * @returns {DataFile_AbilitiesEntry}
   */
  merge(other) {
    const copy = new DataFile_AbilitiesEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
DataFile_AbilitiesEntry.default = new DataFile_AbilitiesEntry();
class DataFile_AbilitiesEntry_Builder {
  constructor(value) {
    this._value = new DataFile_AbilitiesEntry(value);
  }
  build() {
    return new DataFile_AbilitiesEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
DataFile_AbilitiesEntry.Builder = DataFile_AbilitiesEntry_Builder;
class DataFile_AbilitiesEntry_WithParent {
  /**
   * @param {DataFile_AbilitiesEntry} value
   * @param {DataFile_AbilitiesEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataFile_AbilitiesEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new dcei_engine_ability_proto.Ability.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new dcei_engine_ability_proto.Ability.WithParent(dcei_engine_ability_proto.Ability.default, this._parent.value) : dcei_engine_ability_proto.Ability.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new DataFile_AbilitiesEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
DataFile_AbilitiesEntry_WithParent.default = new DataFile_AbilitiesEntry_WithParent(DataFile_AbilitiesEntry.default, null);
DataFile_AbilitiesEntry.WithParent = DataFile_AbilitiesEntry_WithParent;
class DataFile_AbilitiesEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: dcei_engine_ability_proto.Ability,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
DataFile_AbilitiesEntry.descriptor = new DataFile_AbilitiesEntry_Descriptor();
class DataFile_EffectsEntry {
  get descriptor() {
    return DataFile_EffectsEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataFile_EffectsEntry) {
      return value;
    }
    return DataFile_EffectsEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataFile_EffectsEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = dcei_engine_effect_proto.Effect.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = dcei_engine_effect_proto.Effect.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_engine_effect_proto.Effect}
   */
  get value() {
    return this._hasValue ? this._value : dcei_engine_effect_proto.Effect.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_EffectsEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new DataFile_EffectsEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_EffectsEntry(this);
              copy._hasValue = true;
              copy._value = dcei_engine_effect_proto.Effect.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new DataFile_EffectsEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new DataFile_EffectsEntry(this);
            copy._hasValue = true;
            copy._value = dcei_engine_effect_proto.Effect.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new DataFile_EffectsEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataFile_EffectsEntry} other
   * @returns {DataFile_EffectsEntry}
   */
  merge(other) {
    const copy = new DataFile_EffectsEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
DataFile_EffectsEntry.default = new DataFile_EffectsEntry();
class DataFile_EffectsEntry_Builder {
  constructor(value) {
    this._value = new DataFile_EffectsEntry(value);
  }
  build() {
    return new DataFile_EffectsEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
DataFile_EffectsEntry.Builder = DataFile_EffectsEntry_Builder;
class DataFile_EffectsEntry_WithParent {
  /**
   * @param {DataFile_EffectsEntry} value
   * @param {DataFile_EffectsEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataFile_EffectsEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new dcei_engine_effect_proto.Effect.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new dcei_engine_effect_proto.Effect.WithParent(dcei_engine_effect_proto.Effect.default, this._parent.value) : dcei_engine_effect_proto.Effect.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new DataFile_EffectsEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
DataFile_EffectsEntry_WithParent.default = new DataFile_EffectsEntry_WithParent(DataFile_EffectsEntry.default, null);
DataFile_EffectsEntry.WithParent = DataFile_EffectsEntry_WithParent;
class DataFile_EffectsEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: dcei_engine_effect_proto.Effect,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
DataFile_EffectsEntry.descriptor = new DataFile_EffectsEntry_Descriptor();
class DataFile_BehaviorsEntry {
  get descriptor() {
    return DataFile_BehaviorsEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataFile_BehaviorsEntry) {
      return value;
    }
    return DataFile_BehaviorsEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataFile_BehaviorsEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = dcei_engine_behavior_proto.Behavior.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = dcei_engine_behavior_proto.Behavior.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_engine_behavior_proto.Behavior}
   */
  get value() {
    return this._hasValue ? this._value : dcei_engine_behavior_proto.Behavior.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_BehaviorsEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new DataFile_BehaviorsEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_BehaviorsEntry(this);
              copy._hasValue = true;
              copy._value = dcei_engine_behavior_proto.Behavior.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new DataFile_BehaviorsEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new DataFile_BehaviorsEntry(this);
            copy._hasValue = true;
            copy._value = dcei_engine_behavior_proto.Behavior.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new DataFile_BehaviorsEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataFile_BehaviorsEntry} other
   * @returns {DataFile_BehaviorsEntry}
   */
  merge(other) {
    const copy = new DataFile_BehaviorsEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
DataFile_BehaviorsEntry.default = new DataFile_BehaviorsEntry();
class DataFile_BehaviorsEntry_Builder {
  constructor(value) {
    this._value = new DataFile_BehaviorsEntry(value);
  }
  build() {
    return new DataFile_BehaviorsEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
DataFile_BehaviorsEntry.Builder = DataFile_BehaviorsEntry_Builder;
class DataFile_BehaviorsEntry_WithParent {
  /**
   * @param {DataFile_BehaviorsEntry} value
   * @param {DataFile_BehaviorsEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataFile_BehaviorsEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new dcei_engine_behavior_proto.Behavior.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new dcei_engine_behavior_proto.Behavior.WithParent(dcei_engine_behavior_proto.Behavior.default, this._parent.value) : dcei_engine_behavior_proto.Behavior.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new DataFile_BehaviorsEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
DataFile_BehaviorsEntry_WithParent.default = new DataFile_BehaviorsEntry_WithParent(DataFile_BehaviorsEntry.default, null);
DataFile_BehaviorsEntry.WithParent = DataFile_BehaviorsEntry_WithParent;
class DataFile_BehaviorsEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: dcei_engine_behavior_proto.Behavior,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
DataFile_BehaviorsEntry.descriptor = new DataFile_BehaviorsEntry_Descriptor();
class DataFile_UpgradesEntry {
  get descriptor() {
    return DataFile_UpgradesEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataFile_UpgradesEntry) {
      return value;
    }
    return DataFile_UpgradesEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataFile_UpgradesEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = dcei_engine_upgrade_proto.Upgrade.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = dcei_engine_upgrade_proto.Upgrade.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_engine_upgrade_proto.Upgrade}
   */
  get value() {
    return this._hasValue ? this._value : dcei_engine_upgrade_proto.Upgrade.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_UpgradesEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new DataFile_UpgradesEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_UpgradesEntry(this);
              copy._hasValue = true;
              copy._value = dcei_engine_upgrade_proto.Upgrade.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new DataFile_UpgradesEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new DataFile_UpgradesEntry(this);
            copy._hasValue = true;
            copy._value = dcei_engine_upgrade_proto.Upgrade.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new DataFile_UpgradesEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataFile_UpgradesEntry} other
   * @returns {DataFile_UpgradesEntry}
   */
  merge(other) {
    const copy = new DataFile_UpgradesEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
DataFile_UpgradesEntry.default = new DataFile_UpgradesEntry();
class DataFile_UpgradesEntry_Builder {
  constructor(value) {
    this._value = new DataFile_UpgradesEntry(value);
  }
  build() {
    return new DataFile_UpgradesEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
DataFile_UpgradesEntry.Builder = DataFile_UpgradesEntry_Builder;
class DataFile_UpgradesEntry_WithParent {
  /**
   * @param {DataFile_UpgradesEntry} value
   * @param {DataFile_UpgradesEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataFile_UpgradesEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new dcei_engine_upgrade_proto.Upgrade.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new dcei_engine_upgrade_proto.Upgrade.WithParent(dcei_engine_upgrade_proto.Upgrade.default, this._parent.value) : dcei_engine_upgrade_proto.Upgrade.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new DataFile_UpgradesEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
DataFile_UpgradesEntry_WithParent.default = new DataFile_UpgradesEntry_WithParent(DataFile_UpgradesEntry.default, null);
DataFile_UpgradesEntry.WithParent = DataFile_UpgradesEntry_WithParent;
class DataFile_UpgradesEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: dcei_engine_upgrade_proto.Upgrade,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
DataFile_UpgradesEntry.descriptor = new DataFile_UpgradesEntry_Descriptor();
class DataFile_MoversEntry {
  get descriptor() {
    return DataFile_MoversEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataFile_MoversEntry) {
      return value;
    }
    return DataFile_MoversEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataFile_MoversEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = dcei_engine_mover_proto.Mover.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = dcei_engine_mover_proto.Mover.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_engine_mover_proto.Mover}
   */
  get value() {
    return this._hasValue ? this._value : dcei_engine_mover_proto.Mover.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_MoversEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new DataFile_MoversEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_MoversEntry(this);
              copy._hasValue = true;
              copy._value = dcei_engine_mover_proto.Mover.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new DataFile_MoversEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new DataFile_MoversEntry(this);
            copy._hasValue = true;
            copy._value = dcei_engine_mover_proto.Mover.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new DataFile_MoversEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataFile_MoversEntry} other
   * @returns {DataFile_MoversEntry}
   */
  merge(other) {
    const copy = new DataFile_MoversEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
DataFile_MoversEntry.default = new DataFile_MoversEntry();
class DataFile_MoversEntry_Builder {
  constructor(value) {
    this._value = new DataFile_MoversEntry(value);
  }
  build() {
    return new DataFile_MoversEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
DataFile_MoversEntry.Builder = DataFile_MoversEntry_Builder;
class DataFile_MoversEntry_WithParent {
  /**
   * @param {DataFile_MoversEntry} value
   * @param {DataFile_MoversEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataFile_MoversEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new dcei_engine_mover_proto.Mover.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new dcei_engine_mover_proto.Mover.WithParent(dcei_engine_mover_proto.Mover.default, this._parent.value) : dcei_engine_mover_proto.Mover.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new DataFile_MoversEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
DataFile_MoversEntry_WithParent.default = new DataFile_MoversEntry_WithParent(DataFile_MoversEntry.default, null);
DataFile_MoversEntry.WithParent = DataFile_MoversEntry_WithParent;
class DataFile_MoversEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: dcei_engine_mover_proto.Mover,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
DataFile_MoversEntry.descriptor = new DataFile_MoversEntry_Descriptor();
class DataFile_ValidatorsEntry {
  get descriptor() {
    return DataFile_ValidatorsEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataFile_ValidatorsEntry) {
      return value;
    }
    return DataFile_ValidatorsEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataFile_ValidatorsEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = dcei_engine_validator_proto.Validator.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = dcei_engine_validator_proto.Validator.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_engine_validator_proto.Validator}
   */
  get value() {
    return this._hasValue ? this._value : dcei_engine_validator_proto.Validator.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_ValidatorsEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new DataFile_ValidatorsEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_ValidatorsEntry(this);
              copy._hasValue = true;
              copy._value = dcei_engine_validator_proto.Validator.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new DataFile_ValidatorsEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new DataFile_ValidatorsEntry(this);
            copy._hasValue = true;
            copy._value = dcei_engine_validator_proto.Validator.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new DataFile_ValidatorsEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataFile_ValidatorsEntry} other
   * @returns {DataFile_ValidatorsEntry}
   */
  merge(other) {
    const copy = new DataFile_ValidatorsEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
DataFile_ValidatorsEntry.default = new DataFile_ValidatorsEntry();
class DataFile_ValidatorsEntry_Builder {
  constructor(value) {
    this._value = new DataFile_ValidatorsEntry(value);
  }
  build() {
    return new DataFile_ValidatorsEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
DataFile_ValidatorsEntry.Builder = DataFile_ValidatorsEntry_Builder;
class DataFile_ValidatorsEntry_WithParent {
  /**
   * @param {DataFile_ValidatorsEntry} value
   * @param {DataFile_ValidatorsEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataFile_ValidatorsEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new dcei_engine_validator_proto.Validator.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new dcei_engine_validator_proto.Validator.WithParent(dcei_engine_validator_proto.Validator.default, this._parent.value) : dcei_engine_validator_proto.Validator.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new DataFile_ValidatorsEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
DataFile_ValidatorsEntry_WithParent.default = new DataFile_ValidatorsEntry_WithParent(DataFile_ValidatorsEntry.default, null);
DataFile_ValidatorsEntry.WithParent = DataFile_ValidatorsEntry_WithParent;
class DataFile_ValidatorsEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: dcei_engine_validator_proto.Validator,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
DataFile_ValidatorsEntry.descriptor = new DataFile_ValidatorsEntry_Descriptor();
class DataFile_ExpressionsEntry {
  get descriptor() {
    return DataFile_ExpressionsEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataFile_ExpressionsEntry) {
      return value;
    }
    return DataFile_ExpressionsEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataFile_ExpressionsEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = dcei_engine_expression_proto.ValidatorExpressions.Expression.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_engine_expression_proto.ValidatorExpressions.Expression}
   */
  get value() {
    return this._hasValue ? this._value : dcei_engine_expression_proto.ValidatorExpressions.Expression.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_ExpressionsEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new DataFile_ExpressionsEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_ExpressionsEntry(this);
              copy._hasValue = true;
              copy._value = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new DataFile_ExpressionsEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new DataFile_ExpressionsEntry(this);
            copy._hasValue = true;
            copy._value = dcei_engine_expression_proto.ValidatorExpressions.Expression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new DataFile_ExpressionsEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataFile_ExpressionsEntry} other
   * @returns {DataFile_ExpressionsEntry}
   */
  merge(other) {
    const copy = new DataFile_ExpressionsEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
DataFile_ExpressionsEntry.default = new DataFile_ExpressionsEntry();
class DataFile_ExpressionsEntry_Builder {
  constructor(value) {
    this._value = new DataFile_ExpressionsEntry(value);
  }
  build() {
    return new DataFile_ExpressionsEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
DataFile_ExpressionsEntry.Builder = DataFile_ExpressionsEntry_Builder;
class DataFile_ExpressionsEntry_WithParent {
  /**
   * @param {DataFile_ExpressionsEntry} value
   * @param {DataFile_ExpressionsEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataFile_ExpressionsEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(dcei_engine_expression_proto.ValidatorExpressions.Expression.default, this._parent.value) : dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new DataFile_ExpressionsEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
DataFile_ExpressionsEntry_WithParent.default = new DataFile_ExpressionsEntry_WithParent(DataFile_ExpressionsEntry.default, null);
DataFile_ExpressionsEntry.WithParent = DataFile_ExpressionsEntry_WithParent;
class DataFile_ExpressionsEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: dcei_engine_expression_proto.ValidatorExpressions.Expression,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
DataFile_ExpressionsEntry.descriptor = new DataFile_ExpressionsEntry_Descriptor();
class DataFile_DataUpgradesEntry {
  get descriptor() {
    return DataFile_DataUpgradesEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataFile_DataUpgradesEntry) {
      return value;
    }
    return DataFile_DataUpgradesEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataFile_DataUpgradesEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = dcei_engine_upgrade_proto.DataUpgrade.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = dcei_engine_upgrade_proto.DataUpgrade.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_engine_upgrade_proto.DataUpgrade}
   */
  get value() {
    return this._hasValue ? this._value : dcei_engine_upgrade_proto.DataUpgrade.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_DataUpgradesEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new DataFile_DataUpgradesEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_DataUpgradesEntry(this);
              copy._hasValue = true;
              copy._value = dcei_engine_upgrade_proto.DataUpgrade.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new DataFile_DataUpgradesEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new DataFile_DataUpgradesEntry(this);
            copy._hasValue = true;
            copy._value = dcei_engine_upgrade_proto.DataUpgrade.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new DataFile_DataUpgradesEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataFile_DataUpgradesEntry} other
   * @returns {DataFile_DataUpgradesEntry}
   */
  merge(other) {
    const copy = new DataFile_DataUpgradesEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
DataFile_DataUpgradesEntry.default = new DataFile_DataUpgradesEntry();
class DataFile_DataUpgradesEntry_Builder {
  constructor(value) {
    this._value = new DataFile_DataUpgradesEntry(value);
  }
  build() {
    return new DataFile_DataUpgradesEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
DataFile_DataUpgradesEntry.Builder = DataFile_DataUpgradesEntry_Builder;
class DataFile_DataUpgradesEntry_WithParent {
  /**
   * @param {DataFile_DataUpgradesEntry} value
   * @param {DataFile_DataUpgradesEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataFile_DataUpgradesEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new dcei_engine_upgrade_proto.DataUpgrade.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new dcei_engine_upgrade_proto.DataUpgrade.WithParent(dcei_engine_upgrade_proto.DataUpgrade.default, this._parent.value) : dcei_engine_upgrade_proto.DataUpgrade.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new DataFile_DataUpgradesEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
DataFile_DataUpgradesEntry_WithParent.default = new DataFile_DataUpgradesEntry_WithParent(DataFile_DataUpgradesEntry.default, null);
DataFile_DataUpgradesEntry.WithParent = DataFile_DataUpgradesEntry_WithParent;
class DataFile_DataUpgradesEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: dcei_engine_upgrade_proto.DataUpgrade,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
DataFile_DataUpgradesEntry.descriptor = new DataFile_DataUpgradesEntry_Descriptor();
class DataFile_ActorsEntry {
  get descriptor() {
    return DataFile_ActorsEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataFile_ActorsEntry) {
      return value;
    }
    return DataFile_ActorsEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataFile_ActorsEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = dcei_engine_actor_proto.Actor.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = dcei_engine_actor_proto.Actor.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_engine_actor_proto.Actor}
   */
  get value() {
    return this._hasValue ? this._value : dcei_engine_actor_proto.Actor.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_ActorsEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new DataFile_ActorsEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_ActorsEntry(this);
              copy._hasValue = true;
              copy._value = dcei_engine_actor_proto.Actor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new DataFile_ActorsEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new DataFile_ActorsEntry(this);
            copy._hasValue = true;
            copy._value = dcei_engine_actor_proto.Actor.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new DataFile_ActorsEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataFile_ActorsEntry} other
   * @returns {DataFile_ActorsEntry}
   */
  merge(other) {
    const copy = new DataFile_ActorsEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
DataFile_ActorsEntry.default = new DataFile_ActorsEntry();
class DataFile_ActorsEntry_Builder {
  constructor(value) {
    this._value = new DataFile_ActorsEntry(value);
  }
  build() {
    return new DataFile_ActorsEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
DataFile_ActorsEntry.Builder = DataFile_ActorsEntry_Builder;
class DataFile_ActorsEntry_WithParent {
  /**
   * @param {DataFile_ActorsEntry} value
   * @param {DataFile_ActorsEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataFile_ActorsEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new dcei_engine_actor_proto.Actor.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new dcei_engine_actor_proto.Actor.WithParent(dcei_engine_actor_proto.Actor.default, this._parent.value) : dcei_engine_actor_proto.Actor.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new DataFile_ActorsEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
DataFile_ActorsEntry_WithParent.default = new DataFile_ActorsEntry_WithParent(DataFile_ActorsEntry.default, null);
DataFile_ActorsEntry.WithParent = DataFile_ActorsEntry_WithParent;
class DataFile_ActorsEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: dcei_engine_actor_proto.Actor,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
DataFile_ActorsEntry.descriptor = new DataFile_ActorsEntry_Descriptor();
class DataFile_ActorEventMacrosEntry {
  get descriptor() {
    return DataFile_ActorEventMacrosEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataFile_ActorEventMacrosEntry) {
      return value;
    }
    return DataFile_ActorEventMacrosEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataFile_ActorEventMacrosEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = dcei_engine_actor_proto.ActorEventMacro.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = dcei_engine_actor_proto.ActorEventMacro.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_engine_actor_proto.ActorEventMacro}
   */
  get value() {
    return this._hasValue ? this._value : dcei_engine_actor_proto.ActorEventMacro.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_ActorEventMacrosEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new DataFile_ActorEventMacrosEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_ActorEventMacrosEntry(this);
              copy._hasValue = true;
              copy._value = dcei_engine_actor_proto.ActorEventMacro.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new DataFile_ActorEventMacrosEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new DataFile_ActorEventMacrosEntry(this);
            copy._hasValue = true;
            copy._value = dcei_engine_actor_proto.ActorEventMacro.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new DataFile_ActorEventMacrosEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataFile_ActorEventMacrosEntry} other
   * @returns {DataFile_ActorEventMacrosEntry}
   */
  merge(other) {
    const copy = new DataFile_ActorEventMacrosEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
DataFile_ActorEventMacrosEntry.default = new DataFile_ActorEventMacrosEntry();
class DataFile_ActorEventMacrosEntry_Builder {
  constructor(value) {
    this._value = new DataFile_ActorEventMacrosEntry(value);
  }
  build() {
    return new DataFile_ActorEventMacrosEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
DataFile_ActorEventMacrosEntry.Builder = DataFile_ActorEventMacrosEntry_Builder;
class DataFile_ActorEventMacrosEntry_WithParent {
  /**
   * @param {DataFile_ActorEventMacrosEntry} value
   * @param {DataFile_ActorEventMacrosEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataFile_ActorEventMacrosEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new dcei_engine_actor_proto.ActorEventMacro.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new dcei_engine_actor_proto.ActorEventMacro.WithParent(dcei_engine_actor_proto.ActorEventMacro.default, this._parent.value) : dcei_engine_actor_proto.ActorEventMacro.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new DataFile_ActorEventMacrosEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
DataFile_ActorEventMacrosEntry_WithParent.default = new DataFile_ActorEventMacrosEntry_WithParent(DataFile_ActorEventMacrosEntry.default, null);
DataFile_ActorEventMacrosEntry.WithParent = DataFile_ActorEventMacrosEntry_WithParent;
class DataFile_ActorEventMacrosEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: dcei_engine_actor_proto.ActorEventMacro,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
DataFile_ActorEventMacrosEntry.descriptor = new DataFile_ActorEventMacrosEntry_Descriptor();
class DataFile_SpawnPatternsEntry {
  get descriptor() {
    return DataFile_SpawnPatternsEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataFile_SpawnPatternsEntry) {
      return value;
    }
    return DataFile_SpawnPatternsEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataFile_SpawnPatternsEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = dcei_engine_spawn_pattern_proto.SpawnPattern.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = dcei_engine_spawn_pattern_proto.SpawnPattern.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_engine_spawn_pattern_proto.SpawnPattern}
   */
  get value() {
    return this._hasValue ? this._value : dcei_engine_spawn_pattern_proto.SpawnPattern.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_SpawnPatternsEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new DataFile_SpawnPatternsEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_SpawnPatternsEntry(this);
              copy._hasValue = true;
              copy._value = dcei_engine_spawn_pattern_proto.SpawnPattern.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new DataFile_SpawnPatternsEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new DataFile_SpawnPatternsEntry(this);
            copy._hasValue = true;
            copy._value = dcei_engine_spawn_pattern_proto.SpawnPattern.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new DataFile_SpawnPatternsEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataFile_SpawnPatternsEntry} other
   * @returns {DataFile_SpawnPatternsEntry}
   */
  merge(other) {
    const copy = new DataFile_SpawnPatternsEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
DataFile_SpawnPatternsEntry.default = new DataFile_SpawnPatternsEntry();
class DataFile_SpawnPatternsEntry_Builder {
  constructor(value) {
    this._value = new DataFile_SpawnPatternsEntry(value);
  }
  build() {
    return new DataFile_SpawnPatternsEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
DataFile_SpawnPatternsEntry.Builder = DataFile_SpawnPatternsEntry_Builder;
class DataFile_SpawnPatternsEntry_WithParent {
  /**
   * @param {DataFile_SpawnPatternsEntry} value
   * @param {DataFile_SpawnPatternsEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataFile_SpawnPatternsEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new dcei_engine_spawn_pattern_proto.SpawnPattern.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new dcei_engine_spawn_pattern_proto.SpawnPattern.WithParent(dcei_engine_spawn_pattern_proto.SpawnPattern.default, this._parent.value) : dcei_engine_spawn_pattern_proto.SpawnPattern.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new DataFile_SpawnPatternsEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
DataFile_SpawnPatternsEntry_WithParent.default = new DataFile_SpawnPatternsEntry_WithParent(DataFile_SpawnPatternsEntry.default, null);
DataFile_SpawnPatternsEntry.WithParent = DataFile_SpawnPatternsEntry_WithParent;
class DataFile_SpawnPatternsEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: dcei_engine_spawn_pattern_proto.SpawnPattern,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
DataFile_SpawnPatternsEntry.descriptor = new DataFile_SpawnPatternsEntry_Descriptor();
class DataFile_SpawnWavesEntry {
  get descriptor() {
    return DataFile_SpawnWavesEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataFile_SpawnWavesEntry) {
      return value;
    }
    return DataFile_SpawnWavesEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataFile_SpawnWavesEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = dcei_engine_spawn_wave_proto.SpawnWave.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = dcei_engine_spawn_wave_proto.SpawnWave.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_engine_spawn_wave_proto.SpawnWave}
   */
  get value() {
    return this._hasValue ? this._value : dcei_engine_spawn_wave_proto.SpawnWave.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_SpawnWavesEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new DataFile_SpawnWavesEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_SpawnWavesEntry(this);
              copy._hasValue = true;
              copy._value = dcei_engine_spawn_wave_proto.SpawnWave.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new DataFile_SpawnWavesEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new DataFile_SpawnWavesEntry(this);
            copy._hasValue = true;
            copy._value = dcei_engine_spawn_wave_proto.SpawnWave.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new DataFile_SpawnWavesEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataFile_SpawnWavesEntry} other
   * @returns {DataFile_SpawnWavesEntry}
   */
  merge(other) {
    const copy = new DataFile_SpawnWavesEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
DataFile_SpawnWavesEntry.default = new DataFile_SpawnWavesEntry();
class DataFile_SpawnWavesEntry_Builder {
  constructor(value) {
    this._value = new DataFile_SpawnWavesEntry(value);
  }
  build() {
    return new DataFile_SpawnWavesEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
DataFile_SpawnWavesEntry.Builder = DataFile_SpawnWavesEntry_Builder;
class DataFile_SpawnWavesEntry_WithParent {
  /**
   * @param {DataFile_SpawnWavesEntry} value
   * @param {DataFile_SpawnWavesEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataFile_SpawnWavesEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new dcei_engine_spawn_wave_proto.SpawnWave.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new dcei_engine_spawn_wave_proto.SpawnWave.WithParent(dcei_engine_spawn_wave_proto.SpawnWave.default, this._parent.value) : dcei_engine_spawn_wave_proto.SpawnWave.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new DataFile_SpawnWavesEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
DataFile_SpawnWavesEntry_WithParent.default = new DataFile_SpawnWavesEntry_WithParent(DataFile_SpawnWavesEntry.default, null);
DataFile_SpawnWavesEntry.WithParent = DataFile_SpawnWavesEntry_WithParent;
class DataFile_SpawnWavesEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: dcei_engine_spawn_wave_proto.SpawnWave,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
DataFile_SpawnWavesEntry.descriptor = new DataFile_SpawnWavesEntry_Descriptor();
class DataFile_SpawnPatternGroupsEntry {
  get descriptor() {
    return DataFile_SpawnPatternGroupsEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataFile_SpawnPatternGroupsEntry) {
      return value;
    }
    return DataFile_SpawnPatternGroupsEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataFile_SpawnPatternGroupsEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = dcei_engine_spawn_pattern_proto.SpawnGroup.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = dcei_engine_spawn_pattern_proto.SpawnGroup.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_engine_spawn_pattern_proto.SpawnGroup}
   */
  get value() {
    return this._hasValue ? this._value : dcei_engine_spawn_pattern_proto.SpawnGroup.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_SpawnPatternGroupsEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new DataFile_SpawnPatternGroupsEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_SpawnPatternGroupsEntry(this);
              copy._hasValue = true;
              copy._value = dcei_engine_spawn_pattern_proto.SpawnGroup.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new DataFile_SpawnPatternGroupsEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new DataFile_SpawnPatternGroupsEntry(this);
            copy._hasValue = true;
            copy._value = dcei_engine_spawn_pattern_proto.SpawnGroup.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new DataFile_SpawnPatternGroupsEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataFile_SpawnPatternGroupsEntry} other
   * @returns {DataFile_SpawnPatternGroupsEntry}
   */
  merge(other) {
    const copy = new DataFile_SpawnPatternGroupsEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
DataFile_SpawnPatternGroupsEntry.default = new DataFile_SpawnPatternGroupsEntry();
class DataFile_SpawnPatternGroupsEntry_Builder {
  constructor(value) {
    this._value = new DataFile_SpawnPatternGroupsEntry(value);
  }
  build() {
    return new DataFile_SpawnPatternGroupsEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
DataFile_SpawnPatternGroupsEntry.Builder = DataFile_SpawnPatternGroupsEntry_Builder;
class DataFile_SpawnPatternGroupsEntry_WithParent {
  /**
   * @param {DataFile_SpawnPatternGroupsEntry} value
   * @param {DataFile_SpawnPatternGroupsEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataFile_SpawnPatternGroupsEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new dcei_engine_spawn_pattern_proto.SpawnGroup.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new dcei_engine_spawn_pattern_proto.SpawnGroup.WithParent(dcei_engine_spawn_pattern_proto.SpawnGroup.default, this._parent.value) : dcei_engine_spawn_pattern_proto.SpawnGroup.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new DataFile_SpawnPatternGroupsEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
DataFile_SpawnPatternGroupsEntry_WithParent.default = new DataFile_SpawnPatternGroupsEntry_WithParent(DataFile_SpawnPatternGroupsEntry.default, null);
DataFile_SpawnPatternGroupsEntry.WithParent = DataFile_SpawnPatternGroupsEntry_WithParent;
class DataFile_SpawnPatternGroupsEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: dcei_engine_spawn_pattern_proto.SpawnGroup,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
DataFile_SpawnPatternGroupsEntry.descriptor = new DataFile_SpawnPatternGroupsEntry_Descriptor();
class DataFile_TriggersEntry {
  get descriptor() {
    return DataFile_TriggersEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataFile_TriggersEntry) {
      return value;
    }
    return DataFile_TriggersEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataFile_TriggersEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = dcei_engine_trigger_proto.Trigger.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = dcei_engine_trigger_proto.Trigger.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_engine_trigger_proto.Trigger}
   */
  get value() {
    return this._hasValue ? this._value : dcei_engine_trigger_proto.Trigger.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_TriggersEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new DataFile_TriggersEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_TriggersEntry(this);
              copy._hasValue = true;
              copy._value = dcei_engine_trigger_proto.Trigger.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new DataFile_TriggersEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new DataFile_TriggersEntry(this);
            copy._hasValue = true;
            copy._value = dcei_engine_trigger_proto.Trigger.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new DataFile_TriggersEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataFile_TriggersEntry} other
   * @returns {DataFile_TriggersEntry}
   */
  merge(other) {
    const copy = new DataFile_TriggersEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
DataFile_TriggersEntry.default = new DataFile_TriggersEntry();
class DataFile_TriggersEntry_Builder {
  constructor(value) {
    this._value = new DataFile_TriggersEntry(value);
  }
  build() {
    return new DataFile_TriggersEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
DataFile_TriggersEntry.Builder = DataFile_TriggersEntry_Builder;
class DataFile_TriggersEntry_WithParent {
  /**
   * @param {DataFile_TriggersEntry} value
   * @param {DataFile_TriggersEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataFile_TriggersEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new dcei_engine_trigger_proto.Trigger.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new dcei_engine_trigger_proto.Trigger.WithParent(dcei_engine_trigger_proto.Trigger.default, this._parent.value) : dcei_engine_trigger_proto.Trigger.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new DataFile_TriggersEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
DataFile_TriggersEntry_WithParent.default = new DataFile_TriggersEntry_WithParent(DataFile_TriggersEntry.default, null);
DataFile_TriggersEntry.WithParent = DataFile_TriggersEntry_WithParent;
class DataFile_TriggersEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: dcei_engine_trigger_proto.Trigger,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
DataFile_TriggersEntry.descriptor = new DataFile_TriggersEntry_Descriptor();
class DataFile_TriggerGlobalVariablesEntry {
  get descriptor() {
    return DataFile_TriggerGlobalVariablesEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataFile_TriggerGlobalVariablesEntry) {
      return value;
    }
    return DataFile_TriggerGlobalVariablesEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataFile_TriggerGlobalVariablesEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = dcei_engine_trigger_proto.VariableDefinition.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = dcei_engine_trigger_proto.VariableDefinition.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_engine_trigger_proto.VariableDefinition}
   */
  get value() {
    return this._hasValue ? this._value : dcei_engine_trigger_proto.VariableDefinition.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_TriggerGlobalVariablesEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new DataFile_TriggerGlobalVariablesEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_TriggerGlobalVariablesEntry(this);
              copy._hasValue = true;
              copy._value = dcei_engine_trigger_proto.VariableDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new DataFile_TriggerGlobalVariablesEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new DataFile_TriggerGlobalVariablesEntry(this);
            copy._hasValue = true;
            copy._value = dcei_engine_trigger_proto.VariableDefinition.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new DataFile_TriggerGlobalVariablesEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataFile_TriggerGlobalVariablesEntry} other
   * @returns {DataFile_TriggerGlobalVariablesEntry}
   */
  merge(other) {
    const copy = new DataFile_TriggerGlobalVariablesEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
DataFile_TriggerGlobalVariablesEntry.default = new DataFile_TriggerGlobalVariablesEntry();
class DataFile_TriggerGlobalVariablesEntry_Builder {
  constructor(value) {
    this._value = new DataFile_TriggerGlobalVariablesEntry(value);
  }
  build() {
    return new DataFile_TriggerGlobalVariablesEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
DataFile_TriggerGlobalVariablesEntry.Builder = DataFile_TriggerGlobalVariablesEntry_Builder;
class DataFile_TriggerGlobalVariablesEntry_WithParent {
  /**
   * @param {DataFile_TriggerGlobalVariablesEntry} value
   * @param {DataFile_TriggerGlobalVariablesEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataFile_TriggerGlobalVariablesEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new dcei_engine_trigger_proto.VariableDefinition.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new dcei_engine_trigger_proto.VariableDefinition.WithParent(dcei_engine_trigger_proto.VariableDefinition.default, this._parent.value) : dcei_engine_trigger_proto.VariableDefinition.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new DataFile_TriggerGlobalVariablesEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
DataFile_TriggerGlobalVariablesEntry_WithParent.default = new DataFile_TriggerGlobalVariablesEntry_WithParent(DataFile_TriggerGlobalVariablesEntry.default, null);
DataFile_TriggerGlobalVariablesEntry.WithParent = DataFile_TriggerGlobalVariablesEntry_WithParent;
class DataFile_TriggerGlobalVariablesEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: dcei_engine_trigger_proto.VariableDefinition,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
DataFile_TriggerGlobalVariablesEntry.descriptor = new DataFile_TriggerGlobalVariablesEntry_Descriptor();
class DataFile_TriggerCustomFunctionsEntry {
  get descriptor() {
    return DataFile_TriggerCustomFunctionsEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataFile_TriggerCustomFunctionsEntry) {
      return value;
    }
    return DataFile_TriggerCustomFunctionsEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataFile_TriggerCustomFunctionsEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = dcei_engine_trigger_proto.CustomFunctionDefinition.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = dcei_engine_trigger_proto.CustomFunctionDefinition.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_engine_trigger_proto.CustomFunctionDefinition}
   */
  get value() {
    return this._hasValue ? this._value : dcei_engine_trigger_proto.CustomFunctionDefinition.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_TriggerCustomFunctionsEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new DataFile_TriggerCustomFunctionsEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_TriggerCustomFunctionsEntry(this);
              copy._hasValue = true;
              copy._value = dcei_engine_trigger_proto.CustomFunctionDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new DataFile_TriggerCustomFunctionsEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new DataFile_TriggerCustomFunctionsEntry(this);
            copy._hasValue = true;
            copy._value = dcei_engine_trigger_proto.CustomFunctionDefinition.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new DataFile_TriggerCustomFunctionsEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataFile_TriggerCustomFunctionsEntry} other
   * @returns {DataFile_TriggerCustomFunctionsEntry}
   */
  merge(other) {
    const copy = new DataFile_TriggerCustomFunctionsEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
DataFile_TriggerCustomFunctionsEntry.default = new DataFile_TriggerCustomFunctionsEntry();
class DataFile_TriggerCustomFunctionsEntry_Builder {
  constructor(value) {
    this._value = new DataFile_TriggerCustomFunctionsEntry(value);
  }
  build() {
    return new DataFile_TriggerCustomFunctionsEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
DataFile_TriggerCustomFunctionsEntry.Builder = DataFile_TriggerCustomFunctionsEntry_Builder;
class DataFile_TriggerCustomFunctionsEntry_WithParent {
  /**
   * @param {DataFile_TriggerCustomFunctionsEntry} value
   * @param {DataFile_TriggerCustomFunctionsEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataFile_TriggerCustomFunctionsEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new dcei_engine_trigger_proto.CustomFunctionDefinition.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new dcei_engine_trigger_proto.CustomFunctionDefinition.WithParent(dcei_engine_trigger_proto.CustomFunctionDefinition.default, this._parent.value) : dcei_engine_trigger_proto.CustomFunctionDefinition.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new DataFile_TriggerCustomFunctionsEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
DataFile_TriggerCustomFunctionsEntry_WithParent.default = new DataFile_TriggerCustomFunctionsEntry_WithParent(DataFile_TriggerCustomFunctionsEntry.default, null);
DataFile_TriggerCustomFunctionsEntry.WithParent = DataFile_TriggerCustomFunctionsEntry_WithParent;
class DataFile_TriggerCustomFunctionsEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: dcei_engine_trigger_proto.CustomFunctionDefinition,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
DataFile_TriggerCustomFunctionsEntry.descriptor = new DataFile_TriggerCustomFunctionsEntry_Descriptor();
class DataFile_TriggerCustomTypesEntry {
  get descriptor() {
    return DataFile_TriggerCustomTypesEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataFile_TriggerCustomTypesEntry) {
      return value;
    }
    return DataFile_TriggerCustomTypesEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataFile_TriggerCustomTypesEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = dcei_engine_trigger_proto.CompositeTypeDefinition.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = dcei_engine_trigger_proto.CompositeTypeDefinition.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_engine_trigger_proto.CompositeTypeDefinition}
   */
  get value() {
    return this._hasValue ? this._value : dcei_engine_trigger_proto.CompositeTypeDefinition.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_TriggerCustomTypesEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new DataFile_TriggerCustomTypesEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_TriggerCustomTypesEntry(this);
              copy._hasValue = true;
              copy._value = dcei_engine_trigger_proto.CompositeTypeDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new DataFile_TriggerCustomTypesEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new DataFile_TriggerCustomTypesEntry(this);
            copy._hasValue = true;
            copy._value = dcei_engine_trigger_proto.CompositeTypeDefinition.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new DataFile_TriggerCustomTypesEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataFile_TriggerCustomTypesEntry} other
   * @returns {DataFile_TriggerCustomTypesEntry}
   */
  merge(other) {
    const copy = new DataFile_TriggerCustomTypesEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
DataFile_TriggerCustomTypesEntry.default = new DataFile_TriggerCustomTypesEntry();
class DataFile_TriggerCustomTypesEntry_Builder {
  constructor(value) {
    this._value = new DataFile_TriggerCustomTypesEntry(value);
  }
  build() {
    return new DataFile_TriggerCustomTypesEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
DataFile_TriggerCustomTypesEntry.Builder = DataFile_TriggerCustomTypesEntry_Builder;
class DataFile_TriggerCustomTypesEntry_WithParent {
  /**
   * @param {DataFile_TriggerCustomTypesEntry} value
   * @param {DataFile_TriggerCustomTypesEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataFile_TriggerCustomTypesEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new dcei_engine_trigger_proto.CompositeTypeDefinition.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new dcei_engine_trigger_proto.CompositeTypeDefinition.WithParent(dcei_engine_trigger_proto.CompositeTypeDefinition.default, this._parent.value) : dcei_engine_trigger_proto.CompositeTypeDefinition.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new DataFile_TriggerCustomTypesEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
DataFile_TriggerCustomTypesEntry_WithParent.default = new DataFile_TriggerCustomTypesEntry_WithParent(DataFile_TriggerCustomTypesEntry.default, null);
DataFile_TriggerCustomTypesEntry.WithParent = DataFile_TriggerCustomTypesEntry_WithParent;
class DataFile_TriggerCustomTypesEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: dcei_engine_trigger_proto.CompositeTypeDefinition,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
DataFile_TriggerCustomTypesEntry.descriptor = new DataFile_TriggerCustomTypesEntry_Descriptor();
class DataFile_LocalizationEntriesEntry {
  get descriptor() {
    return DataFile_LocalizationEntriesEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataFile_LocalizationEntriesEntry) {
      return value;
    }
    return DataFile_LocalizationEntriesEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataFile_LocalizationEntriesEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = dcei_engine_localization_proto.LocalizationEntry.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = dcei_engine_localization_proto.LocalizationEntry.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_engine_localization_proto.LocalizationEntry}
   */
  get value() {
    return this._hasValue ? this._value : dcei_engine_localization_proto.LocalizationEntry.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_LocalizationEntriesEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new DataFile_LocalizationEntriesEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_LocalizationEntriesEntry(this);
              copy._hasValue = true;
              copy._value = dcei_engine_localization_proto.LocalizationEntry.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new DataFile_LocalizationEntriesEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new DataFile_LocalizationEntriesEntry(this);
            copy._hasValue = true;
            copy._value = dcei_engine_localization_proto.LocalizationEntry.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new DataFile_LocalizationEntriesEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataFile_LocalizationEntriesEntry} other
   * @returns {DataFile_LocalizationEntriesEntry}
   */
  merge(other) {
    const copy = new DataFile_LocalizationEntriesEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
DataFile_LocalizationEntriesEntry.default = new DataFile_LocalizationEntriesEntry();
class DataFile_LocalizationEntriesEntry_Builder {
  constructor(value) {
    this._value = new DataFile_LocalizationEntriesEntry(value);
  }
  build() {
    return new DataFile_LocalizationEntriesEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
DataFile_LocalizationEntriesEntry.Builder = DataFile_LocalizationEntriesEntry_Builder;
class DataFile_LocalizationEntriesEntry_WithParent {
  /**
   * @param {DataFile_LocalizationEntriesEntry} value
   * @param {DataFile_LocalizationEntriesEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataFile_LocalizationEntriesEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new dcei_engine_localization_proto.LocalizationEntry.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new dcei_engine_localization_proto.LocalizationEntry.WithParent(dcei_engine_localization_proto.LocalizationEntry.default, this._parent.value) : dcei_engine_localization_proto.LocalizationEntry.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new DataFile_LocalizationEntriesEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
DataFile_LocalizationEntriesEntry_WithParent.default = new DataFile_LocalizationEntriesEntry_WithParent(DataFile_LocalizationEntriesEntry.default, null);
DataFile_LocalizationEntriesEntry.WithParent = DataFile_LocalizationEntriesEntry_WithParent;
class DataFile_LocalizationEntriesEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: dcei_engine_localization_proto.LocalizationEntry,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
DataFile_LocalizationEntriesEntry.descriptor = new DataFile_LocalizationEntriesEntry_Descriptor();
class DataFile_UserDataTypesEntry {
  get descriptor() {
    return DataFile_UserDataTypesEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataFile_UserDataTypesEntry) {
      return value;
    }
    return DataFile_UserDataTypesEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataFile_UserDataTypesEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = dcei_engine_user_data_proto.UserDataObjectType.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = dcei_engine_user_data_proto.UserDataObjectType.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_engine_user_data_proto.UserDataObjectType}
   */
  get value() {
    return this._hasValue ? this._value : dcei_engine_user_data_proto.UserDataObjectType.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_UserDataTypesEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new DataFile_UserDataTypesEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_UserDataTypesEntry(this);
              copy._hasValue = true;
              copy._value = dcei_engine_user_data_proto.UserDataObjectType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new DataFile_UserDataTypesEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new DataFile_UserDataTypesEntry(this);
            copy._hasValue = true;
            copy._value = dcei_engine_user_data_proto.UserDataObjectType.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new DataFile_UserDataTypesEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataFile_UserDataTypesEntry} other
   * @returns {DataFile_UserDataTypesEntry}
   */
  merge(other) {
    const copy = new DataFile_UserDataTypesEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
DataFile_UserDataTypesEntry.default = new DataFile_UserDataTypesEntry();
class DataFile_UserDataTypesEntry_Builder {
  constructor(value) {
    this._value = new DataFile_UserDataTypesEntry(value);
  }
  build() {
    return new DataFile_UserDataTypesEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
DataFile_UserDataTypesEntry.Builder = DataFile_UserDataTypesEntry_Builder;
class DataFile_UserDataTypesEntry_WithParent {
  /**
   * @param {DataFile_UserDataTypesEntry} value
   * @param {DataFile_UserDataTypesEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataFile_UserDataTypesEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new dcei_engine_user_data_proto.UserDataObjectType.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new dcei_engine_user_data_proto.UserDataObjectType.WithParent(dcei_engine_user_data_proto.UserDataObjectType.default, this._parent.value) : dcei_engine_user_data_proto.UserDataObjectType.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new DataFile_UserDataTypesEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
DataFile_UserDataTypesEntry_WithParent.default = new DataFile_UserDataTypesEntry_WithParent(DataFile_UserDataTypesEntry.default, null);
DataFile_UserDataTypesEntry.WithParent = DataFile_UserDataTypesEntry_WithParent;
class DataFile_UserDataTypesEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: dcei_engine_user_data_proto.UserDataObjectType,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
DataFile_UserDataTypesEntry.descriptor = new DataFile_UserDataTypesEntry_Descriptor();
class DataFile_UserDataValuesEntry {
  get descriptor() {
    return DataFile_UserDataValuesEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataFile_UserDataValuesEntry) {
      return value;
    }
    return DataFile_UserDataValuesEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataFile_UserDataValuesEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = dcei_engine_user_data_proto.UserDataValue.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = dcei_engine_user_data_proto.UserDataValue.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_engine_user_data_proto.UserDataValue}
   */
  get value() {
    return this._hasValue ? this._value : dcei_engine_user_data_proto.UserDataValue.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_UserDataValuesEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new DataFile_UserDataValuesEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile_UserDataValuesEntry(this);
              copy._hasValue = true;
              copy._value = dcei_engine_user_data_proto.UserDataValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new DataFile_UserDataValuesEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new DataFile_UserDataValuesEntry(this);
            copy._hasValue = true;
            copy._value = dcei_engine_user_data_proto.UserDataValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new DataFile_UserDataValuesEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataFile_UserDataValuesEntry} other
   * @returns {DataFile_UserDataValuesEntry}
   */
  merge(other) {
    const copy = new DataFile_UserDataValuesEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
DataFile_UserDataValuesEntry.default = new DataFile_UserDataValuesEntry();
class DataFile_UserDataValuesEntry_Builder {
  constructor(value) {
    this._value = new DataFile_UserDataValuesEntry(value);
  }
  build() {
    return new DataFile_UserDataValuesEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
DataFile_UserDataValuesEntry.Builder = DataFile_UserDataValuesEntry_Builder;
class DataFile_UserDataValuesEntry_WithParent {
  /**
   * @param {DataFile_UserDataValuesEntry} value
   * @param {DataFile_UserDataValuesEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataFile_UserDataValuesEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new dcei_engine_user_data_proto.UserDataValue.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new dcei_engine_user_data_proto.UserDataValue.WithParent(dcei_engine_user_data_proto.UserDataValue.default, this._parent.value) : dcei_engine_user_data_proto.UserDataValue.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new DataFile_UserDataValuesEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
DataFile_UserDataValuesEntry_WithParent.default = new DataFile_UserDataValuesEntry_WithParent(DataFile_UserDataValuesEntry.default, null);
DataFile_UserDataValuesEntry.WithParent = DataFile_UserDataValuesEntry_WithParent;
class DataFile_UserDataValuesEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: dcei_engine_user_data_proto.UserDataValue,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
DataFile_UserDataValuesEntry.descriptor = new DataFile_UserDataValuesEntry_Descriptor();
export class DataFile {
  get descriptor() {
    return DataFile.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._units = {};
    this._weapons = {};
    this._abilities = {};
    this._effects = {};
    this._behaviors = {};
    this._upgrades = {};
    this._movers = {};
    this._validators = {};
    this._expressions = {};
    this._dataUpgrades = {};
    this._actors = {};
    this._actorEventMacros = {};
    this._spawnPatterns = {};
    this._spawnWaves = {};
    this._spawnPatternGroups = {};
    this._triggers = {};
    this._triggerGlobalVariables = {};
    this._triggerCustomFunctions = {};
    this._triggerCustomTypes = {};
    this._localizationEntries = {};
    this._userDataTypes = {};
    this._userDataValues = {};
    this._hasSettings = false;
    this._settings = null;
    this._hasPlayerSettings = false;
    this._playerSettings = null;
    this._hasDisplaySettings = false;
    this._displaySettings = null;
    this._hasInputSettings = false;
    this._inputSettings = null;
    this._hasGraphicsSettings = false;
    this._graphicsSettings = null;
    this._hasCameraSettings = false;
    this._cameraSettings = null;
    this._hasMusicSettings = false;
    this._musicSettings = null;
    this._hasWeatherSettings = false;
    this._weatherSettings = null;
    this._hasTriggerSettings = false;
    this._triggerSettings = null;
    this._hasFontSettings = false;
    this._fontSettings = null;
    this._hasIngameSettings = false;
    this._ingameSettings = null;
    this._hasCustomAssetSettings = false;
    this._customAssetSettings = null;
  }
  isEmpty() {
    if (Object.keys(this._units).length > 0) return false;
    if (Object.keys(this._weapons).length > 0) return false;
    if (Object.keys(this._abilities).length > 0) return false;
    if (Object.keys(this._effects).length > 0) return false;
    if (Object.keys(this._behaviors).length > 0) return false;
    if (Object.keys(this._upgrades).length > 0) return false;
    if (Object.keys(this._movers).length > 0) return false;
    if (Object.keys(this._validators).length > 0) return false;
    if (Object.keys(this._expressions).length > 0) return false;
    if (Object.keys(this._dataUpgrades).length > 0) return false;
    if (Object.keys(this._actors).length > 0) return false;
    if (Object.keys(this._actorEventMacros).length > 0) return false;
    if (Object.keys(this._spawnPatterns).length > 0) return false;
    if (Object.keys(this._spawnWaves).length > 0) return false;
    if (Object.keys(this._spawnPatternGroups).length > 0) return false;
    if (Object.keys(this._triggers).length > 0) return false;
    if (Object.keys(this._triggerGlobalVariables).length > 0) return false;
    if (Object.keys(this._triggerCustomFunctions).length > 0) return false;
    if (Object.keys(this._triggerCustomTypes).length > 0) return false;
    if (Object.keys(this._localizationEntries).length > 0) return false;
    if (Object.keys(this._userDataTypes).length > 0) return false;
    if (Object.keys(this._userDataValues).length > 0) return false;
    if (this._hasSettings && !this._settings.isEmpty()) return false;
    if (this._hasPlayerSettings && !this._playerSettings.isEmpty()) return false;
    if (this._hasDisplaySettings && !this._displaySettings.isEmpty()) return false;
    if (this._hasInputSettings && !this._inputSettings.isEmpty()) return false;
    if (this._hasGraphicsSettings && !this._graphicsSettings.isEmpty()) return false;
    if (this._hasCameraSettings && !this._cameraSettings.isEmpty()) return false;
    if (this._hasMusicSettings && !this._musicSettings.isEmpty()) return false;
    if (this._hasWeatherSettings && !this._weatherSettings.isEmpty()) return false;
    if (this._hasTriggerSettings && !this._triggerSettings.isEmpty()) return false;
    if (this._hasFontSettings && !this._fontSettings.isEmpty()) return false;
    if (this._hasIngameSettings && !this._ingameSettings.isEmpty()) return false;
    if (this._hasCustomAssetSettings && !this._customAssetSettings.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataFile) {
      return value;
    }
    return DataFile.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataFile();
    result._units = JsonToMap(json.units, JsonToString, dcei_engine_unit_proto.Unit);
    result._weapons = JsonToMap(json.weapons, JsonToString, dcei_engine_weapon_proto.Weapon);
    result._abilities = JsonToMap(json.abilities, JsonToString, dcei_engine_ability_proto.Ability);
    result._effects = JsonToMap(json.effects, JsonToString, dcei_engine_effect_proto.Effect);
    result._behaviors = JsonToMap(json.behaviors, JsonToString, dcei_engine_behavior_proto.Behavior);
    result._upgrades = JsonToMap(json.upgrades, JsonToString, dcei_engine_upgrade_proto.Upgrade);
    result._movers = JsonToMap(json.movers, JsonToString, dcei_engine_mover_proto.Mover);
    result._validators = JsonToMap(json.validators, JsonToString, dcei_engine_validator_proto.Validator);
    result._expressions = JsonToMap(json.expressions, JsonToString, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    result._dataUpgrades = JsonToMap(json.dataUpgrades, JsonToString, dcei_engine_upgrade_proto.DataUpgrade);
    result._actors = JsonToMap(json.actors, JsonToString, dcei_engine_actor_proto.Actor);
    result._actorEventMacros = JsonToMap(json.actorEventMacros, JsonToString, dcei_engine_actor_proto.ActorEventMacro);
    result._spawnPatterns = JsonToMap(json.spawnPatterns, JsonToString, dcei_engine_spawn_pattern_proto.SpawnPattern);
    result._spawnWaves = JsonToMap(json.spawnWaves, JsonToString, dcei_engine_spawn_wave_proto.SpawnWave);
    result._spawnPatternGroups = JsonToMap(json.spawnPatternGroups, JsonToString, dcei_engine_spawn_pattern_proto.SpawnGroup);
    result._triggers = JsonToMap(json.triggers, JsonToString, dcei_engine_trigger_proto.Trigger);
    result._triggerGlobalVariables = JsonToMap(json.triggerGlobalVariables, JsonToString, dcei_engine_trigger_proto.VariableDefinition);
    result._triggerCustomFunctions = JsonToMap(json.triggerCustomFunctions, JsonToString, dcei_engine_trigger_proto.CustomFunctionDefinition);
    result._triggerCustomTypes = JsonToMap(json.triggerCustomTypes, JsonToString, dcei_engine_trigger_proto.CompositeTypeDefinition);
    result._localizationEntries = JsonToMap(json.localizationEntries, JsonToString, dcei_engine_localization_proto.LocalizationEntry);
    result._userDataTypes = JsonToMap(json.userDataTypes, JsonToString, dcei_engine_user_data_proto.UserDataObjectType);
    result._userDataValues = JsonToMap(json.userDataValues, JsonToString, dcei_engine_user_data_proto.UserDataValue);
    if (json.settings != null) {
      result._hasSettings = true;
      result._settings = MapSettings.fromJson(json.settings);
    }
    if (json.playerSettings != null) {
      result._hasPlayerSettings = true;
      result._playerSettings = PlayerSettings.fromJson(json.playerSettings);
    }
    if (json.displaySettings != null) {
      result._hasDisplaySettings = true;
      result._displaySettings = DisplaySettings.fromJson(json.displaySettings);
    }
    if (json.inputSettings != null) {
      result._hasInputSettings = true;
      result._inputSettings = InputSettings.fromJson(json.inputSettings);
    }
    if (json.graphicsSettings != null) {
      result._hasGraphicsSettings = true;
      result._graphicsSettings = GraphicsSettings.fromJson(json.graphicsSettings);
    }
    if (json.cameraSettings != null) {
      result._hasCameraSettings = true;
      result._cameraSettings = dcei_engine_spawn_wave_proto.CameraSettings.fromJson(json.cameraSettings);
    }
    if (json.musicSettings != null) {
      result._hasMusicSettings = true;
      result._musicSettings = MusicSettings.fromJson(json.musicSettings);
    }
    if (json.weatherSettings != null) {
      result._hasWeatherSettings = true;
      result._weatherSettings = WeatherSettings.fromJson(json.weatherSettings);
    }
    if (json.triggerSettings != null) {
      result._hasTriggerSettings = true;
      result._triggerSettings = TriggerSettings.fromJson(json.triggerSettings);
    }
    if (json.fontSettings != null) {
      result._hasFontSettings = true;
      result._fontSettings = FontSettings.fromJson(json.fontSettings);
    }
    if (json.ingameSettings != null) {
      result._hasIngameSettings = true;
      result._ingameSettings = InGameSettings.fromJson(json.ingameSettings);
    }
    if (json.customAssetSettings != null) {
      result._hasCustomAssetSettings = true;
      result._customAssetSettings = CustomAssetSettings.fromJson(json.customAssetSettings);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (Object.keys(this._units).length > 0) {
      result.units = MapToJson(this._units, JsonToString, dcei_engine_unit_proto.Unit);
    }
    if (Object.keys(this._weapons).length > 0) {
      result.weapons = MapToJson(this._weapons, JsonToString, dcei_engine_weapon_proto.Weapon);
    }
    if (Object.keys(this._abilities).length > 0) {
      result.abilities = MapToJson(this._abilities, JsonToString, dcei_engine_ability_proto.Ability);
    }
    if (Object.keys(this._effects).length > 0) {
      result.effects = MapToJson(this._effects, JsonToString, dcei_engine_effect_proto.Effect);
    }
    if (Object.keys(this._behaviors).length > 0) {
      result.behaviors = MapToJson(this._behaviors, JsonToString, dcei_engine_behavior_proto.Behavior);
    }
    if (Object.keys(this._upgrades).length > 0) {
      result.upgrades = MapToJson(this._upgrades, JsonToString, dcei_engine_upgrade_proto.Upgrade);
    }
    if (Object.keys(this._movers).length > 0) {
      result.movers = MapToJson(this._movers, JsonToString, dcei_engine_mover_proto.Mover);
    }
    if (Object.keys(this._validators).length > 0) {
      result.validators = MapToJson(this._validators, JsonToString, dcei_engine_validator_proto.Validator);
    }
    if (Object.keys(this._expressions).length > 0) {
      result.expressions = MapToJson(this._expressions, JsonToString, dcei_engine_expression_proto.ValidatorExpressions.Expression);
    }
    if (Object.keys(this._dataUpgrades).length > 0) {
      result.dataUpgrades = MapToJson(this._dataUpgrades, JsonToString, dcei_engine_upgrade_proto.DataUpgrade);
    }
    if (Object.keys(this._actors).length > 0) {
      result.actors = MapToJson(this._actors, JsonToString, dcei_engine_actor_proto.Actor);
    }
    if (Object.keys(this._actorEventMacros).length > 0) {
      result.actorEventMacros = MapToJson(this._actorEventMacros, JsonToString, dcei_engine_actor_proto.ActorEventMacro);
    }
    if (Object.keys(this._spawnPatterns).length > 0) {
      result.spawnPatterns = MapToJson(this._spawnPatterns, JsonToString, dcei_engine_spawn_pattern_proto.SpawnPattern);
    }
    if (Object.keys(this._spawnWaves).length > 0) {
      result.spawnWaves = MapToJson(this._spawnWaves, JsonToString, dcei_engine_spawn_wave_proto.SpawnWave);
    }
    if (Object.keys(this._spawnPatternGroups).length > 0) {
      result.spawnPatternGroups = MapToJson(this._spawnPatternGroups, JsonToString, dcei_engine_spawn_pattern_proto.SpawnGroup);
    }
    if (Object.keys(this._triggers).length > 0) {
      result.triggers = MapToJson(this._triggers, JsonToString, dcei_engine_trigger_proto.Trigger);
    }
    if (Object.keys(this._triggerGlobalVariables).length > 0) {
      result.triggerGlobalVariables = MapToJson(this._triggerGlobalVariables, JsonToString, dcei_engine_trigger_proto.VariableDefinition);
    }
    if (Object.keys(this._triggerCustomFunctions).length > 0) {
      result.triggerCustomFunctions = MapToJson(this._triggerCustomFunctions, JsonToString, dcei_engine_trigger_proto.CustomFunctionDefinition);
    }
    if (Object.keys(this._triggerCustomTypes).length > 0) {
      result.triggerCustomTypes = MapToJson(this._triggerCustomTypes, JsonToString, dcei_engine_trigger_proto.CompositeTypeDefinition);
    }
    if (Object.keys(this._localizationEntries).length > 0) {
      result.localizationEntries = MapToJson(this._localizationEntries, JsonToString, dcei_engine_localization_proto.LocalizationEntry);
    }
    if (Object.keys(this._userDataTypes).length > 0) {
      result.userDataTypes = MapToJson(this._userDataTypes, JsonToString, dcei_engine_user_data_proto.UserDataObjectType);
    }
    if (Object.keys(this._userDataValues).length > 0) {
      result.userDataValues = MapToJson(this._userDataValues, JsonToString, dcei_engine_user_data_proto.UserDataValue);
    }
    if (this._hasSettings && !this._settings.isEmpty()) {
      result.settings = MapSettings.toJson(this._settings);
    }
    if (this._hasPlayerSettings && !this._playerSettings.isEmpty()) {
      result.playerSettings = PlayerSettings.toJson(this._playerSettings);
    }
    if (this._hasDisplaySettings && !this._displaySettings.isEmpty()) {
      result.displaySettings = DisplaySettings.toJson(this._displaySettings);
    }
    if (this._hasInputSettings && !this._inputSettings.isEmpty()) {
      result.inputSettings = InputSettings.toJson(this._inputSettings);
    }
    if (this._hasGraphicsSettings && !this._graphicsSettings.isEmpty()) {
      result.graphicsSettings = GraphicsSettings.toJson(this._graphicsSettings);
    }
    if (this._hasCameraSettings && !this._cameraSettings.isEmpty()) {
      result.cameraSettings = dcei_engine_spawn_wave_proto.CameraSettings.toJson(this._cameraSettings);
    }
    if (this._hasMusicSettings && !this._musicSettings.isEmpty()) {
      result.musicSettings = MusicSettings.toJson(this._musicSettings);
    }
    if (this._hasWeatherSettings && !this._weatherSettings.isEmpty()) {
      result.weatherSettings = WeatherSettings.toJson(this._weatherSettings);
    }
    if (this._hasTriggerSettings && !this._triggerSettings.isEmpty()) {
      result.triggerSettings = TriggerSettings.toJson(this._triggerSettings);
    }
    if (this._hasFontSettings && !this._fontSettings.isEmpty()) {
      result.fontSettings = FontSettings.toJson(this._fontSettings);
    }
    if (this._hasIngameSettings && !this._ingameSettings.isEmpty()) {
      result.ingameSettings = InGameSettings.toJson(this._ingameSettings);
    }
    if (this._hasCustomAssetSettings && !this._customAssetSettings.isEmpty()) {
      result.customAssetSettings = CustomAssetSettings.toJson(this._customAssetSettings);
    }
    return result;
  }
  /**
   * @returns {Object<string, dcei_engine_unit_proto.Unit>}
   */
  get units() {
    return this._units;
  }
  setUnits(path, value) {
    return {type: 'SET', path: path.concat(['units']), value: MapToJson(value, JsonToString, dcei_engine_unit_proto.Unit)};
  }
  setUnitsByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['units', key]), value: value.toJson()};
  }
  deleteUnits(path) {
    return {type: 'DELETE', path: path.concat(['units'])};
  }
  deleteUnitsByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['units', key])};
  }
  /**
   * @returns {Object<string, dcei_engine_weapon_proto.Weapon>}
   */
  get weapons() {
    return this._weapons;
  }
  setWeapons(path, value) {
    return {type: 'SET', path: path.concat(['weapons']), value: MapToJson(value, JsonToString, dcei_engine_weapon_proto.Weapon)};
  }
  setWeaponsByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['weapons', key]), value: value.toJson()};
  }
  deleteWeapons(path) {
    return {type: 'DELETE', path: path.concat(['weapons'])};
  }
  deleteWeaponsByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['weapons', key])};
  }
  /**
   * @returns {Object<string, dcei_engine_ability_proto.Ability>}
   */
  get abilities() {
    return this._abilities;
  }
  setAbilities(path, value) {
    return {type: 'SET', path: path.concat(['abilities']), value: MapToJson(value, JsonToString, dcei_engine_ability_proto.Ability)};
  }
  setAbilitiesByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['abilities', key]), value: value.toJson()};
  }
  deleteAbilities(path) {
    return {type: 'DELETE', path: path.concat(['abilities'])};
  }
  deleteAbilitiesByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['abilities', key])};
  }
  /**
   * @returns {Object<string, dcei_engine_effect_proto.Effect>}
   */
  get effects() {
    return this._effects;
  }
  setEffects(path, value) {
    return {type: 'SET', path: path.concat(['effects']), value: MapToJson(value, JsonToString, dcei_engine_effect_proto.Effect)};
  }
  setEffectsByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['effects', key]), value: value.toJson()};
  }
  deleteEffects(path) {
    return {type: 'DELETE', path: path.concat(['effects'])};
  }
  deleteEffectsByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['effects', key])};
  }
  /**
   * @returns {Object<string, dcei_engine_behavior_proto.Behavior>}
   */
  get behaviors() {
    return this._behaviors;
  }
  setBehaviors(path, value) {
    return {type: 'SET', path: path.concat(['behaviors']), value: MapToJson(value, JsonToString, dcei_engine_behavior_proto.Behavior)};
  }
  setBehaviorsByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['behaviors', key]), value: value.toJson()};
  }
  deleteBehaviors(path) {
    return {type: 'DELETE', path: path.concat(['behaviors'])};
  }
  deleteBehaviorsByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['behaviors', key])};
  }
  /**
   * @returns {Object<string, dcei_engine_upgrade_proto.Upgrade>}
   */
  get upgrades() {
    return this._upgrades;
  }
  setUpgrades(path, value) {
    return {type: 'SET', path: path.concat(['upgrades']), value: MapToJson(value, JsonToString, dcei_engine_upgrade_proto.Upgrade)};
  }
  setUpgradesByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['upgrades', key]), value: value.toJson()};
  }
  deleteUpgrades(path) {
    return {type: 'DELETE', path: path.concat(['upgrades'])};
  }
  deleteUpgradesByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['upgrades', key])};
  }
  /**
   * @returns {Object<string, dcei_engine_mover_proto.Mover>}
   */
  get movers() {
    return this._movers;
  }
  setMovers(path, value) {
    return {type: 'SET', path: path.concat(['movers']), value: MapToJson(value, JsonToString, dcei_engine_mover_proto.Mover)};
  }
  setMoversByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['movers', key]), value: value.toJson()};
  }
  deleteMovers(path) {
    return {type: 'DELETE', path: path.concat(['movers'])};
  }
  deleteMoversByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['movers', key])};
  }
  /**
   * @returns {Object<string, dcei_engine_validator_proto.Validator>}
   */
  get validators() {
    return this._validators;
  }
  setValidators(path, value) {
    return {type: 'SET', path: path.concat(['validators']), value: MapToJson(value, JsonToString, dcei_engine_validator_proto.Validator)};
  }
  setValidatorsByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['validators', key]), value: value.toJson()};
  }
  deleteValidators(path) {
    return {type: 'DELETE', path: path.concat(['validators'])};
  }
  deleteValidatorsByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['validators', key])};
  }
  /**
   * @returns {Object<string, dcei_engine_expression_proto.ValidatorExpressions.Expression>}
   */
  get expressions() {
    return this._expressions;
  }
  setExpressions(path, value) {
    return {type: 'SET', path: path.concat(['expressions']), value: MapToJson(value, JsonToString, dcei_engine_expression_proto.ValidatorExpressions.Expression)};
  }
  setExpressionsByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['expressions', key]), value: value.toJson()};
  }
  deleteExpressions(path) {
    return {type: 'DELETE', path: path.concat(['expressions'])};
  }
  deleteExpressionsByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['expressions', key])};
  }
  /**
   * @returns {Object<string, dcei_engine_upgrade_proto.DataUpgrade>}
   */
  get dataUpgrades() {
    return this._dataUpgrades;
  }
  setDataUpgrades(path, value) {
    return {type: 'SET', path: path.concat(['dataUpgrades']), value: MapToJson(value, JsonToString, dcei_engine_upgrade_proto.DataUpgrade)};
  }
  setDataUpgradesByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['dataUpgrades', key]), value: value.toJson()};
  }
  deleteDataUpgrades(path) {
    return {type: 'DELETE', path: path.concat(['dataUpgrades'])};
  }
  deleteDataUpgradesByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['dataUpgrades', key])};
  }
  /**
   * @returns {Object<string, dcei_engine_actor_proto.Actor>}
   */
  get actors() {
    return this._actors;
  }
  setActors(path, value) {
    return {type: 'SET', path: path.concat(['actors']), value: MapToJson(value, JsonToString, dcei_engine_actor_proto.Actor)};
  }
  setActorsByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['actors', key]), value: value.toJson()};
  }
  deleteActors(path) {
    return {type: 'DELETE', path: path.concat(['actors'])};
  }
  deleteActorsByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['actors', key])};
  }
  /**
   * @returns {Object<string, dcei_engine_actor_proto.ActorEventMacro>}
   */
  get actorEventMacros() {
    return this._actorEventMacros;
  }
  setActorEventMacros(path, value) {
    return {type: 'SET', path: path.concat(['actorEventMacros']), value: MapToJson(value, JsonToString, dcei_engine_actor_proto.ActorEventMacro)};
  }
  setActorEventMacrosByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['actorEventMacros', key]), value: value.toJson()};
  }
  deleteActorEventMacros(path) {
    return {type: 'DELETE', path: path.concat(['actorEventMacros'])};
  }
  deleteActorEventMacrosByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['actorEventMacros', key])};
  }
  /**
   * @returns {Object<string, dcei_engine_spawn_pattern_proto.SpawnPattern>}
   */
  get spawnPatterns() {
    return this._spawnPatterns;
  }
  setSpawnPatterns(path, value) {
    return {type: 'SET', path: path.concat(['spawnPatterns']), value: MapToJson(value, JsonToString, dcei_engine_spawn_pattern_proto.SpawnPattern)};
  }
  setSpawnPatternsByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['spawnPatterns', key]), value: value.toJson()};
  }
  deleteSpawnPatterns(path) {
    return {type: 'DELETE', path: path.concat(['spawnPatterns'])};
  }
  deleteSpawnPatternsByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['spawnPatterns', key])};
  }
  /**
   * @returns {Object<string, dcei_engine_spawn_wave_proto.SpawnWave>}
   */
  get spawnWaves() {
    return this._spawnWaves;
  }
  setSpawnWaves(path, value) {
    return {type: 'SET', path: path.concat(['spawnWaves']), value: MapToJson(value, JsonToString, dcei_engine_spawn_wave_proto.SpawnWave)};
  }
  setSpawnWavesByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['spawnWaves', key]), value: value.toJson()};
  }
  deleteSpawnWaves(path) {
    return {type: 'DELETE', path: path.concat(['spawnWaves'])};
  }
  deleteSpawnWavesByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['spawnWaves', key])};
  }
  /**
   * @returns {Object<string, dcei_engine_spawn_pattern_proto.SpawnGroup>}
   */
  get spawnPatternGroups() {
    return this._spawnPatternGroups;
  }
  setSpawnPatternGroups(path, value) {
    return {type: 'SET', path: path.concat(['spawnPatternGroups']), value: MapToJson(value, JsonToString, dcei_engine_spawn_pattern_proto.SpawnGroup)};
  }
  setSpawnPatternGroupsByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['spawnPatternGroups', key]), value: value.toJson()};
  }
  deleteSpawnPatternGroups(path) {
    return {type: 'DELETE', path: path.concat(['spawnPatternGroups'])};
  }
  deleteSpawnPatternGroupsByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['spawnPatternGroups', key])};
  }
  /**
   * @returns {Object<string, dcei_engine_trigger_proto.Trigger>}
   */
  get triggers() {
    return this._triggers;
  }
  setTriggers(path, value) {
    return {type: 'SET', path: path.concat(['triggers']), value: MapToJson(value, JsonToString, dcei_engine_trigger_proto.Trigger)};
  }
  setTriggersByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['triggers', key]), value: value.toJson()};
  }
  deleteTriggers(path) {
    return {type: 'DELETE', path: path.concat(['triggers'])};
  }
  deleteTriggersByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['triggers', key])};
  }
  /**
   * @returns {Object<string, dcei_engine_trigger_proto.VariableDefinition>}
   */
  get triggerGlobalVariables() {
    return this._triggerGlobalVariables;
  }
  setTriggerGlobalVariables(path, value) {
    return {type: 'SET', path: path.concat(['triggerGlobalVariables']), value: MapToJson(value, JsonToString, dcei_engine_trigger_proto.VariableDefinition)};
  }
  setTriggerGlobalVariablesByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['triggerGlobalVariables', key]), value: value.toJson()};
  }
  deleteTriggerGlobalVariables(path) {
    return {type: 'DELETE', path: path.concat(['triggerGlobalVariables'])};
  }
  deleteTriggerGlobalVariablesByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['triggerGlobalVariables', key])};
  }
  /**
   * @returns {Object<string, dcei_engine_trigger_proto.CustomFunctionDefinition>}
   */
  get triggerCustomFunctions() {
    return this._triggerCustomFunctions;
  }
  setTriggerCustomFunctions(path, value) {
    return {type: 'SET', path: path.concat(['triggerCustomFunctions']), value: MapToJson(value, JsonToString, dcei_engine_trigger_proto.CustomFunctionDefinition)};
  }
  setTriggerCustomFunctionsByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['triggerCustomFunctions', key]), value: value.toJson()};
  }
  deleteTriggerCustomFunctions(path) {
    return {type: 'DELETE', path: path.concat(['triggerCustomFunctions'])};
  }
  deleteTriggerCustomFunctionsByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['triggerCustomFunctions', key])};
  }
  /**
   * @returns {Object<string, dcei_engine_trigger_proto.CompositeTypeDefinition>}
   */
  get triggerCustomTypes() {
    return this._triggerCustomTypes;
  }
  setTriggerCustomTypes(path, value) {
    return {type: 'SET', path: path.concat(['triggerCustomTypes']), value: MapToJson(value, JsonToString, dcei_engine_trigger_proto.CompositeTypeDefinition)};
  }
  setTriggerCustomTypesByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['triggerCustomTypes', key]), value: value.toJson()};
  }
  deleteTriggerCustomTypes(path) {
    return {type: 'DELETE', path: path.concat(['triggerCustomTypes'])};
  }
  deleteTriggerCustomTypesByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['triggerCustomTypes', key])};
  }
  /**
   * @returns {Object<string, dcei_engine_localization_proto.LocalizationEntry>}
   */
  get localizationEntries() {
    return this._localizationEntries;
  }
  setLocalizationEntries(path, value) {
    return {type: 'SET', path: path.concat(['localizationEntries']), value: MapToJson(value, JsonToString, dcei_engine_localization_proto.LocalizationEntry)};
  }
  setLocalizationEntriesByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['localizationEntries', key]), value: value.toJson()};
  }
  deleteLocalizationEntries(path) {
    return {type: 'DELETE', path: path.concat(['localizationEntries'])};
  }
  deleteLocalizationEntriesByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['localizationEntries', key])};
  }
  /**
   * @returns {Object<string, dcei_engine_user_data_proto.UserDataObjectType>}
   */
  get userDataTypes() {
    return this._userDataTypes;
  }
  setUserDataTypes(path, value) {
    return {type: 'SET', path: path.concat(['userDataTypes']), value: MapToJson(value, JsonToString, dcei_engine_user_data_proto.UserDataObjectType)};
  }
  setUserDataTypesByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['userDataTypes', key]), value: value.toJson()};
  }
  deleteUserDataTypes(path) {
    return {type: 'DELETE', path: path.concat(['userDataTypes'])};
  }
  deleteUserDataTypesByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['userDataTypes', key])};
  }
  /**
   * @returns {Object<string, dcei_engine_user_data_proto.UserDataValue>}
   */
  get userDataValues() {
    return this._userDataValues;
  }
  setUserDataValues(path, value) {
    return {type: 'SET', path: path.concat(['userDataValues']), value: MapToJson(value, JsonToString, dcei_engine_user_data_proto.UserDataValue)};
  }
  setUserDataValuesByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['userDataValues', key]), value: value.toJson()};
  }
  deleteUserDataValues(path) {
    return {type: 'DELETE', path: path.concat(['userDataValues'])};
  }
  deleteUserDataValuesByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['userDataValues', key])};
  }
  /**
   * @returns {MapSettings}
   */
  get settings() {
    return this._hasSettings ? this._settings : MapSettings.default;
  }
  get hasSettings() {
    return this._hasSettings;
  }
  setSettings(path, value) {
    return {type: 'SET', path: path.concat(['settings']), value: value.toJson()};
  }
  deleteSettings(path) {
    return {type: 'DELETE', path: path.concat(['settings'])};
  }
  /**
   * @returns {PlayerSettings}
   */
  get playerSettings() {
    return this._hasPlayerSettings ? this._playerSettings : PlayerSettings.default;
  }
  get hasPlayerSettings() {
    return this._hasPlayerSettings;
  }
  setPlayerSettings(path, value) {
    return {type: 'SET', path: path.concat(['playerSettings']), value: value.toJson()};
  }
  deletePlayerSettings(path) {
    return {type: 'DELETE', path: path.concat(['playerSettings'])};
  }
  /**
   * @returns {DisplaySettings}
   */
  get displaySettings() {
    return this._hasDisplaySettings ? this._displaySettings : DisplaySettings.default;
  }
  get hasDisplaySettings() {
    return this._hasDisplaySettings;
  }
  setDisplaySettings(path, value) {
    return {type: 'SET', path: path.concat(['displaySettings']), value: value.toJson()};
  }
  deleteDisplaySettings(path) {
    return {type: 'DELETE', path: path.concat(['displaySettings'])};
  }
  /**
   * @returns {InputSettings}
   */
  get inputSettings() {
    return this._hasInputSettings ? this._inputSettings : InputSettings.default;
  }
  get hasInputSettings() {
    return this._hasInputSettings;
  }
  setInputSettings(path, value) {
    return {type: 'SET', path: path.concat(['inputSettings']), value: value.toJson()};
  }
  deleteInputSettings(path) {
    return {type: 'DELETE', path: path.concat(['inputSettings'])};
  }
  /**
   * @returns {GraphicsSettings}
   */
  get graphicsSettings() {
    return this._hasGraphicsSettings ? this._graphicsSettings : GraphicsSettings.default;
  }
  get hasGraphicsSettings() {
    return this._hasGraphicsSettings;
  }
  setGraphicsSettings(path, value) {
    return {type: 'SET', path: path.concat(['graphicsSettings']), value: value.toJson()};
  }
  deleteGraphicsSettings(path) {
    return {type: 'DELETE', path: path.concat(['graphicsSettings'])};
  }
  /**
   * @returns {dcei_engine_spawn_wave_proto.CameraSettings}
   */
  get cameraSettings() {
    return this._hasCameraSettings ? this._cameraSettings : dcei_engine_spawn_wave_proto.CameraSettings.default;
  }
  get hasCameraSettings() {
    return this._hasCameraSettings;
  }
  setCameraSettings(path, value) {
    return {type: 'SET', path: path.concat(['cameraSettings']), value: value.toJson()};
  }
  deleteCameraSettings(path) {
    return {type: 'DELETE', path: path.concat(['cameraSettings'])};
  }
  /**
   * @returns {MusicSettings}
   */
  get musicSettings() {
    return this._hasMusicSettings ? this._musicSettings : MusicSettings.default;
  }
  get hasMusicSettings() {
    return this._hasMusicSettings;
  }
  setMusicSettings(path, value) {
    return {type: 'SET', path: path.concat(['musicSettings']), value: value.toJson()};
  }
  deleteMusicSettings(path) {
    return {type: 'DELETE', path: path.concat(['musicSettings'])};
  }
  /**
   * @returns {WeatherSettings}
   */
  get weatherSettings() {
    return this._hasWeatherSettings ? this._weatherSettings : WeatherSettings.default;
  }
  get hasWeatherSettings() {
    return this._hasWeatherSettings;
  }
  setWeatherSettings(path, value) {
    return {type: 'SET', path: path.concat(['weatherSettings']), value: value.toJson()};
  }
  deleteWeatherSettings(path) {
    return {type: 'DELETE', path: path.concat(['weatherSettings'])};
  }
  /**
   * @returns {TriggerSettings}
   */
  get triggerSettings() {
    return this._hasTriggerSettings ? this._triggerSettings : TriggerSettings.default;
  }
  get hasTriggerSettings() {
    return this._hasTriggerSettings;
  }
  setTriggerSettings(path, value) {
    return {type: 'SET', path: path.concat(['triggerSettings']), value: value.toJson()};
  }
  deleteTriggerSettings(path) {
    return {type: 'DELETE', path: path.concat(['triggerSettings'])};
  }
  /**
   * @returns {FontSettings}
   */
  get fontSettings() {
    return this._hasFontSettings ? this._fontSettings : FontSettings.default;
  }
  get hasFontSettings() {
    return this._hasFontSettings;
  }
  setFontSettings(path, value) {
    return {type: 'SET', path: path.concat(['fontSettings']), value: value.toJson()};
  }
  deleteFontSettings(path) {
    return {type: 'DELETE', path: path.concat(['fontSettings'])};
  }
  /**
   * @returns {InGameSettings}
   */
  get ingameSettings() {
    return this._hasIngameSettings ? this._ingameSettings : InGameSettings.default;
  }
  get hasIngameSettings() {
    return this._hasIngameSettings;
  }
  setIngameSettings(path, value) {
    return {type: 'SET', path: path.concat(['ingameSettings']), value: value.toJson()};
  }
  deleteIngameSettings(path) {
    return {type: 'DELETE', path: path.concat(['ingameSettings'])};
  }
  /**
   * @returns {CustomAssetSettings}
   */
  get customAssetSettings() {
    return this._hasCustomAssetSettings ? this._customAssetSettings : CustomAssetSettings.default;
  }
  get hasCustomAssetSettings() {
    return this._hasCustomAssetSettings;
  }
  setCustomAssetSettings(path, value) {
    return {type: 'SET', path: path.concat(['customAssetSettings']), value: value.toJson()};
  }
  deleteCustomAssetSettings(path) {
    return {type: 'DELETE', path: path.concat(['customAssetSettings'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "units": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._units).length === 0) {
                return this;
              }
              const copy = new DataFile(this);
              copy._units = {};
              return copy;
            }
            case 'SET': {
              const copy = new DataFile(this);
              copy._units = {};
              for (let key in value) {
                copy._units[key] = dcei_engine_unit_proto.Unit.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._units = {...copy._units};
              copy._units[path[1]] = dcei_engine_unit_proto.Unit.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._units[path[1]]) {
                return this;
              }
              const copy = new DataFile(this);
              copy._units = {...copy._units};
              delete copy._units[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._units[key] === undefined) {
            const copy = new DataFile(this);
            copy._units = {...copy._units};
            copy._units[key] = dcei_engine_unit_proto.Unit.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._units[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataFile(this);
          copy._units = {...copy._units};
          copy._units[key] = newValue;
          return copy;
        }
      }
      case "weapons": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._weapons).length === 0) {
                return this;
              }
              const copy = new DataFile(this);
              copy._weapons = {};
              return copy;
            }
            case 'SET': {
              const copy = new DataFile(this);
              copy._weapons = {};
              for (let key in value) {
                copy._weapons[key] = dcei_engine_weapon_proto.Weapon.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._weapons = {...copy._weapons};
              copy._weapons[path[1]] = dcei_engine_weapon_proto.Weapon.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._weapons[path[1]]) {
                return this;
              }
              const copy = new DataFile(this);
              copy._weapons = {...copy._weapons};
              delete copy._weapons[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._weapons[key] === undefined) {
            const copy = new DataFile(this);
            copy._weapons = {...copy._weapons};
            copy._weapons[key] = dcei_engine_weapon_proto.Weapon.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._weapons[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataFile(this);
          copy._weapons = {...copy._weapons};
          copy._weapons[key] = newValue;
          return copy;
        }
      }
      case "abilities": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._abilities).length === 0) {
                return this;
              }
              const copy = new DataFile(this);
              copy._abilities = {};
              return copy;
            }
            case 'SET': {
              const copy = new DataFile(this);
              copy._abilities = {};
              for (let key in value) {
                copy._abilities[key] = dcei_engine_ability_proto.Ability.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._abilities = {...copy._abilities};
              copy._abilities[path[1]] = dcei_engine_ability_proto.Ability.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._abilities[path[1]]) {
                return this;
              }
              const copy = new DataFile(this);
              copy._abilities = {...copy._abilities};
              delete copy._abilities[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._abilities[key] === undefined) {
            const copy = new DataFile(this);
            copy._abilities = {...copy._abilities};
            copy._abilities[key] = dcei_engine_ability_proto.Ability.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._abilities[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataFile(this);
          copy._abilities = {...copy._abilities};
          copy._abilities[key] = newValue;
          return copy;
        }
      }
      case "effects": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._effects).length === 0) {
                return this;
              }
              const copy = new DataFile(this);
              copy._effects = {};
              return copy;
            }
            case 'SET': {
              const copy = new DataFile(this);
              copy._effects = {};
              for (let key in value) {
                copy._effects[key] = dcei_engine_effect_proto.Effect.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._effects = {...copy._effects};
              copy._effects[path[1]] = dcei_engine_effect_proto.Effect.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._effects[path[1]]) {
                return this;
              }
              const copy = new DataFile(this);
              copy._effects = {...copy._effects};
              delete copy._effects[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._effects[key] === undefined) {
            const copy = new DataFile(this);
            copy._effects = {...copy._effects};
            copy._effects[key] = dcei_engine_effect_proto.Effect.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._effects[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataFile(this);
          copy._effects = {...copy._effects};
          copy._effects[key] = newValue;
          return copy;
        }
      }
      case "behaviors": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._behaviors).length === 0) {
                return this;
              }
              const copy = new DataFile(this);
              copy._behaviors = {};
              return copy;
            }
            case 'SET': {
              const copy = new DataFile(this);
              copy._behaviors = {};
              for (let key in value) {
                copy._behaviors[key] = dcei_engine_behavior_proto.Behavior.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._behaviors = {...copy._behaviors};
              copy._behaviors[path[1]] = dcei_engine_behavior_proto.Behavior.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._behaviors[path[1]]) {
                return this;
              }
              const copy = new DataFile(this);
              copy._behaviors = {...copy._behaviors};
              delete copy._behaviors[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._behaviors[key] === undefined) {
            const copy = new DataFile(this);
            copy._behaviors = {...copy._behaviors};
            copy._behaviors[key] = dcei_engine_behavior_proto.Behavior.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._behaviors[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataFile(this);
          copy._behaviors = {...copy._behaviors};
          copy._behaviors[key] = newValue;
          return copy;
        }
      }
      case "upgrades": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._upgrades).length === 0) {
                return this;
              }
              const copy = new DataFile(this);
              copy._upgrades = {};
              return copy;
            }
            case 'SET': {
              const copy = new DataFile(this);
              copy._upgrades = {};
              for (let key in value) {
                copy._upgrades[key] = dcei_engine_upgrade_proto.Upgrade.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._upgrades = {...copy._upgrades};
              copy._upgrades[path[1]] = dcei_engine_upgrade_proto.Upgrade.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._upgrades[path[1]]) {
                return this;
              }
              const copy = new DataFile(this);
              copy._upgrades = {...copy._upgrades};
              delete copy._upgrades[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._upgrades[key] === undefined) {
            const copy = new DataFile(this);
            copy._upgrades = {...copy._upgrades};
            copy._upgrades[key] = dcei_engine_upgrade_proto.Upgrade.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._upgrades[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataFile(this);
          copy._upgrades = {...copy._upgrades};
          copy._upgrades[key] = newValue;
          return copy;
        }
      }
      case "movers": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._movers).length === 0) {
                return this;
              }
              const copy = new DataFile(this);
              copy._movers = {};
              return copy;
            }
            case 'SET': {
              const copy = new DataFile(this);
              copy._movers = {};
              for (let key in value) {
                copy._movers[key] = dcei_engine_mover_proto.Mover.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._movers = {...copy._movers};
              copy._movers[path[1]] = dcei_engine_mover_proto.Mover.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._movers[path[1]]) {
                return this;
              }
              const copy = new DataFile(this);
              copy._movers = {...copy._movers};
              delete copy._movers[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._movers[key] === undefined) {
            const copy = new DataFile(this);
            copy._movers = {...copy._movers};
            copy._movers[key] = dcei_engine_mover_proto.Mover.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._movers[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataFile(this);
          copy._movers = {...copy._movers};
          copy._movers[key] = newValue;
          return copy;
        }
      }
      case "validators": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._validators).length === 0) {
                return this;
              }
              const copy = new DataFile(this);
              copy._validators = {};
              return copy;
            }
            case 'SET': {
              const copy = new DataFile(this);
              copy._validators = {};
              for (let key in value) {
                copy._validators[key] = dcei_engine_validator_proto.Validator.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._validators = {...copy._validators};
              copy._validators[path[1]] = dcei_engine_validator_proto.Validator.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._validators[path[1]]) {
                return this;
              }
              const copy = new DataFile(this);
              copy._validators = {...copy._validators};
              delete copy._validators[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._validators[key] === undefined) {
            const copy = new DataFile(this);
            copy._validators = {...copy._validators};
            copy._validators[key] = dcei_engine_validator_proto.Validator.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._validators[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataFile(this);
          copy._validators = {...copy._validators};
          copy._validators[key] = newValue;
          return copy;
        }
      }
      case "expressions": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._expressions).length === 0) {
                return this;
              }
              const copy = new DataFile(this);
              copy._expressions = {};
              return copy;
            }
            case 'SET': {
              const copy = new DataFile(this);
              copy._expressions = {};
              for (let key in value) {
                copy._expressions[key] = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._expressions = {...copy._expressions};
              copy._expressions[path[1]] = dcei_engine_expression_proto.ValidatorExpressions.Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._expressions[path[1]]) {
                return this;
              }
              const copy = new DataFile(this);
              copy._expressions = {...copy._expressions};
              delete copy._expressions[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._expressions[key] === undefined) {
            const copy = new DataFile(this);
            copy._expressions = {...copy._expressions};
            copy._expressions[key] = dcei_engine_expression_proto.ValidatorExpressions.Expression.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._expressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataFile(this);
          copy._expressions = {...copy._expressions};
          copy._expressions[key] = newValue;
          return copy;
        }
      }
      case "dataUpgrades": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._dataUpgrades).length === 0) {
                return this;
              }
              const copy = new DataFile(this);
              copy._dataUpgrades = {};
              return copy;
            }
            case 'SET': {
              const copy = new DataFile(this);
              copy._dataUpgrades = {};
              for (let key in value) {
                copy._dataUpgrades[key] = dcei_engine_upgrade_proto.DataUpgrade.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._dataUpgrades = {...copy._dataUpgrades};
              copy._dataUpgrades[path[1]] = dcei_engine_upgrade_proto.DataUpgrade.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._dataUpgrades[path[1]]) {
                return this;
              }
              const copy = new DataFile(this);
              copy._dataUpgrades = {...copy._dataUpgrades};
              delete copy._dataUpgrades[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._dataUpgrades[key] === undefined) {
            const copy = new DataFile(this);
            copy._dataUpgrades = {...copy._dataUpgrades};
            copy._dataUpgrades[key] = dcei_engine_upgrade_proto.DataUpgrade.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._dataUpgrades[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataFile(this);
          copy._dataUpgrades = {...copy._dataUpgrades};
          copy._dataUpgrades[key] = newValue;
          return copy;
        }
      }
      case "actors": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._actors).length === 0) {
                return this;
              }
              const copy = new DataFile(this);
              copy._actors = {};
              return copy;
            }
            case 'SET': {
              const copy = new DataFile(this);
              copy._actors = {};
              for (let key in value) {
                copy._actors[key] = dcei_engine_actor_proto.Actor.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._actors = {...copy._actors};
              copy._actors[path[1]] = dcei_engine_actor_proto.Actor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._actors[path[1]]) {
                return this;
              }
              const copy = new DataFile(this);
              copy._actors = {...copy._actors};
              delete copy._actors[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._actors[key] === undefined) {
            const copy = new DataFile(this);
            copy._actors = {...copy._actors};
            copy._actors[key] = dcei_engine_actor_proto.Actor.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._actors[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataFile(this);
          copy._actors = {...copy._actors};
          copy._actors[key] = newValue;
          return copy;
        }
      }
      case "actorEventMacros": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._actorEventMacros).length === 0) {
                return this;
              }
              const copy = new DataFile(this);
              copy._actorEventMacros = {};
              return copy;
            }
            case 'SET': {
              const copy = new DataFile(this);
              copy._actorEventMacros = {};
              for (let key in value) {
                copy._actorEventMacros[key] = dcei_engine_actor_proto.ActorEventMacro.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._actorEventMacros = {...copy._actorEventMacros};
              copy._actorEventMacros[path[1]] = dcei_engine_actor_proto.ActorEventMacro.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._actorEventMacros[path[1]]) {
                return this;
              }
              const copy = new DataFile(this);
              copy._actorEventMacros = {...copy._actorEventMacros};
              delete copy._actorEventMacros[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._actorEventMacros[key] === undefined) {
            const copy = new DataFile(this);
            copy._actorEventMacros = {...copy._actorEventMacros};
            copy._actorEventMacros[key] = dcei_engine_actor_proto.ActorEventMacro.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._actorEventMacros[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataFile(this);
          copy._actorEventMacros = {...copy._actorEventMacros};
          copy._actorEventMacros[key] = newValue;
          return copy;
        }
      }
      case "spawnPatterns": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._spawnPatterns).length === 0) {
                return this;
              }
              const copy = new DataFile(this);
              copy._spawnPatterns = {};
              return copy;
            }
            case 'SET': {
              const copy = new DataFile(this);
              copy._spawnPatterns = {};
              for (let key in value) {
                copy._spawnPatterns[key] = dcei_engine_spawn_pattern_proto.SpawnPattern.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._spawnPatterns = {...copy._spawnPatterns};
              copy._spawnPatterns[path[1]] = dcei_engine_spawn_pattern_proto.SpawnPattern.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._spawnPatterns[path[1]]) {
                return this;
              }
              const copy = new DataFile(this);
              copy._spawnPatterns = {...copy._spawnPatterns};
              delete copy._spawnPatterns[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._spawnPatterns[key] === undefined) {
            const copy = new DataFile(this);
            copy._spawnPatterns = {...copy._spawnPatterns};
            copy._spawnPatterns[key] = dcei_engine_spawn_pattern_proto.SpawnPattern.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._spawnPatterns[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataFile(this);
          copy._spawnPatterns = {...copy._spawnPatterns};
          copy._spawnPatterns[key] = newValue;
          return copy;
        }
      }
      case "spawnWaves": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._spawnWaves).length === 0) {
                return this;
              }
              const copy = new DataFile(this);
              copy._spawnWaves = {};
              return copy;
            }
            case 'SET': {
              const copy = new DataFile(this);
              copy._spawnWaves = {};
              for (let key in value) {
                copy._spawnWaves[key] = dcei_engine_spawn_wave_proto.SpawnWave.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._spawnWaves = {...copy._spawnWaves};
              copy._spawnWaves[path[1]] = dcei_engine_spawn_wave_proto.SpawnWave.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._spawnWaves[path[1]]) {
                return this;
              }
              const copy = new DataFile(this);
              copy._spawnWaves = {...copy._spawnWaves};
              delete copy._spawnWaves[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._spawnWaves[key] === undefined) {
            const copy = new DataFile(this);
            copy._spawnWaves = {...copy._spawnWaves};
            copy._spawnWaves[key] = dcei_engine_spawn_wave_proto.SpawnWave.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._spawnWaves[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataFile(this);
          copy._spawnWaves = {...copy._spawnWaves};
          copy._spawnWaves[key] = newValue;
          return copy;
        }
      }
      case "spawnPatternGroups": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._spawnPatternGroups).length === 0) {
                return this;
              }
              const copy = new DataFile(this);
              copy._spawnPatternGroups = {};
              return copy;
            }
            case 'SET': {
              const copy = new DataFile(this);
              copy._spawnPatternGroups = {};
              for (let key in value) {
                copy._spawnPatternGroups[key] = dcei_engine_spawn_pattern_proto.SpawnGroup.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._spawnPatternGroups = {...copy._spawnPatternGroups};
              copy._spawnPatternGroups[path[1]] = dcei_engine_spawn_pattern_proto.SpawnGroup.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._spawnPatternGroups[path[1]]) {
                return this;
              }
              const copy = new DataFile(this);
              copy._spawnPatternGroups = {...copy._spawnPatternGroups};
              delete copy._spawnPatternGroups[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._spawnPatternGroups[key] === undefined) {
            const copy = new DataFile(this);
            copy._spawnPatternGroups = {...copy._spawnPatternGroups};
            copy._spawnPatternGroups[key] = dcei_engine_spawn_pattern_proto.SpawnGroup.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._spawnPatternGroups[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataFile(this);
          copy._spawnPatternGroups = {...copy._spawnPatternGroups};
          copy._spawnPatternGroups[key] = newValue;
          return copy;
        }
      }
      case "triggers": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._triggers).length === 0) {
                return this;
              }
              const copy = new DataFile(this);
              copy._triggers = {};
              return copy;
            }
            case 'SET': {
              const copy = new DataFile(this);
              copy._triggers = {};
              for (let key in value) {
                copy._triggers[key] = dcei_engine_trigger_proto.Trigger.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._triggers = {...copy._triggers};
              copy._triggers[path[1]] = dcei_engine_trigger_proto.Trigger.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._triggers[path[1]]) {
                return this;
              }
              const copy = new DataFile(this);
              copy._triggers = {...copy._triggers};
              delete copy._triggers[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._triggers[key] === undefined) {
            const copy = new DataFile(this);
            copy._triggers = {...copy._triggers};
            copy._triggers[key] = dcei_engine_trigger_proto.Trigger.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._triggers[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataFile(this);
          copy._triggers = {...copy._triggers};
          copy._triggers[key] = newValue;
          return copy;
        }
      }
      case "triggerGlobalVariables": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._triggerGlobalVariables).length === 0) {
                return this;
              }
              const copy = new DataFile(this);
              copy._triggerGlobalVariables = {};
              return copy;
            }
            case 'SET': {
              const copy = new DataFile(this);
              copy._triggerGlobalVariables = {};
              for (let key in value) {
                copy._triggerGlobalVariables[key] = dcei_engine_trigger_proto.VariableDefinition.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._triggerGlobalVariables = {...copy._triggerGlobalVariables};
              copy._triggerGlobalVariables[path[1]] = dcei_engine_trigger_proto.VariableDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._triggerGlobalVariables[path[1]]) {
                return this;
              }
              const copy = new DataFile(this);
              copy._triggerGlobalVariables = {...copy._triggerGlobalVariables};
              delete copy._triggerGlobalVariables[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._triggerGlobalVariables[key] === undefined) {
            const copy = new DataFile(this);
            copy._triggerGlobalVariables = {...copy._triggerGlobalVariables};
            copy._triggerGlobalVariables[key] = dcei_engine_trigger_proto.VariableDefinition.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._triggerGlobalVariables[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataFile(this);
          copy._triggerGlobalVariables = {...copy._triggerGlobalVariables};
          copy._triggerGlobalVariables[key] = newValue;
          return copy;
        }
      }
      case "triggerCustomFunctions": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._triggerCustomFunctions).length === 0) {
                return this;
              }
              const copy = new DataFile(this);
              copy._triggerCustomFunctions = {};
              return copy;
            }
            case 'SET': {
              const copy = new DataFile(this);
              copy._triggerCustomFunctions = {};
              for (let key in value) {
                copy._triggerCustomFunctions[key] = dcei_engine_trigger_proto.CustomFunctionDefinition.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._triggerCustomFunctions = {...copy._triggerCustomFunctions};
              copy._triggerCustomFunctions[path[1]] = dcei_engine_trigger_proto.CustomFunctionDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._triggerCustomFunctions[path[1]]) {
                return this;
              }
              const copy = new DataFile(this);
              copy._triggerCustomFunctions = {...copy._triggerCustomFunctions};
              delete copy._triggerCustomFunctions[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._triggerCustomFunctions[key] === undefined) {
            const copy = new DataFile(this);
            copy._triggerCustomFunctions = {...copy._triggerCustomFunctions};
            copy._triggerCustomFunctions[key] = dcei_engine_trigger_proto.CustomFunctionDefinition.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._triggerCustomFunctions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataFile(this);
          copy._triggerCustomFunctions = {...copy._triggerCustomFunctions};
          copy._triggerCustomFunctions[key] = newValue;
          return copy;
        }
      }
      case "triggerCustomTypes": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._triggerCustomTypes).length === 0) {
                return this;
              }
              const copy = new DataFile(this);
              copy._triggerCustomTypes = {};
              return copy;
            }
            case 'SET': {
              const copy = new DataFile(this);
              copy._triggerCustomTypes = {};
              for (let key in value) {
                copy._triggerCustomTypes[key] = dcei_engine_trigger_proto.CompositeTypeDefinition.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._triggerCustomTypes = {...copy._triggerCustomTypes};
              copy._triggerCustomTypes[path[1]] = dcei_engine_trigger_proto.CompositeTypeDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._triggerCustomTypes[path[1]]) {
                return this;
              }
              const copy = new DataFile(this);
              copy._triggerCustomTypes = {...copy._triggerCustomTypes};
              delete copy._triggerCustomTypes[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._triggerCustomTypes[key] === undefined) {
            const copy = new DataFile(this);
            copy._triggerCustomTypes = {...copy._triggerCustomTypes};
            copy._triggerCustomTypes[key] = dcei_engine_trigger_proto.CompositeTypeDefinition.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._triggerCustomTypes[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataFile(this);
          copy._triggerCustomTypes = {...copy._triggerCustomTypes};
          copy._triggerCustomTypes[key] = newValue;
          return copy;
        }
      }
      case "localizationEntries": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._localizationEntries).length === 0) {
                return this;
              }
              const copy = new DataFile(this);
              copy._localizationEntries = {};
              return copy;
            }
            case 'SET': {
              const copy = new DataFile(this);
              copy._localizationEntries = {};
              for (let key in value) {
                copy._localizationEntries[key] = dcei_engine_localization_proto.LocalizationEntry.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._localizationEntries = {...copy._localizationEntries};
              copy._localizationEntries[path[1]] = dcei_engine_localization_proto.LocalizationEntry.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._localizationEntries[path[1]]) {
                return this;
              }
              const copy = new DataFile(this);
              copy._localizationEntries = {...copy._localizationEntries};
              delete copy._localizationEntries[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._localizationEntries[key] === undefined) {
            const copy = new DataFile(this);
            copy._localizationEntries = {...copy._localizationEntries};
            copy._localizationEntries[key] = dcei_engine_localization_proto.LocalizationEntry.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._localizationEntries[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataFile(this);
          copy._localizationEntries = {...copy._localizationEntries};
          copy._localizationEntries[key] = newValue;
          return copy;
        }
      }
      case "userDataTypes": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._userDataTypes).length === 0) {
                return this;
              }
              const copy = new DataFile(this);
              copy._userDataTypes = {};
              return copy;
            }
            case 'SET': {
              const copy = new DataFile(this);
              copy._userDataTypes = {};
              for (let key in value) {
                copy._userDataTypes[key] = dcei_engine_user_data_proto.UserDataObjectType.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._userDataTypes = {...copy._userDataTypes};
              copy._userDataTypes[path[1]] = dcei_engine_user_data_proto.UserDataObjectType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._userDataTypes[path[1]]) {
                return this;
              }
              const copy = new DataFile(this);
              copy._userDataTypes = {...copy._userDataTypes};
              delete copy._userDataTypes[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._userDataTypes[key] === undefined) {
            const copy = new DataFile(this);
            copy._userDataTypes = {...copy._userDataTypes};
            copy._userDataTypes[key] = dcei_engine_user_data_proto.UserDataObjectType.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._userDataTypes[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataFile(this);
          copy._userDataTypes = {...copy._userDataTypes};
          copy._userDataTypes[key] = newValue;
          return copy;
        }
      }
      case "userDataValues": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._userDataValues).length === 0) {
                return this;
              }
              const copy = new DataFile(this);
              copy._userDataValues = {};
              return copy;
            }
            case 'SET': {
              const copy = new DataFile(this);
              copy._userDataValues = {};
              for (let key in value) {
                copy._userDataValues[key] = dcei_engine_user_data_proto.UserDataValue.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._userDataValues = {...copy._userDataValues};
              copy._userDataValues[path[1]] = dcei_engine_user_data_proto.UserDataValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._userDataValues[path[1]]) {
                return this;
              }
              const copy = new DataFile(this);
              copy._userDataValues = {...copy._userDataValues};
              delete copy._userDataValues[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._userDataValues[key] === undefined) {
            const copy = new DataFile(this);
            copy._userDataValues = {...copy._userDataValues};
            copy._userDataValues[key] = dcei_engine_user_data_proto.UserDataValue.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._userDataValues[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataFile(this);
          copy._userDataValues = {...copy._userDataValues};
          copy._userDataValues[key] = newValue;
          return copy;
        }
      }
      case "settings": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._hasSettings = true;
              copy._settings = MapSettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSettings) {
                return this;
              }
              const copy = new DataFile(this);
              copy._hasSettings = false;
              copy._settings = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasSettings) {
            const copy = new DataFile(this);
            copy._hasSettings = true;
            copy._settings = MapSettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._settings.apply(type, path.slice(1), value);
          if (newValue === this._settings) {
            return this;
          }
          const copy = new DataFile(this);
          copy._settings = copy._settings.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "playerSettings": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._hasPlayerSettings = true;
              copy._playerSettings = PlayerSettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayerSettings) {
                return this;
              }
              const copy = new DataFile(this);
              copy._hasPlayerSettings = false;
              copy._playerSettings = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPlayerSettings) {
            const copy = new DataFile(this);
            copy._hasPlayerSettings = true;
            copy._playerSettings = PlayerSettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._playerSettings.apply(type, path.slice(1), value);
          if (newValue === this._playerSettings) {
            return this;
          }
          const copy = new DataFile(this);
          copy._playerSettings = copy._playerSettings.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "displaySettings": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._hasDisplaySettings = true;
              copy._displaySettings = DisplaySettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplaySettings) {
                return this;
              }
              const copy = new DataFile(this);
              copy._hasDisplaySettings = false;
              copy._displaySettings = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasDisplaySettings) {
            const copy = new DataFile(this);
            copy._hasDisplaySettings = true;
            copy._displaySettings = DisplaySettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._displaySettings.apply(type, path.slice(1), value);
          if (newValue === this._displaySettings) {
            return this;
          }
          const copy = new DataFile(this);
          copy._displaySettings = copy._displaySettings.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "inputSettings": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._hasInputSettings = true;
              copy._inputSettings = InputSettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasInputSettings) {
                return this;
              }
              const copy = new DataFile(this);
              copy._hasInputSettings = false;
              copy._inputSettings = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasInputSettings) {
            const copy = new DataFile(this);
            copy._hasInputSettings = true;
            copy._inputSettings = InputSettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._inputSettings.apply(type, path.slice(1), value);
          if (newValue === this._inputSettings) {
            return this;
          }
          const copy = new DataFile(this);
          copy._inputSettings = copy._inputSettings.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "graphicsSettings": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._hasGraphicsSettings = true;
              copy._graphicsSettings = GraphicsSettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGraphicsSettings) {
                return this;
              }
              const copy = new DataFile(this);
              copy._hasGraphicsSettings = false;
              copy._graphicsSettings = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasGraphicsSettings) {
            const copy = new DataFile(this);
            copy._hasGraphicsSettings = true;
            copy._graphicsSettings = GraphicsSettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._graphicsSettings.apply(type, path.slice(1), value);
          if (newValue === this._graphicsSettings) {
            return this;
          }
          const copy = new DataFile(this);
          copy._graphicsSettings = copy._graphicsSettings.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "cameraSettings": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._hasCameraSettings = true;
              copy._cameraSettings = dcei_engine_spawn_wave_proto.CameraSettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCameraSettings) {
                return this;
              }
              const copy = new DataFile(this);
              copy._hasCameraSettings = false;
              copy._cameraSettings = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCameraSettings) {
            const copy = new DataFile(this);
            copy._hasCameraSettings = true;
            copy._cameraSettings = dcei_engine_spawn_wave_proto.CameraSettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._cameraSettings.apply(type, path.slice(1), value);
          if (newValue === this._cameraSettings) {
            return this;
          }
          const copy = new DataFile(this);
          copy._cameraSettings = copy._cameraSettings.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "musicSettings": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._hasMusicSettings = true;
              copy._musicSettings = MusicSettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMusicSettings) {
                return this;
              }
              const copy = new DataFile(this);
              copy._hasMusicSettings = false;
              copy._musicSettings = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasMusicSettings) {
            const copy = new DataFile(this);
            copy._hasMusicSettings = true;
            copy._musicSettings = MusicSettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._musicSettings.apply(type, path.slice(1), value);
          if (newValue === this._musicSettings) {
            return this;
          }
          const copy = new DataFile(this);
          copy._musicSettings = copy._musicSettings.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "weatherSettings": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._hasWeatherSettings = true;
              copy._weatherSettings = WeatherSettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWeatherSettings) {
                return this;
              }
              const copy = new DataFile(this);
              copy._hasWeatherSettings = false;
              copy._weatherSettings = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasWeatherSettings) {
            const copy = new DataFile(this);
            copy._hasWeatherSettings = true;
            copy._weatherSettings = WeatherSettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._weatherSettings.apply(type, path.slice(1), value);
          if (newValue === this._weatherSettings) {
            return this;
          }
          const copy = new DataFile(this);
          copy._weatherSettings = copy._weatherSettings.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "triggerSettings": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._hasTriggerSettings = true;
              copy._triggerSettings = TriggerSettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTriggerSettings) {
                return this;
              }
              const copy = new DataFile(this);
              copy._hasTriggerSettings = false;
              copy._triggerSettings = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTriggerSettings) {
            const copy = new DataFile(this);
            copy._hasTriggerSettings = true;
            copy._triggerSettings = TriggerSettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._triggerSettings.apply(type, path.slice(1), value);
          if (newValue === this._triggerSettings) {
            return this;
          }
          const copy = new DataFile(this);
          copy._triggerSettings = copy._triggerSettings.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "fontSettings": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._hasFontSettings = true;
              copy._fontSettings = FontSettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFontSettings) {
                return this;
              }
              const copy = new DataFile(this);
              copy._hasFontSettings = false;
              copy._fontSettings = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasFontSettings) {
            const copy = new DataFile(this);
            copy._hasFontSettings = true;
            copy._fontSettings = FontSettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._fontSettings.apply(type, path.slice(1), value);
          if (newValue === this._fontSettings) {
            return this;
          }
          const copy = new DataFile(this);
          copy._fontSettings = copy._fontSettings.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "ingameSettings": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._hasIngameSettings = true;
              copy._ingameSettings = InGameSettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIngameSettings) {
                return this;
              }
              const copy = new DataFile(this);
              copy._hasIngameSettings = false;
              copy._ingameSettings = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasIngameSettings) {
            const copy = new DataFile(this);
            copy._hasIngameSettings = true;
            copy._ingameSettings = InGameSettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._ingameSettings.apply(type, path.slice(1), value);
          if (newValue === this._ingameSettings) {
            return this;
          }
          const copy = new DataFile(this);
          copy._ingameSettings = copy._ingameSettings.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "customAssetSettings": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFile(this);
              copy._hasCustomAssetSettings = true;
              copy._customAssetSettings = CustomAssetSettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCustomAssetSettings) {
                return this;
              }
              const copy = new DataFile(this);
              copy._hasCustomAssetSettings = false;
              copy._customAssetSettings = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCustomAssetSettings) {
            const copy = new DataFile(this);
            copy._hasCustomAssetSettings = true;
            copy._customAssetSettings = CustomAssetSettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._customAssetSettings.apply(type, path.slice(1), value);
          if (newValue === this._customAssetSettings) {
            return this;
          }
          const copy = new DataFile(this);
          copy._customAssetSettings = copy._customAssetSettings.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataFile} other
   * @returns {DataFile}
   */
  merge(other) {
    const copy = new DataFile(this);
    copy._units = {...this._units, ...other._units};
    copy._weapons = {...this._weapons, ...other._weapons};
    copy._abilities = {...this._abilities, ...other._abilities};
    copy._effects = {...this._effects, ...other._effects};
    copy._behaviors = {...this._behaviors, ...other._behaviors};
    copy._upgrades = {...this._upgrades, ...other._upgrades};
    copy._movers = {...this._movers, ...other._movers};
    copy._validators = {...this._validators, ...other._validators};
    copy._expressions = {...this._expressions, ...other._expressions};
    copy._dataUpgrades = {...this._dataUpgrades, ...other._dataUpgrades};
    copy._actors = {...this._actors, ...other._actors};
    copy._actorEventMacros = {...this._actorEventMacros, ...other._actorEventMacros};
    copy._spawnPatterns = {...this._spawnPatterns, ...other._spawnPatterns};
    copy._spawnWaves = {...this._spawnWaves, ...other._spawnWaves};
    copy._spawnPatternGroups = {...this._spawnPatternGroups, ...other._spawnPatternGroups};
    copy._triggers = {...this._triggers, ...other._triggers};
    copy._triggerGlobalVariables = {...this._triggerGlobalVariables, ...other._triggerGlobalVariables};
    copy._triggerCustomFunctions = {...this._triggerCustomFunctions, ...other._triggerCustomFunctions};
    copy._triggerCustomTypes = {...this._triggerCustomTypes, ...other._triggerCustomTypes};
    copy._localizationEntries = {...this._localizationEntries, ...other._localizationEntries};
    copy._userDataTypes = {...this._userDataTypes, ...other._userDataTypes};
    copy._userDataValues = {...this._userDataValues, ...other._userDataValues};
    if (other._hasSettings) {
      if (copy._hasSettings) {
        copy._settings = copy.settings.merge(other.settings);
      } else {
        copy._settings = other._settings;
      }
      copy._hasSettings = true;
    }
    if (other._hasPlayerSettings) {
      if (copy._hasPlayerSettings) {
        copy._playerSettings = copy.playerSettings.merge(other.playerSettings);
      } else {
        copy._playerSettings = other._playerSettings;
      }
      copy._hasPlayerSettings = true;
    }
    if (other._hasDisplaySettings) {
      if (copy._hasDisplaySettings) {
        copy._displaySettings = copy.displaySettings.merge(other.displaySettings);
      } else {
        copy._displaySettings = other._displaySettings;
      }
      copy._hasDisplaySettings = true;
    }
    if (other._hasInputSettings) {
      if (copy._hasInputSettings) {
        copy._inputSettings = copy.inputSettings.merge(other.inputSettings);
      } else {
        copy._inputSettings = other._inputSettings;
      }
      copy._hasInputSettings = true;
    }
    if (other._hasGraphicsSettings) {
      if (copy._hasGraphicsSettings) {
        copy._graphicsSettings = copy.graphicsSettings.merge(other.graphicsSettings);
      } else {
        copy._graphicsSettings = other._graphicsSettings;
      }
      copy._hasGraphicsSettings = true;
    }
    if (other._hasCameraSettings) {
      if (copy._hasCameraSettings) {
        copy._cameraSettings = copy.cameraSettings.merge(other.cameraSettings);
      } else {
        copy._cameraSettings = other._cameraSettings;
      }
      copy._hasCameraSettings = true;
    }
    if (other._hasMusicSettings) {
      if (copy._hasMusicSettings) {
        copy._musicSettings = copy.musicSettings.merge(other.musicSettings);
      } else {
        copy._musicSettings = other._musicSettings;
      }
      copy._hasMusicSettings = true;
    }
    if (other._hasWeatherSettings) {
      if (copy._hasWeatherSettings) {
        copy._weatherSettings = copy.weatherSettings.merge(other.weatherSettings);
      } else {
        copy._weatherSettings = other._weatherSettings;
      }
      copy._hasWeatherSettings = true;
    }
    if (other._hasTriggerSettings) {
      if (copy._hasTriggerSettings) {
        copy._triggerSettings = copy.triggerSettings.merge(other.triggerSettings);
      } else {
        copy._triggerSettings = other._triggerSettings;
      }
      copy._hasTriggerSettings = true;
    }
    if (other._hasFontSettings) {
      if (copy._hasFontSettings) {
        copy._fontSettings = copy.fontSettings.merge(other.fontSettings);
      } else {
        copy._fontSettings = other._fontSettings;
      }
      copy._hasFontSettings = true;
    }
    if (other._hasIngameSettings) {
      if (copy._hasIngameSettings) {
        copy._ingameSettings = copy.ingameSettings.merge(other.ingameSettings);
      } else {
        copy._ingameSettings = other._ingameSettings;
      }
      copy._hasIngameSettings = true;
    }
    if (other._hasCustomAssetSettings) {
      if (copy._hasCustomAssetSettings) {
        copy._customAssetSettings = copy.customAssetSettings.merge(other.customAssetSettings);
      } else {
        copy._customAssetSettings = other._customAssetSettings;
      }
      copy._hasCustomAssetSettings = true;
    }
    return copy;
  }
}
DataFile.default = new DataFile();
DataFile.UnitsEntry = DataFile_UnitsEntry;
DataFile.WeaponsEntry = DataFile_WeaponsEntry;
DataFile.AbilitiesEntry = DataFile_AbilitiesEntry;
DataFile.EffectsEntry = DataFile_EffectsEntry;
DataFile.BehaviorsEntry = DataFile_BehaviorsEntry;
DataFile.UpgradesEntry = DataFile_UpgradesEntry;
DataFile.MoversEntry = DataFile_MoversEntry;
DataFile.ValidatorsEntry = DataFile_ValidatorsEntry;
DataFile.ExpressionsEntry = DataFile_ExpressionsEntry;
DataFile.DataUpgradesEntry = DataFile_DataUpgradesEntry;
DataFile.ActorsEntry = DataFile_ActorsEntry;
DataFile.ActorEventMacrosEntry = DataFile_ActorEventMacrosEntry;
DataFile.SpawnPatternsEntry = DataFile_SpawnPatternsEntry;
DataFile.SpawnWavesEntry = DataFile_SpawnWavesEntry;
DataFile.SpawnPatternGroupsEntry = DataFile_SpawnPatternGroupsEntry;
DataFile.TriggersEntry = DataFile_TriggersEntry;
DataFile.TriggerGlobalVariablesEntry = DataFile_TriggerGlobalVariablesEntry;
DataFile.TriggerCustomFunctionsEntry = DataFile_TriggerCustomFunctionsEntry;
DataFile.TriggerCustomTypesEntry = DataFile_TriggerCustomTypesEntry;
DataFile.LocalizationEntriesEntry = DataFile_LocalizationEntriesEntry;
DataFile.UserDataTypesEntry = DataFile_UserDataTypesEntry;
DataFile.UserDataValuesEntry = DataFile_UserDataValuesEntry;
class DataFile_Builder {
  constructor(value) {
    this._value = new DataFile(value);
  }
  build() {
    return new DataFile(this._value);
  }
  setUnits(key, value) {
    this._value._units = {...this._value._units, [key]: value};
    return this;
  }
  addAllUnits(values) {
    this._value._units = {...this._value._units, ...values};
    return this;
  }
  deleteUnits(key) {
    this._value._units = {...this._value._units};
    delete this._value._units[key];
    return this;
  }
  clearUnits() {
    this._value._units = {};
    return this;
  }
  setWeapons(key, value) {
    this._value._weapons = {...this._value._weapons, [key]: value};
    return this;
  }
  addAllWeapons(values) {
    this._value._weapons = {...this._value._weapons, ...values};
    return this;
  }
  deleteWeapons(key) {
    this._value._weapons = {...this._value._weapons};
    delete this._value._weapons[key];
    return this;
  }
  clearWeapons() {
    this._value._weapons = {};
    return this;
  }
  setAbilities(key, value) {
    this._value._abilities = {...this._value._abilities, [key]: value};
    return this;
  }
  addAllAbilities(values) {
    this._value._abilities = {...this._value._abilities, ...values};
    return this;
  }
  deleteAbilities(key) {
    this._value._abilities = {...this._value._abilities};
    delete this._value._abilities[key];
    return this;
  }
  clearAbilities() {
    this._value._abilities = {};
    return this;
  }
  setEffects(key, value) {
    this._value._effects = {...this._value._effects, [key]: value};
    return this;
  }
  addAllEffects(values) {
    this._value._effects = {...this._value._effects, ...values};
    return this;
  }
  deleteEffects(key) {
    this._value._effects = {...this._value._effects};
    delete this._value._effects[key];
    return this;
  }
  clearEffects() {
    this._value._effects = {};
    return this;
  }
  setBehaviors(key, value) {
    this._value._behaviors = {...this._value._behaviors, [key]: value};
    return this;
  }
  addAllBehaviors(values) {
    this._value._behaviors = {...this._value._behaviors, ...values};
    return this;
  }
  deleteBehaviors(key) {
    this._value._behaviors = {...this._value._behaviors};
    delete this._value._behaviors[key];
    return this;
  }
  clearBehaviors() {
    this._value._behaviors = {};
    return this;
  }
  setUpgrades(key, value) {
    this._value._upgrades = {...this._value._upgrades, [key]: value};
    return this;
  }
  addAllUpgrades(values) {
    this._value._upgrades = {...this._value._upgrades, ...values};
    return this;
  }
  deleteUpgrades(key) {
    this._value._upgrades = {...this._value._upgrades};
    delete this._value._upgrades[key];
    return this;
  }
  clearUpgrades() {
    this._value._upgrades = {};
    return this;
  }
  setMovers(key, value) {
    this._value._movers = {...this._value._movers, [key]: value};
    return this;
  }
  addAllMovers(values) {
    this._value._movers = {...this._value._movers, ...values};
    return this;
  }
  deleteMovers(key) {
    this._value._movers = {...this._value._movers};
    delete this._value._movers[key];
    return this;
  }
  clearMovers() {
    this._value._movers = {};
    return this;
  }
  setValidators(key, value) {
    this._value._validators = {...this._value._validators, [key]: value};
    return this;
  }
  addAllValidators(values) {
    this._value._validators = {...this._value._validators, ...values};
    return this;
  }
  deleteValidators(key) {
    this._value._validators = {...this._value._validators};
    delete this._value._validators[key];
    return this;
  }
  clearValidators() {
    this._value._validators = {};
    return this;
  }
  setExpressions(key, value) {
    this._value._expressions = {...this._value._expressions, [key]: value};
    return this;
  }
  addAllExpressions(values) {
    this._value._expressions = {...this._value._expressions, ...values};
    return this;
  }
  deleteExpressions(key) {
    this._value._expressions = {...this._value._expressions};
    delete this._value._expressions[key];
    return this;
  }
  clearExpressions() {
    this._value._expressions = {};
    return this;
  }
  setDataUpgrades(key, value) {
    this._value._dataUpgrades = {...this._value._dataUpgrades, [key]: value};
    return this;
  }
  addAllDataUpgrades(values) {
    this._value._dataUpgrades = {...this._value._dataUpgrades, ...values};
    return this;
  }
  deleteDataUpgrades(key) {
    this._value._dataUpgrades = {...this._value._dataUpgrades};
    delete this._value._dataUpgrades[key];
    return this;
  }
  clearDataUpgrades() {
    this._value._dataUpgrades = {};
    return this;
  }
  setActors(key, value) {
    this._value._actors = {...this._value._actors, [key]: value};
    return this;
  }
  addAllActors(values) {
    this._value._actors = {...this._value._actors, ...values};
    return this;
  }
  deleteActors(key) {
    this._value._actors = {...this._value._actors};
    delete this._value._actors[key];
    return this;
  }
  clearActors() {
    this._value._actors = {};
    return this;
  }
  setActorEventMacros(key, value) {
    this._value._actorEventMacros = {...this._value._actorEventMacros, [key]: value};
    return this;
  }
  addAllActorEventMacros(values) {
    this._value._actorEventMacros = {...this._value._actorEventMacros, ...values};
    return this;
  }
  deleteActorEventMacros(key) {
    this._value._actorEventMacros = {...this._value._actorEventMacros};
    delete this._value._actorEventMacros[key];
    return this;
  }
  clearActorEventMacros() {
    this._value._actorEventMacros = {};
    return this;
  }
  setSpawnPatterns(key, value) {
    this._value._spawnPatterns = {...this._value._spawnPatterns, [key]: value};
    return this;
  }
  addAllSpawnPatterns(values) {
    this._value._spawnPatterns = {...this._value._spawnPatterns, ...values};
    return this;
  }
  deleteSpawnPatterns(key) {
    this._value._spawnPatterns = {...this._value._spawnPatterns};
    delete this._value._spawnPatterns[key];
    return this;
  }
  clearSpawnPatterns() {
    this._value._spawnPatterns = {};
    return this;
  }
  setSpawnWaves(key, value) {
    this._value._spawnWaves = {...this._value._spawnWaves, [key]: value};
    return this;
  }
  addAllSpawnWaves(values) {
    this._value._spawnWaves = {...this._value._spawnWaves, ...values};
    return this;
  }
  deleteSpawnWaves(key) {
    this._value._spawnWaves = {...this._value._spawnWaves};
    delete this._value._spawnWaves[key];
    return this;
  }
  clearSpawnWaves() {
    this._value._spawnWaves = {};
    return this;
  }
  setSpawnPatternGroups(key, value) {
    this._value._spawnPatternGroups = {...this._value._spawnPatternGroups, [key]: value};
    return this;
  }
  addAllSpawnPatternGroups(values) {
    this._value._spawnPatternGroups = {...this._value._spawnPatternGroups, ...values};
    return this;
  }
  deleteSpawnPatternGroups(key) {
    this._value._spawnPatternGroups = {...this._value._spawnPatternGroups};
    delete this._value._spawnPatternGroups[key];
    return this;
  }
  clearSpawnPatternGroups() {
    this._value._spawnPatternGroups = {};
    return this;
  }
  setTriggers(key, value) {
    this._value._triggers = {...this._value._triggers, [key]: value};
    return this;
  }
  addAllTriggers(values) {
    this._value._triggers = {...this._value._triggers, ...values};
    return this;
  }
  deleteTriggers(key) {
    this._value._triggers = {...this._value._triggers};
    delete this._value._triggers[key];
    return this;
  }
  clearTriggers() {
    this._value._triggers = {};
    return this;
  }
  setTriggerGlobalVariables(key, value) {
    this._value._triggerGlobalVariables = {...this._value._triggerGlobalVariables, [key]: value};
    return this;
  }
  addAllTriggerGlobalVariables(values) {
    this._value._triggerGlobalVariables = {...this._value._triggerGlobalVariables, ...values};
    return this;
  }
  deleteTriggerGlobalVariables(key) {
    this._value._triggerGlobalVariables = {...this._value._triggerGlobalVariables};
    delete this._value._triggerGlobalVariables[key];
    return this;
  }
  clearTriggerGlobalVariables() {
    this._value._triggerGlobalVariables = {};
    return this;
  }
  setTriggerCustomFunctions(key, value) {
    this._value._triggerCustomFunctions = {...this._value._triggerCustomFunctions, [key]: value};
    return this;
  }
  addAllTriggerCustomFunctions(values) {
    this._value._triggerCustomFunctions = {...this._value._triggerCustomFunctions, ...values};
    return this;
  }
  deleteTriggerCustomFunctions(key) {
    this._value._triggerCustomFunctions = {...this._value._triggerCustomFunctions};
    delete this._value._triggerCustomFunctions[key];
    return this;
  }
  clearTriggerCustomFunctions() {
    this._value._triggerCustomFunctions = {};
    return this;
  }
  setTriggerCustomTypes(key, value) {
    this._value._triggerCustomTypes = {...this._value._triggerCustomTypes, [key]: value};
    return this;
  }
  addAllTriggerCustomTypes(values) {
    this._value._triggerCustomTypes = {...this._value._triggerCustomTypes, ...values};
    return this;
  }
  deleteTriggerCustomTypes(key) {
    this._value._triggerCustomTypes = {...this._value._triggerCustomTypes};
    delete this._value._triggerCustomTypes[key];
    return this;
  }
  clearTriggerCustomTypes() {
    this._value._triggerCustomTypes = {};
    return this;
  }
  setLocalizationEntries(key, value) {
    this._value._localizationEntries = {...this._value._localizationEntries, [key]: value};
    return this;
  }
  addAllLocalizationEntries(values) {
    this._value._localizationEntries = {...this._value._localizationEntries, ...values};
    return this;
  }
  deleteLocalizationEntries(key) {
    this._value._localizationEntries = {...this._value._localizationEntries};
    delete this._value._localizationEntries[key];
    return this;
  }
  clearLocalizationEntries() {
    this._value._localizationEntries = {};
    return this;
  }
  setUserDataTypes(key, value) {
    this._value._userDataTypes = {...this._value._userDataTypes, [key]: value};
    return this;
  }
  addAllUserDataTypes(values) {
    this._value._userDataTypes = {...this._value._userDataTypes, ...values};
    return this;
  }
  deleteUserDataTypes(key) {
    this._value._userDataTypes = {...this._value._userDataTypes};
    delete this._value._userDataTypes[key];
    return this;
  }
  clearUserDataTypes() {
    this._value._userDataTypes = {};
    return this;
  }
  setUserDataValues(key, value) {
    this._value._userDataValues = {...this._value._userDataValues, [key]: value};
    return this;
  }
  addAllUserDataValues(values) {
    this._value._userDataValues = {...this._value._userDataValues, ...values};
    return this;
  }
  deleteUserDataValues(key) {
    this._value._userDataValues = {...this._value._userDataValues};
    delete this._value._userDataValues[key];
    return this;
  }
  clearUserDataValues() {
    this._value._userDataValues = {};
    return this;
  }
  setSettings(value) {
    this._value._hasSettings = true;
    this._value._settings = value;
    return this;
  }
  deleteSettings() {
    this._value._hasSettings = false;
    this._value._settings = null;
    return this;
  }
  setPlayerSettings(value) {
    this._value._hasPlayerSettings = true;
    this._value._playerSettings = value;
    return this;
  }
  deletePlayerSettings() {
    this._value._hasPlayerSettings = false;
    this._value._playerSettings = null;
    return this;
  }
  setDisplaySettings(value) {
    this._value._hasDisplaySettings = true;
    this._value._displaySettings = value;
    return this;
  }
  deleteDisplaySettings() {
    this._value._hasDisplaySettings = false;
    this._value._displaySettings = null;
    return this;
  }
  setInputSettings(value) {
    this._value._hasInputSettings = true;
    this._value._inputSettings = value;
    return this;
  }
  deleteInputSettings() {
    this._value._hasInputSettings = false;
    this._value._inputSettings = null;
    return this;
  }
  setGraphicsSettings(value) {
    this._value._hasGraphicsSettings = true;
    this._value._graphicsSettings = value;
    return this;
  }
  deleteGraphicsSettings() {
    this._value._hasGraphicsSettings = false;
    this._value._graphicsSettings = null;
    return this;
  }
  setCameraSettings(value) {
    this._value._hasCameraSettings = true;
    this._value._cameraSettings = value;
    return this;
  }
  deleteCameraSettings() {
    this._value._hasCameraSettings = false;
    this._value._cameraSettings = null;
    return this;
  }
  setMusicSettings(value) {
    this._value._hasMusicSettings = true;
    this._value._musicSettings = value;
    return this;
  }
  deleteMusicSettings() {
    this._value._hasMusicSettings = false;
    this._value._musicSettings = null;
    return this;
  }
  setWeatherSettings(value) {
    this._value._hasWeatherSettings = true;
    this._value._weatherSettings = value;
    return this;
  }
  deleteWeatherSettings() {
    this._value._hasWeatherSettings = false;
    this._value._weatherSettings = null;
    return this;
  }
  setTriggerSettings(value) {
    this._value._hasTriggerSettings = true;
    this._value._triggerSettings = value;
    return this;
  }
  deleteTriggerSettings() {
    this._value._hasTriggerSettings = false;
    this._value._triggerSettings = null;
    return this;
  }
  setFontSettings(value) {
    this._value._hasFontSettings = true;
    this._value._fontSettings = value;
    return this;
  }
  deleteFontSettings() {
    this._value._hasFontSettings = false;
    this._value._fontSettings = null;
    return this;
  }
  setIngameSettings(value) {
    this._value._hasIngameSettings = true;
    this._value._ingameSettings = value;
    return this;
  }
  deleteIngameSettings() {
    this._value._hasIngameSettings = false;
    this._value._ingameSettings = null;
    return this;
  }
  setCustomAssetSettings(value) {
    this._value._hasCustomAssetSettings = true;
    this._value._customAssetSettings = value;
    return this;
  }
  deleteCustomAssetSettings() {
    this._value._hasCustomAssetSettings = false;
    this._value._customAssetSettings = null;
    return this;
  }
}
DataFile.Builder = DataFile_Builder;
class DataFile_WithParent {
  /**
   * @param {DataFile} value
   * @param {DataFile_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataFile.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfUnits() {
    if (!this._selfUnits) {
      this._selfUnits = {};
      for (let i in this._value.units) {
        this._selfUnits[i] = new dcei_engine_unit_proto.Unit.WithParent(this._value.units[i], null);
      }
    }
    return this._selfUnits;
  }
  get inherentUnits() {
    if (!this._inherentUnits) {
      this._inherentUnits = this._parent ? this._parent.units : {};
    }
    return this._inherentUnits;
  }
  get units() {
    if (!this._allUnits) {
      this._allUnits = this._parent ? {...this._parent.units, ...this.selfUnits} : this.selfUnits;
    }
    return this._allUnits;
  }
  get selfWeapons() {
    if (!this._selfWeapons) {
      this._selfWeapons = {};
      for (let i in this._value.weapons) {
        this._selfWeapons[i] = new dcei_engine_weapon_proto.Weapon.WithParent(this._value.weapons[i], null);
      }
    }
    return this._selfWeapons;
  }
  get inherentWeapons() {
    if (!this._inherentWeapons) {
      this._inherentWeapons = this._parent ? this._parent.weapons : {};
    }
    return this._inherentWeapons;
  }
  get weapons() {
    if (!this._allWeapons) {
      this._allWeapons = this._parent ? {...this._parent.weapons, ...this.selfWeapons} : this.selfWeapons;
    }
    return this._allWeapons;
  }
  get selfAbilities() {
    if (!this._selfAbilities) {
      this._selfAbilities = {};
      for (let i in this._value.abilities) {
        this._selfAbilities[i] = new dcei_engine_ability_proto.Ability.WithParent(this._value.abilities[i], null);
      }
    }
    return this._selfAbilities;
  }
  get inherentAbilities() {
    if (!this._inherentAbilities) {
      this._inherentAbilities = this._parent ? this._parent.abilities : {};
    }
    return this._inherentAbilities;
  }
  get abilities() {
    if (!this._allAbilities) {
      this._allAbilities = this._parent ? {...this._parent.abilities, ...this.selfAbilities} : this.selfAbilities;
    }
    return this._allAbilities;
  }
  get selfEffects() {
    if (!this._selfEffects) {
      this._selfEffects = {};
      for (let i in this._value.effects) {
        this._selfEffects[i] = new dcei_engine_effect_proto.Effect.WithParent(this._value.effects[i], null);
      }
    }
    return this._selfEffects;
  }
  get inherentEffects() {
    if (!this._inherentEffects) {
      this._inherentEffects = this._parent ? this._parent.effects : {};
    }
    return this._inherentEffects;
  }
  get effects() {
    if (!this._allEffects) {
      this._allEffects = this._parent ? {...this._parent.effects, ...this.selfEffects} : this.selfEffects;
    }
    return this._allEffects;
  }
  get selfBehaviors() {
    if (!this._selfBehaviors) {
      this._selfBehaviors = {};
      for (let i in this._value.behaviors) {
        this._selfBehaviors[i] = new dcei_engine_behavior_proto.Behavior.WithParent(this._value.behaviors[i], null);
      }
    }
    return this._selfBehaviors;
  }
  get inherentBehaviors() {
    if (!this._inherentBehaviors) {
      this._inherentBehaviors = this._parent ? this._parent.behaviors : {};
    }
    return this._inherentBehaviors;
  }
  get behaviors() {
    if (!this._allBehaviors) {
      this._allBehaviors = this._parent ? {...this._parent.behaviors, ...this.selfBehaviors} : this.selfBehaviors;
    }
    return this._allBehaviors;
  }
  get selfUpgrades() {
    if (!this._selfUpgrades) {
      this._selfUpgrades = {};
      for (let i in this._value.upgrades) {
        this._selfUpgrades[i] = new dcei_engine_upgrade_proto.Upgrade.WithParent(this._value.upgrades[i], null);
      }
    }
    return this._selfUpgrades;
  }
  get inherentUpgrades() {
    if (!this._inherentUpgrades) {
      this._inherentUpgrades = this._parent ? this._parent.upgrades : {};
    }
    return this._inherentUpgrades;
  }
  get upgrades() {
    if (!this._allUpgrades) {
      this._allUpgrades = this._parent ? {...this._parent.upgrades, ...this.selfUpgrades} : this.selfUpgrades;
    }
    return this._allUpgrades;
  }
  get selfMovers() {
    if (!this._selfMovers) {
      this._selfMovers = {};
      for (let i in this._value.movers) {
        this._selfMovers[i] = new dcei_engine_mover_proto.Mover.WithParent(this._value.movers[i], null);
      }
    }
    return this._selfMovers;
  }
  get inherentMovers() {
    if (!this._inherentMovers) {
      this._inherentMovers = this._parent ? this._parent.movers : {};
    }
    return this._inherentMovers;
  }
  get movers() {
    if (!this._allMovers) {
      this._allMovers = this._parent ? {...this._parent.movers, ...this.selfMovers} : this.selfMovers;
    }
    return this._allMovers;
  }
  get selfValidators() {
    if (!this._selfValidators) {
      this._selfValidators = {};
      for (let i in this._value.validators) {
        this._selfValidators[i] = new dcei_engine_validator_proto.Validator.WithParent(this._value.validators[i], null);
      }
    }
    return this._selfValidators;
  }
  get inherentValidators() {
    if (!this._inherentValidators) {
      this._inherentValidators = this._parent ? this._parent.validators : {};
    }
    return this._inherentValidators;
  }
  get validators() {
    if (!this._allValidators) {
      this._allValidators = this._parent ? {...this._parent.validators, ...this.selfValidators} : this.selfValidators;
    }
    return this._allValidators;
  }
  get selfExpressions() {
    if (!this._selfExpressions) {
      this._selfExpressions = {};
      for (let i in this._value.expressions) {
        this._selfExpressions[i] = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(this._value.expressions[i], null);
      }
    }
    return this._selfExpressions;
  }
  get inherentExpressions() {
    if (!this._inherentExpressions) {
      this._inherentExpressions = this._parent ? this._parent.expressions : {};
    }
    return this._inherentExpressions;
  }
  get expressions() {
    if (!this._allExpressions) {
      this._allExpressions = this._parent ? {...this._parent.expressions, ...this.selfExpressions} : this.selfExpressions;
    }
    return this._allExpressions;
  }
  get selfDataUpgrades() {
    if (!this._selfDataUpgrades) {
      this._selfDataUpgrades = {};
      for (let i in this._value.dataUpgrades) {
        this._selfDataUpgrades[i] = new dcei_engine_upgrade_proto.DataUpgrade.WithParent(this._value.dataUpgrades[i], null);
      }
    }
    return this._selfDataUpgrades;
  }
  get inherentDataUpgrades() {
    if (!this._inherentDataUpgrades) {
      this._inherentDataUpgrades = this._parent ? this._parent.dataUpgrades : {};
    }
    return this._inherentDataUpgrades;
  }
  get dataUpgrades() {
    if (!this._allDataUpgrades) {
      this._allDataUpgrades = this._parent ? {...this._parent.dataUpgrades, ...this.selfDataUpgrades} : this.selfDataUpgrades;
    }
    return this._allDataUpgrades;
  }
  get selfActors() {
    if (!this._selfActors) {
      this._selfActors = {};
      for (let i in this._value.actors) {
        this._selfActors[i] = new dcei_engine_actor_proto.Actor.WithParent(this._value.actors[i], null);
      }
    }
    return this._selfActors;
  }
  get inherentActors() {
    if (!this._inherentActors) {
      this._inherentActors = this._parent ? this._parent.actors : {};
    }
    return this._inherentActors;
  }
  get actors() {
    if (!this._allActors) {
      this._allActors = this._parent ? {...this._parent.actors, ...this.selfActors} : this.selfActors;
    }
    return this._allActors;
  }
  get selfActorEventMacros() {
    if (!this._selfActorEventMacros) {
      this._selfActorEventMacros = {};
      for (let i in this._value.actorEventMacros) {
        this._selfActorEventMacros[i] = new dcei_engine_actor_proto.ActorEventMacro.WithParent(this._value.actorEventMacros[i], null);
      }
    }
    return this._selfActorEventMacros;
  }
  get inherentActorEventMacros() {
    if (!this._inherentActorEventMacros) {
      this._inherentActorEventMacros = this._parent ? this._parent.actorEventMacros : {};
    }
    return this._inherentActorEventMacros;
  }
  get actorEventMacros() {
    if (!this._allActorEventMacros) {
      this._allActorEventMacros = this._parent ? {...this._parent.actorEventMacros, ...this.selfActorEventMacros} : this.selfActorEventMacros;
    }
    return this._allActorEventMacros;
  }
  get selfSpawnPatterns() {
    if (!this._selfSpawnPatterns) {
      this._selfSpawnPatterns = {};
      for (let i in this._value.spawnPatterns) {
        this._selfSpawnPatterns[i] = new dcei_engine_spawn_pattern_proto.SpawnPattern.WithParent(this._value.spawnPatterns[i], null);
      }
    }
    return this._selfSpawnPatterns;
  }
  get inherentSpawnPatterns() {
    if (!this._inherentSpawnPatterns) {
      this._inherentSpawnPatterns = this._parent ? this._parent.spawnPatterns : {};
    }
    return this._inherentSpawnPatterns;
  }
  get spawnPatterns() {
    if (!this._allSpawnPatterns) {
      this._allSpawnPatterns = this._parent ? {...this._parent.spawnPatterns, ...this.selfSpawnPatterns} : this.selfSpawnPatterns;
    }
    return this._allSpawnPatterns;
  }
  get selfSpawnWaves() {
    if (!this._selfSpawnWaves) {
      this._selfSpawnWaves = {};
      for (let i in this._value.spawnWaves) {
        this._selfSpawnWaves[i] = new dcei_engine_spawn_wave_proto.SpawnWave.WithParent(this._value.spawnWaves[i], null);
      }
    }
    return this._selfSpawnWaves;
  }
  get inherentSpawnWaves() {
    if (!this._inherentSpawnWaves) {
      this._inherentSpawnWaves = this._parent ? this._parent.spawnWaves : {};
    }
    return this._inherentSpawnWaves;
  }
  get spawnWaves() {
    if (!this._allSpawnWaves) {
      this._allSpawnWaves = this._parent ? {...this._parent.spawnWaves, ...this.selfSpawnWaves} : this.selfSpawnWaves;
    }
    return this._allSpawnWaves;
  }
  get selfSpawnPatternGroups() {
    if (!this._selfSpawnPatternGroups) {
      this._selfSpawnPatternGroups = {};
      for (let i in this._value.spawnPatternGroups) {
        this._selfSpawnPatternGroups[i] = new dcei_engine_spawn_pattern_proto.SpawnGroup.WithParent(this._value.spawnPatternGroups[i], null);
      }
    }
    return this._selfSpawnPatternGroups;
  }
  get inherentSpawnPatternGroups() {
    if (!this._inherentSpawnPatternGroups) {
      this._inherentSpawnPatternGroups = this._parent ? this._parent.spawnPatternGroups : {};
    }
    return this._inherentSpawnPatternGroups;
  }
  get spawnPatternGroups() {
    if (!this._allSpawnPatternGroups) {
      this._allSpawnPatternGroups = this._parent ? {...this._parent.spawnPatternGroups, ...this.selfSpawnPatternGroups} : this.selfSpawnPatternGroups;
    }
    return this._allSpawnPatternGroups;
  }
  get selfTriggers() {
    if (!this._selfTriggers) {
      this._selfTriggers = {};
      for (let i in this._value.triggers) {
        this._selfTriggers[i] = new dcei_engine_trigger_proto.Trigger.WithParent(this._value.triggers[i], null);
      }
    }
    return this._selfTriggers;
  }
  get inherentTriggers() {
    if (!this._inherentTriggers) {
      this._inherentTriggers = this._parent ? this._parent.triggers : {};
    }
    return this._inherentTriggers;
  }
  get triggers() {
    if (!this._allTriggers) {
      this._allTriggers = this._parent ? {...this._parent.triggers, ...this.selfTriggers} : this.selfTriggers;
    }
    return this._allTriggers;
  }
  get selfTriggerGlobalVariables() {
    if (!this._selfTriggerGlobalVariables) {
      this._selfTriggerGlobalVariables = {};
      for (let i in this._value.triggerGlobalVariables) {
        this._selfTriggerGlobalVariables[i] = new dcei_engine_trigger_proto.VariableDefinition.WithParent(this._value.triggerGlobalVariables[i], null);
      }
    }
    return this._selfTriggerGlobalVariables;
  }
  get inherentTriggerGlobalVariables() {
    if (!this._inherentTriggerGlobalVariables) {
      this._inherentTriggerGlobalVariables = this._parent ? this._parent.triggerGlobalVariables : {};
    }
    return this._inherentTriggerGlobalVariables;
  }
  get triggerGlobalVariables() {
    if (!this._allTriggerGlobalVariables) {
      this._allTriggerGlobalVariables = this._parent ? {...this._parent.triggerGlobalVariables, ...this.selfTriggerGlobalVariables} : this.selfTriggerGlobalVariables;
    }
    return this._allTriggerGlobalVariables;
  }
  get selfTriggerCustomFunctions() {
    if (!this._selfTriggerCustomFunctions) {
      this._selfTriggerCustomFunctions = {};
      for (let i in this._value.triggerCustomFunctions) {
        this._selfTriggerCustomFunctions[i] = new dcei_engine_trigger_proto.CustomFunctionDefinition.WithParent(this._value.triggerCustomFunctions[i], null);
      }
    }
    return this._selfTriggerCustomFunctions;
  }
  get inherentTriggerCustomFunctions() {
    if (!this._inherentTriggerCustomFunctions) {
      this._inherentTriggerCustomFunctions = this._parent ? this._parent.triggerCustomFunctions : {};
    }
    return this._inherentTriggerCustomFunctions;
  }
  get triggerCustomFunctions() {
    if (!this._allTriggerCustomFunctions) {
      this._allTriggerCustomFunctions = this._parent ? {...this._parent.triggerCustomFunctions, ...this.selfTriggerCustomFunctions} : this.selfTriggerCustomFunctions;
    }
    return this._allTriggerCustomFunctions;
  }
  get selfTriggerCustomTypes() {
    if (!this._selfTriggerCustomTypes) {
      this._selfTriggerCustomTypes = {};
      for (let i in this._value.triggerCustomTypes) {
        this._selfTriggerCustomTypes[i] = new dcei_engine_trigger_proto.CompositeTypeDefinition.WithParent(this._value.triggerCustomTypes[i], null);
      }
    }
    return this._selfTriggerCustomTypes;
  }
  get inherentTriggerCustomTypes() {
    if (!this._inherentTriggerCustomTypes) {
      this._inherentTriggerCustomTypes = this._parent ? this._parent.triggerCustomTypes : {};
    }
    return this._inherentTriggerCustomTypes;
  }
  get triggerCustomTypes() {
    if (!this._allTriggerCustomTypes) {
      this._allTriggerCustomTypes = this._parent ? {...this._parent.triggerCustomTypes, ...this.selfTriggerCustomTypes} : this.selfTriggerCustomTypes;
    }
    return this._allTriggerCustomTypes;
  }
  get selfLocalizationEntries() {
    if (!this._selfLocalizationEntries) {
      this._selfLocalizationEntries = {};
      for (let i in this._value.localizationEntries) {
        this._selfLocalizationEntries[i] = new dcei_engine_localization_proto.LocalizationEntry.WithParent(this._value.localizationEntries[i], null);
      }
    }
    return this._selfLocalizationEntries;
  }
  get inherentLocalizationEntries() {
    if (!this._inherentLocalizationEntries) {
      this._inherentLocalizationEntries = this._parent ? this._parent.localizationEntries : {};
    }
    return this._inherentLocalizationEntries;
  }
  get localizationEntries() {
    if (!this._allLocalizationEntries) {
      this._allLocalizationEntries = this._parent ? {...this._parent.localizationEntries, ...this.selfLocalizationEntries} : this.selfLocalizationEntries;
    }
    return this._allLocalizationEntries;
  }
  get selfUserDataTypes() {
    if (!this._selfUserDataTypes) {
      this._selfUserDataTypes = {};
      for (let i in this._value.userDataTypes) {
        this._selfUserDataTypes[i] = new dcei_engine_user_data_proto.UserDataObjectType.WithParent(this._value.userDataTypes[i], null);
      }
    }
    return this._selfUserDataTypes;
  }
  get inherentUserDataTypes() {
    if (!this._inherentUserDataTypes) {
      this._inherentUserDataTypes = this._parent ? this._parent.userDataTypes : {};
    }
    return this._inherentUserDataTypes;
  }
  get userDataTypes() {
    if (!this._allUserDataTypes) {
      this._allUserDataTypes = this._parent ? {...this._parent.userDataTypes, ...this.selfUserDataTypes} : this.selfUserDataTypes;
    }
    return this._allUserDataTypes;
  }
  get selfUserDataValues() {
    if (!this._selfUserDataValues) {
      this._selfUserDataValues = {};
      for (let i in this._value.userDataValues) {
        this._selfUserDataValues[i] = new dcei_engine_user_data_proto.UserDataValue.WithParent(this._value.userDataValues[i], null);
      }
    }
    return this._selfUserDataValues;
  }
  get inherentUserDataValues() {
    if (!this._inherentUserDataValues) {
      this._inherentUserDataValues = this._parent ? this._parent.userDataValues : {};
    }
    return this._inherentUserDataValues;
  }
  get userDataValues() {
    if (!this._allUserDataValues) {
      this._allUserDataValues = this._parent ? {...this._parent.userDataValues, ...this.selfUserDataValues} : this.selfUserDataValues;
    }
    return this._allUserDataValues;
  }
  get hasSettings() {
    if (this._cachedHasSettings === undefined) {
      if (this._value.hasSettings) {
        this._cachedHasSettings = true;
      } else {
        this._cachedHasSettings = this._parent ? this._parent.hasSettings : false;
      }
    }
    return this._cachedHasSettings;
  }
  get settings() {
    if (!this._cachedSettings) {
      if (this._value.hasSettings) {
        this._cachedSettings = new MapSettings.WithParent(this._value.settings, this._parent && this._parent.hasSettings ? this._parent.settings : null);
      } else {
        this._cachedSettings = this._parent ? new MapSettings.WithParent(MapSettings.default, this._parent.settings) : MapSettings.WithParent.default;
      }
    }
    return this._cachedSettings;
  }
  get hasPlayerSettings() {
    if (this._cachedHasPlayerSettings === undefined) {
      if (this._value.hasPlayerSettings) {
        this._cachedHasPlayerSettings = true;
      } else {
        this._cachedHasPlayerSettings = this._parent ? this._parent.hasPlayerSettings : false;
      }
    }
    return this._cachedHasPlayerSettings;
  }
  get playerSettings() {
    if (!this._cachedPlayerSettings) {
      if (this._value.hasPlayerSettings) {
        this._cachedPlayerSettings = new PlayerSettings.WithParent(this._value.playerSettings, this._parent && this._parent.hasPlayerSettings ? this._parent.playerSettings : null);
      } else {
        this._cachedPlayerSettings = this._parent ? new PlayerSettings.WithParent(PlayerSettings.default, this._parent.playerSettings) : PlayerSettings.WithParent.default;
      }
    }
    return this._cachedPlayerSettings;
  }
  get hasDisplaySettings() {
    if (this._cachedHasDisplaySettings === undefined) {
      if (this._value.hasDisplaySettings) {
        this._cachedHasDisplaySettings = true;
      } else {
        this._cachedHasDisplaySettings = this._parent ? this._parent.hasDisplaySettings : false;
      }
    }
    return this._cachedHasDisplaySettings;
  }
  get displaySettings() {
    if (!this._cachedDisplaySettings) {
      if (this._value.hasDisplaySettings) {
        this._cachedDisplaySettings = new DisplaySettings.WithParent(this._value.displaySettings, this._parent && this._parent.hasDisplaySettings ? this._parent.displaySettings : null);
      } else {
        this._cachedDisplaySettings = this._parent ? new DisplaySettings.WithParent(DisplaySettings.default, this._parent.displaySettings) : DisplaySettings.WithParent.default;
      }
    }
    return this._cachedDisplaySettings;
  }
  get hasInputSettings() {
    if (this._cachedHasInputSettings === undefined) {
      if (this._value.hasInputSettings) {
        this._cachedHasInputSettings = true;
      } else {
        this._cachedHasInputSettings = this._parent ? this._parent.hasInputSettings : false;
      }
    }
    return this._cachedHasInputSettings;
  }
  get inputSettings() {
    if (!this._cachedInputSettings) {
      if (this._value.hasInputSettings) {
        this._cachedInputSettings = new InputSettings.WithParent(this._value.inputSettings, this._parent && this._parent.hasInputSettings ? this._parent.inputSettings : null);
      } else {
        this._cachedInputSettings = this._parent ? new InputSettings.WithParent(InputSettings.default, this._parent.inputSettings) : InputSettings.WithParent.default;
      }
    }
    return this._cachedInputSettings;
  }
  get hasGraphicsSettings() {
    if (this._cachedHasGraphicsSettings === undefined) {
      if (this._value.hasGraphicsSettings) {
        this._cachedHasGraphicsSettings = true;
      } else {
        this._cachedHasGraphicsSettings = this._parent ? this._parent.hasGraphicsSettings : false;
      }
    }
    return this._cachedHasGraphicsSettings;
  }
  get graphicsSettings() {
    if (!this._cachedGraphicsSettings) {
      if (this._value.hasGraphicsSettings) {
        this._cachedGraphicsSettings = new GraphicsSettings.WithParent(this._value.graphicsSettings, this._parent && this._parent.hasGraphicsSettings ? this._parent.graphicsSettings : null);
      } else {
        this._cachedGraphicsSettings = this._parent ? new GraphicsSettings.WithParent(GraphicsSettings.default, this._parent.graphicsSettings) : GraphicsSettings.WithParent.default;
      }
    }
    return this._cachedGraphicsSettings;
  }
  get hasCameraSettings() {
    if (this._cachedHasCameraSettings === undefined) {
      if (this._value.hasCameraSettings) {
        this._cachedHasCameraSettings = true;
      } else {
        this._cachedHasCameraSettings = this._parent ? this._parent.hasCameraSettings : false;
      }
    }
    return this._cachedHasCameraSettings;
  }
  get cameraSettings() {
    if (!this._cachedCameraSettings) {
      if (this._value.hasCameraSettings) {
        this._cachedCameraSettings = new dcei_engine_spawn_wave_proto.CameraSettings.WithParent(this._value.cameraSettings, this._parent && this._parent.hasCameraSettings ? this._parent.cameraSettings : null);
      } else {
        this._cachedCameraSettings = this._parent ? new dcei_engine_spawn_wave_proto.CameraSettings.WithParent(dcei_engine_spawn_wave_proto.CameraSettings.default, this._parent.cameraSettings) : dcei_engine_spawn_wave_proto.CameraSettings.WithParent.default;
      }
    }
    return this._cachedCameraSettings;
  }
  get hasMusicSettings() {
    if (this._cachedHasMusicSettings === undefined) {
      if (this._value.hasMusicSettings) {
        this._cachedHasMusicSettings = true;
      } else {
        this._cachedHasMusicSettings = this._parent ? this._parent.hasMusicSettings : false;
      }
    }
    return this._cachedHasMusicSettings;
  }
  get musicSettings() {
    if (!this._cachedMusicSettings) {
      if (this._value.hasMusicSettings) {
        this._cachedMusicSettings = new MusicSettings.WithParent(this._value.musicSettings, this._parent && this._parent.hasMusicSettings ? this._parent.musicSettings : null);
      } else {
        this._cachedMusicSettings = this._parent ? new MusicSettings.WithParent(MusicSettings.default, this._parent.musicSettings) : MusicSettings.WithParent.default;
      }
    }
    return this._cachedMusicSettings;
  }
  get hasWeatherSettings() {
    if (this._cachedHasWeatherSettings === undefined) {
      if (this._value.hasWeatherSettings) {
        this._cachedHasWeatherSettings = true;
      } else {
        this._cachedHasWeatherSettings = this._parent ? this._parent.hasWeatherSettings : false;
      }
    }
    return this._cachedHasWeatherSettings;
  }
  get weatherSettings() {
    if (!this._cachedWeatherSettings) {
      if (this._value.hasWeatherSettings) {
        this._cachedWeatherSettings = new WeatherSettings.WithParent(this._value.weatherSettings, this._parent && this._parent.hasWeatherSettings ? this._parent.weatherSettings : null);
      } else {
        this._cachedWeatherSettings = this._parent ? new WeatherSettings.WithParent(WeatherSettings.default, this._parent.weatherSettings) : WeatherSettings.WithParent.default;
      }
    }
    return this._cachedWeatherSettings;
  }
  get hasTriggerSettings() {
    if (this._cachedHasTriggerSettings === undefined) {
      if (this._value.hasTriggerSettings) {
        this._cachedHasTriggerSettings = true;
      } else {
        this._cachedHasTriggerSettings = this._parent ? this._parent.hasTriggerSettings : false;
      }
    }
    return this._cachedHasTriggerSettings;
  }
  get triggerSettings() {
    if (!this._cachedTriggerSettings) {
      if (this._value.hasTriggerSettings) {
        this._cachedTriggerSettings = new TriggerSettings.WithParent(this._value.triggerSettings, this._parent && this._parent.hasTriggerSettings ? this._parent.triggerSettings : null);
      } else {
        this._cachedTriggerSettings = this._parent ? new TriggerSettings.WithParent(TriggerSettings.default, this._parent.triggerSettings) : TriggerSettings.WithParent.default;
      }
    }
    return this._cachedTriggerSettings;
  }
  get hasFontSettings() {
    if (this._cachedHasFontSettings === undefined) {
      if (this._value.hasFontSettings) {
        this._cachedHasFontSettings = true;
      } else {
        this._cachedHasFontSettings = this._parent ? this._parent.hasFontSettings : false;
      }
    }
    return this._cachedHasFontSettings;
  }
  get fontSettings() {
    if (!this._cachedFontSettings) {
      if (this._value.hasFontSettings) {
        this._cachedFontSettings = new FontSettings.WithParent(this._value.fontSettings, this._parent && this._parent.hasFontSettings ? this._parent.fontSettings : null);
      } else {
        this._cachedFontSettings = this._parent ? new FontSettings.WithParent(FontSettings.default, this._parent.fontSettings) : FontSettings.WithParent.default;
      }
    }
    return this._cachedFontSettings;
  }
  get hasIngameSettings() {
    if (this._cachedHasIngameSettings === undefined) {
      if (this._value.hasIngameSettings) {
        this._cachedHasIngameSettings = true;
      } else {
        this._cachedHasIngameSettings = this._parent ? this._parent.hasIngameSettings : false;
      }
    }
    return this._cachedHasIngameSettings;
  }
  get ingameSettings() {
    if (!this._cachedIngameSettings) {
      if (this._value.hasIngameSettings) {
        this._cachedIngameSettings = new InGameSettings.WithParent(this._value.ingameSettings, this._parent && this._parent.hasIngameSettings ? this._parent.ingameSettings : null);
      } else {
        this._cachedIngameSettings = this._parent ? new InGameSettings.WithParent(InGameSettings.default, this._parent.ingameSettings) : InGameSettings.WithParent.default;
      }
    }
    return this._cachedIngameSettings;
  }
  get hasCustomAssetSettings() {
    if (this._cachedHasCustomAssetSettings === undefined) {
      if (this._value.hasCustomAssetSettings) {
        this._cachedHasCustomAssetSettings = true;
      } else {
        this._cachedHasCustomAssetSettings = this._parent ? this._parent.hasCustomAssetSettings : false;
      }
    }
    return this._cachedHasCustomAssetSettings;
  }
  get customAssetSettings() {
    if (!this._cachedCustomAssetSettings) {
      if (this._value.hasCustomAssetSettings) {
        this._cachedCustomAssetSettings = new CustomAssetSettings.WithParent(this._value.customAssetSettings, this._parent && this._parent.hasCustomAssetSettings ? this._parent.customAssetSettings : null);
      } else {
        this._cachedCustomAssetSettings = this._parent ? new CustomAssetSettings.WithParent(CustomAssetSettings.default, this._parent.customAssetSettings) : CustomAssetSettings.WithParent.default;
      }
    }
    return this._cachedCustomAssetSettings;
  }
  update(current, parent) {
    const result = new DataFile_WithParent(current, parent);
    if (this._selfUnits) {
      if (this._value.units === current.units) {
        result._selfUnits = this._selfUnits;
      } else {
        result._selfUnits = {};
        for (let i in current.units) {
          const oldValue = this._value.units[i];
          if (oldValue) {
            const oldCache = this._selfUnits[i];
            if (oldValue === current.units[i]) {
              result._selfUnits[i] = oldCache;
            } else {
              result._selfUnits[i] = oldCache.update(current.units[i], null);
            }
          } else {
            result._selfUnits[i] = new dcei_engine_unit_proto.Unit.WithParent(current.units[i], null);
          }
        }
      }
    }
    if (this._selfWeapons) {
      if (this._value.weapons === current.weapons) {
        result._selfWeapons = this._selfWeapons;
      } else {
        result._selfWeapons = {};
        for (let i in current.weapons) {
          const oldValue = this._value.weapons[i];
          if (oldValue) {
            const oldCache = this._selfWeapons[i];
            if (oldValue === current.weapons[i]) {
              result._selfWeapons[i] = oldCache;
            } else {
              result._selfWeapons[i] = oldCache.update(current.weapons[i], null);
            }
          } else {
            result._selfWeapons[i] = new dcei_engine_weapon_proto.Weapon.WithParent(current.weapons[i], null);
          }
        }
      }
    }
    if (this._selfAbilities) {
      if (this._value.abilities === current.abilities) {
        result._selfAbilities = this._selfAbilities;
      } else {
        result._selfAbilities = {};
        for (let i in current.abilities) {
          const oldValue = this._value.abilities[i];
          if (oldValue) {
            const oldCache = this._selfAbilities[i];
            if (oldValue === current.abilities[i]) {
              result._selfAbilities[i] = oldCache;
            } else {
              result._selfAbilities[i] = oldCache.update(current.abilities[i], null);
            }
          } else {
            result._selfAbilities[i] = new dcei_engine_ability_proto.Ability.WithParent(current.abilities[i], null);
          }
        }
      }
    }
    if (this._selfEffects) {
      if (this._value.effects === current.effects) {
        result._selfEffects = this._selfEffects;
      } else {
        result._selfEffects = {};
        for (let i in current.effects) {
          const oldValue = this._value.effects[i];
          if (oldValue) {
            const oldCache = this._selfEffects[i];
            if (oldValue === current.effects[i]) {
              result._selfEffects[i] = oldCache;
            } else {
              result._selfEffects[i] = oldCache.update(current.effects[i], null);
            }
          } else {
            result._selfEffects[i] = new dcei_engine_effect_proto.Effect.WithParent(current.effects[i], null);
          }
        }
      }
    }
    if (this._selfBehaviors) {
      if (this._value.behaviors === current.behaviors) {
        result._selfBehaviors = this._selfBehaviors;
      } else {
        result._selfBehaviors = {};
        for (let i in current.behaviors) {
          const oldValue = this._value.behaviors[i];
          if (oldValue) {
            const oldCache = this._selfBehaviors[i];
            if (oldValue === current.behaviors[i]) {
              result._selfBehaviors[i] = oldCache;
            } else {
              result._selfBehaviors[i] = oldCache.update(current.behaviors[i], null);
            }
          } else {
            result._selfBehaviors[i] = new dcei_engine_behavior_proto.Behavior.WithParent(current.behaviors[i], null);
          }
        }
      }
    }
    if (this._selfUpgrades) {
      if (this._value.upgrades === current.upgrades) {
        result._selfUpgrades = this._selfUpgrades;
      } else {
        result._selfUpgrades = {};
        for (let i in current.upgrades) {
          const oldValue = this._value.upgrades[i];
          if (oldValue) {
            const oldCache = this._selfUpgrades[i];
            if (oldValue === current.upgrades[i]) {
              result._selfUpgrades[i] = oldCache;
            } else {
              result._selfUpgrades[i] = oldCache.update(current.upgrades[i], null);
            }
          } else {
            result._selfUpgrades[i] = new dcei_engine_upgrade_proto.Upgrade.WithParent(current.upgrades[i], null);
          }
        }
      }
    }
    if (this._selfMovers) {
      if (this._value.movers === current.movers) {
        result._selfMovers = this._selfMovers;
      } else {
        result._selfMovers = {};
        for (let i in current.movers) {
          const oldValue = this._value.movers[i];
          if (oldValue) {
            const oldCache = this._selfMovers[i];
            if (oldValue === current.movers[i]) {
              result._selfMovers[i] = oldCache;
            } else {
              result._selfMovers[i] = oldCache.update(current.movers[i], null);
            }
          } else {
            result._selfMovers[i] = new dcei_engine_mover_proto.Mover.WithParent(current.movers[i], null);
          }
        }
      }
    }
    if (this._selfValidators) {
      if (this._value.validators === current.validators) {
        result._selfValidators = this._selfValidators;
      } else {
        result._selfValidators = {};
        for (let i in current.validators) {
          const oldValue = this._value.validators[i];
          if (oldValue) {
            const oldCache = this._selfValidators[i];
            if (oldValue === current.validators[i]) {
              result._selfValidators[i] = oldCache;
            } else {
              result._selfValidators[i] = oldCache.update(current.validators[i], null);
            }
          } else {
            result._selfValidators[i] = new dcei_engine_validator_proto.Validator.WithParent(current.validators[i], null);
          }
        }
      }
    }
    if (this._selfExpressions) {
      if (this._value.expressions === current.expressions) {
        result._selfExpressions = this._selfExpressions;
      } else {
        result._selfExpressions = {};
        for (let i in current.expressions) {
          const oldValue = this._value.expressions[i];
          if (oldValue) {
            const oldCache = this._selfExpressions[i];
            if (oldValue === current.expressions[i]) {
              result._selfExpressions[i] = oldCache;
            } else {
              result._selfExpressions[i] = oldCache.update(current.expressions[i], null);
            }
          } else {
            result._selfExpressions[i] = new dcei_engine_expression_proto.ValidatorExpressions.Expression.WithParent(current.expressions[i], null);
          }
        }
      }
    }
    if (this._selfDataUpgrades) {
      if (this._value.dataUpgrades === current.dataUpgrades) {
        result._selfDataUpgrades = this._selfDataUpgrades;
      } else {
        result._selfDataUpgrades = {};
        for (let i in current.dataUpgrades) {
          const oldValue = this._value.dataUpgrades[i];
          if (oldValue) {
            const oldCache = this._selfDataUpgrades[i];
            if (oldValue === current.dataUpgrades[i]) {
              result._selfDataUpgrades[i] = oldCache;
            } else {
              result._selfDataUpgrades[i] = oldCache.update(current.dataUpgrades[i], null);
            }
          } else {
            result._selfDataUpgrades[i] = new dcei_engine_upgrade_proto.DataUpgrade.WithParent(current.dataUpgrades[i], null);
          }
        }
      }
    }
    if (this._selfActors) {
      if (this._value.actors === current.actors) {
        result._selfActors = this._selfActors;
      } else {
        result._selfActors = {};
        for (let i in current.actors) {
          const oldValue = this._value.actors[i];
          if (oldValue) {
            const oldCache = this._selfActors[i];
            if (oldValue === current.actors[i]) {
              result._selfActors[i] = oldCache;
            } else {
              result._selfActors[i] = oldCache.update(current.actors[i], null);
            }
          } else {
            result._selfActors[i] = new dcei_engine_actor_proto.Actor.WithParent(current.actors[i], null);
          }
        }
      }
    }
    if (this._selfActorEventMacros) {
      if (this._value.actorEventMacros === current.actorEventMacros) {
        result._selfActorEventMacros = this._selfActorEventMacros;
      } else {
        result._selfActorEventMacros = {};
        for (let i in current.actorEventMacros) {
          const oldValue = this._value.actorEventMacros[i];
          if (oldValue) {
            const oldCache = this._selfActorEventMacros[i];
            if (oldValue === current.actorEventMacros[i]) {
              result._selfActorEventMacros[i] = oldCache;
            } else {
              result._selfActorEventMacros[i] = oldCache.update(current.actorEventMacros[i], null);
            }
          } else {
            result._selfActorEventMacros[i] = new dcei_engine_actor_proto.ActorEventMacro.WithParent(current.actorEventMacros[i], null);
          }
        }
      }
    }
    if (this._selfSpawnPatterns) {
      if (this._value.spawnPatterns === current.spawnPatterns) {
        result._selfSpawnPatterns = this._selfSpawnPatterns;
      } else {
        result._selfSpawnPatterns = {};
        for (let i in current.spawnPatterns) {
          const oldValue = this._value.spawnPatterns[i];
          if (oldValue) {
            const oldCache = this._selfSpawnPatterns[i];
            if (oldValue === current.spawnPatterns[i]) {
              result._selfSpawnPatterns[i] = oldCache;
            } else {
              result._selfSpawnPatterns[i] = oldCache.update(current.spawnPatterns[i], null);
            }
          } else {
            result._selfSpawnPatterns[i] = new dcei_engine_spawn_pattern_proto.SpawnPattern.WithParent(current.spawnPatterns[i], null);
          }
        }
      }
    }
    if (this._selfSpawnWaves) {
      if (this._value.spawnWaves === current.spawnWaves) {
        result._selfSpawnWaves = this._selfSpawnWaves;
      } else {
        result._selfSpawnWaves = {};
        for (let i in current.spawnWaves) {
          const oldValue = this._value.spawnWaves[i];
          if (oldValue) {
            const oldCache = this._selfSpawnWaves[i];
            if (oldValue === current.spawnWaves[i]) {
              result._selfSpawnWaves[i] = oldCache;
            } else {
              result._selfSpawnWaves[i] = oldCache.update(current.spawnWaves[i], null);
            }
          } else {
            result._selfSpawnWaves[i] = new dcei_engine_spawn_wave_proto.SpawnWave.WithParent(current.spawnWaves[i], null);
          }
        }
      }
    }
    if (this._selfSpawnPatternGroups) {
      if (this._value.spawnPatternGroups === current.spawnPatternGroups) {
        result._selfSpawnPatternGroups = this._selfSpawnPatternGroups;
      } else {
        result._selfSpawnPatternGroups = {};
        for (let i in current.spawnPatternGroups) {
          const oldValue = this._value.spawnPatternGroups[i];
          if (oldValue) {
            const oldCache = this._selfSpawnPatternGroups[i];
            if (oldValue === current.spawnPatternGroups[i]) {
              result._selfSpawnPatternGroups[i] = oldCache;
            } else {
              result._selfSpawnPatternGroups[i] = oldCache.update(current.spawnPatternGroups[i], null);
            }
          } else {
            result._selfSpawnPatternGroups[i] = new dcei_engine_spawn_pattern_proto.SpawnGroup.WithParent(current.spawnPatternGroups[i], null);
          }
        }
      }
    }
    if (this._selfTriggers) {
      if (this._value.triggers === current.triggers) {
        result._selfTriggers = this._selfTriggers;
      } else {
        result._selfTriggers = {};
        for (let i in current.triggers) {
          const oldValue = this._value.triggers[i];
          if (oldValue) {
            const oldCache = this._selfTriggers[i];
            if (oldValue === current.triggers[i]) {
              result._selfTriggers[i] = oldCache;
            } else {
              result._selfTriggers[i] = oldCache.update(current.triggers[i], null);
            }
          } else {
            result._selfTriggers[i] = new dcei_engine_trigger_proto.Trigger.WithParent(current.triggers[i], null);
          }
        }
      }
    }
    if (this._selfTriggerGlobalVariables) {
      if (this._value.triggerGlobalVariables === current.triggerGlobalVariables) {
        result._selfTriggerGlobalVariables = this._selfTriggerGlobalVariables;
      } else {
        result._selfTriggerGlobalVariables = {};
        for (let i in current.triggerGlobalVariables) {
          const oldValue = this._value.triggerGlobalVariables[i];
          if (oldValue) {
            const oldCache = this._selfTriggerGlobalVariables[i];
            if (oldValue === current.triggerGlobalVariables[i]) {
              result._selfTriggerGlobalVariables[i] = oldCache;
            } else {
              result._selfTriggerGlobalVariables[i] = oldCache.update(current.triggerGlobalVariables[i], null);
            }
          } else {
            result._selfTriggerGlobalVariables[i] = new dcei_engine_trigger_proto.VariableDefinition.WithParent(current.triggerGlobalVariables[i], null);
          }
        }
      }
    }
    if (this._selfTriggerCustomFunctions) {
      if (this._value.triggerCustomFunctions === current.triggerCustomFunctions) {
        result._selfTriggerCustomFunctions = this._selfTriggerCustomFunctions;
      } else {
        result._selfTriggerCustomFunctions = {};
        for (let i in current.triggerCustomFunctions) {
          const oldValue = this._value.triggerCustomFunctions[i];
          if (oldValue) {
            const oldCache = this._selfTriggerCustomFunctions[i];
            if (oldValue === current.triggerCustomFunctions[i]) {
              result._selfTriggerCustomFunctions[i] = oldCache;
            } else {
              result._selfTriggerCustomFunctions[i] = oldCache.update(current.triggerCustomFunctions[i], null);
            }
          } else {
            result._selfTriggerCustomFunctions[i] = new dcei_engine_trigger_proto.CustomFunctionDefinition.WithParent(current.triggerCustomFunctions[i], null);
          }
        }
      }
    }
    if (this._selfTriggerCustomTypes) {
      if (this._value.triggerCustomTypes === current.triggerCustomTypes) {
        result._selfTriggerCustomTypes = this._selfTriggerCustomTypes;
      } else {
        result._selfTriggerCustomTypes = {};
        for (let i in current.triggerCustomTypes) {
          const oldValue = this._value.triggerCustomTypes[i];
          if (oldValue) {
            const oldCache = this._selfTriggerCustomTypes[i];
            if (oldValue === current.triggerCustomTypes[i]) {
              result._selfTriggerCustomTypes[i] = oldCache;
            } else {
              result._selfTriggerCustomTypes[i] = oldCache.update(current.triggerCustomTypes[i], null);
            }
          } else {
            result._selfTriggerCustomTypes[i] = new dcei_engine_trigger_proto.CompositeTypeDefinition.WithParent(current.triggerCustomTypes[i], null);
          }
        }
      }
    }
    if (this._selfLocalizationEntries) {
      if (this._value.localizationEntries === current.localizationEntries) {
        result._selfLocalizationEntries = this._selfLocalizationEntries;
      } else {
        result._selfLocalizationEntries = {};
        for (let i in current.localizationEntries) {
          const oldValue = this._value.localizationEntries[i];
          if (oldValue) {
            const oldCache = this._selfLocalizationEntries[i];
            if (oldValue === current.localizationEntries[i]) {
              result._selfLocalizationEntries[i] = oldCache;
            } else {
              result._selfLocalizationEntries[i] = oldCache.update(current.localizationEntries[i], null);
            }
          } else {
            result._selfLocalizationEntries[i] = new dcei_engine_localization_proto.LocalizationEntry.WithParent(current.localizationEntries[i], null);
          }
        }
      }
    }
    if (this._selfUserDataTypes) {
      if (this._value.userDataTypes === current.userDataTypes) {
        result._selfUserDataTypes = this._selfUserDataTypes;
      } else {
        result._selfUserDataTypes = {};
        for (let i in current.userDataTypes) {
          const oldValue = this._value.userDataTypes[i];
          if (oldValue) {
            const oldCache = this._selfUserDataTypes[i];
            if (oldValue === current.userDataTypes[i]) {
              result._selfUserDataTypes[i] = oldCache;
            } else {
              result._selfUserDataTypes[i] = oldCache.update(current.userDataTypes[i], null);
            }
          } else {
            result._selfUserDataTypes[i] = new dcei_engine_user_data_proto.UserDataObjectType.WithParent(current.userDataTypes[i], null);
          }
        }
      }
    }
    if (this._selfUserDataValues) {
      if (this._value.userDataValues === current.userDataValues) {
        result._selfUserDataValues = this._selfUserDataValues;
      } else {
        result._selfUserDataValues = {};
        for (let i in current.userDataValues) {
          const oldValue = this._value.userDataValues[i];
          if (oldValue) {
            const oldCache = this._selfUserDataValues[i];
            if (oldValue === current.userDataValues[i]) {
              result._selfUserDataValues[i] = oldCache;
            } else {
              result._selfUserDataValues[i] = oldCache.update(current.userDataValues[i], null);
            }
          } else {
            result._selfUserDataValues[i] = new dcei_engine_user_data_proto.UserDataValue.WithParent(current.userDataValues[i], null);
          }
        }
      }
    }
    if (this._cachedSettings && this._value.hasSettings && current.hasSettings) {
      if (this._value.settings === current.settings && this._parent === parent) {
        result._cachedSettings = this._cachedSettings;
      } else {
        result._cachedSettings = this._cachedSettings.update(current.settings, parent && parent.hasSettings ? parent.settings : null);
      }
    }
    if (this._cachedPlayerSettings && this._value.hasPlayerSettings && current.hasPlayerSettings) {
      if (this._value.playerSettings === current.playerSettings && this._parent === parent) {
        result._cachedPlayerSettings = this._cachedPlayerSettings;
      } else {
        result._cachedPlayerSettings = this._cachedPlayerSettings.update(current.playerSettings, parent && parent.hasPlayerSettings ? parent.playerSettings : null);
      }
    }
    if (this._cachedDisplaySettings && this._value.hasDisplaySettings && current.hasDisplaySettings) {
      if (this._value.displaySettings === current.displaySettings && this._parent === parent) {
        result._cachedDisplaySettings = this._cachedDisplaySettings;
      } else {
        result._cachedDisplaySettings = this._cachedDisplaySettings.update(current.displaySettings, parent && parent.hasDisplaySettings ? parent.displaySettings : null);
      }
    }
    if (this._cachedInputSettings && this._value.hasInputSettings && current.hasInputSettings) {
      if (this._value.inputSettings === current.inputSettings && this._parent === parent) {
        result._cachedInputSettings = this._cachedInputSettings;
      } else {
        result._cachedInputSettings = this._cachedInputSettings.update(current.inputSettings, parent && parent.hasInputSettings ? parent.inputSettings : null);
      }
    }
    if (this._cachedGraphicsSettings && this._value.hasGraphicsSettings && current.hasGraphicsSettings) {
      if (this._value.graphicsSettings === current.graphicsSettings && this._parent === parent) {
        result._cachedGraphicsSettings = this._cachedGraphicsSettings;
      } else {
        result._cachedGraphicsSettings = this._cachedGraphicsSettings.update(current.graphicsSettings, parent && parent.hasGraphicsSettings ? parent.graphicsSettings : null);
      }
    }
    if (this._cachedCameraSettings && this._value.hasCameraSettings && current.hasCameraSettings) {
      if (this._value.cameraSettings === current.cameraSettings && this._parent === parent) {
        result._cachedCameraSettings = this._cachedCameraSettings;
      } else {
        result._cachedCameraSettings = this._cachedCameraSettings.update(current.cameraSettings, parent && parent.hasCameraSettings ? parent.cameraSettings : null);
      }
    }
    if (this._cachedMusicSettings && this._value.hasMusicSettings && current.hasMusicSettings) {
      if (this._value.musicSettings === current.musicSettings && this._parent === parent) {
        result._cachedMusicSettings = this._cachedMusicSettings;
      } else {
        result._cachedMusicSettings = this._cachedMusicSettings.update(current.musicSettings, parent && parent.hasMusicSettings ? parent.musicSettings : null);
      }
    }
    if (this._cachedWeatherSettings && this._value.hasWeatherSettings && current.hasWeatherSettings) {
      if (this._value.weatherSettings === current.weatherSettings && this._parent === parent) {
        result._cachedWeatherSettings = this._cachedWeatherSettings;
      } else {
        result._cachedWeatherSettings = this._cachedWeatherSettings.update(current.weatherSettings, parent && parent.hasWeatherSettings ? parent.weatherSettings : null);
      }
    }
    if (this._cachedTriggerSettings && this._value.hasTriggerSettings && current.hasTriggerSettings) {
      if (this._value.triggerSettings === current.triggerSettings && this._parent === parent) {
        result._cachedTriggerSettings = this._cachedTriggerSettings;
      } else {
        result._cachedTriggerSettings = this._cachedTriggerSettings.update(current.triggerSettings, parent && parent.hasTriggerSettings ? parent.triggerSettings : null);
      }
    }
    if (this._cachedFontSettings && this._value.hasFontSettings && current.hasFontSettings) {
      if (this._value.fontSettings === current.fontSettings && this._parent === parent) {
        result._cachedFontSettings = this._cachedFontSettings;
      } else {
        result._cachedFontSettings = this._cachedFontSettings.update(current.fontSettings, parent && parent.hasFontSettings ? parent.fontSettings : null);
      }
    }
    if (this._cachedIngameSettings && this._value.hasIngameSettings && current.hasIngameSettings) {
      if (this._value.ingameSettings === current.ingameSettings && this._parent === parent) {
        result._cachedIngameSettings = this._cachedIngameSettings;
      } else {
        result._cachedIngameSettings = this._cachedIngameSettings.update(current.ingameSettings, parent && parent.hasIngameSettings ? parent.ingameSettings : null);
      }
    }
    if (this._cachedCustomAssetSettings && this._value.hasCustomAssetSettings && current.hasCustomAssetSettings) {
      if (this._value.customAssetSettings === current.customAssetSettings && this._parent === parent) {
        result._cachedCustomAssetSettings = this._cachedCustomAssetSettings;
      } else {
        result._cachedCustomAssetSettings = this._cachedCustomAssetSettings.update(current.customAssetSettings, parent && parent.hasCustomAssetSettings ? parent.customAssetSettings : null);
      }
    }
    return result;
  }
}
DataFile_WithParent.default = new DataFile_WithParent(DataFile.default, null);
DataFile.WithParent = DataFile_WithParent;
class DataFile_Descriptor {
  get units() {
    if (!this._units) {
      this._units = {
        name: "units",
        Name: "Units",
        number: 1,
        protoType: 11,
        protoName: "units",
        isMap: true,
        keyType: JsonToString,
        valueType: dcei_engine_unit_proto.Unit,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._units;
  }
  get weapons() {
    if (!this._weapons) {
      this._weapons = {
        name: "weapons",
        Name: "Weapons",
        number: 2,
        protoType: 11,
        protoName: "weapons",
        isMap: true,
        keyType: JsonToString,
        valueType: dcei_engine_weapon_proto.Weapon,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._weapons;
  }
  get abilities() {
    if (!this._abilities) {
      this._abilities = {
        name: "abilities",
        Name: "Abilities",
        number: 3,
        protoType: 11,
        protoName: "abilities",
        isMap: true,
        keyType: JsonToString,
        valueType: dcei_engine_ability_proto.Ability,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._abilities;
  }
  get effects() {
    if (!this._effects) {
      this._effects = {
        name: "effects",
        Name: "Effects",
        number: 4,
        protoType: 11,
        protoName: "effects",
        isMap: true,
        keyType: JsonToString,
        valueType: dcei_engine_effect_proto.Effect,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._effects;
  }
  get behaviors() {
    if (!this._behaviors) {
      this._behaviors = {
        name: "behaviors",
        Name: "Behaviors",
        number: 5,
        protoType: 11,
        protoName: "behaviors",
        isMap: true,
        keyType: JsonToString,
        valueType: dcei_engine_behavior_proto.Behavior,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._behaviors;
  }
  get upgrades() {
    if (!this._upgrades) {
      this._upgrades = {
        name: "upgrades",
        Name: "Upgrades",
        number: 11,
        protoType: 11,
        protoName: "upgrades",
        isMap: true,
        keyType: JsonToString,
        valueType: dcei_engine_upgrade_proto.Upgrade,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._upgrades;
  }
  get movers() {
    if (!this._movers) {
      this._movers = {
        name: "movers",
        Name: "Movers",
        number: 12,
        protoType: 11,
        protoName: "movers",
        isMap: true,
        keyType: JsonToString,
        valueType: dcei_engine_mover_proto.Mover,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._movers;
  }
  get validators() {
    if (!this._validators) {
      this._validators = {
        name: "validators",
        Name: "Validators",
        number: 13,
        protoType: 11,
        protoName: "validators",
        isMap: true,
        keyType: JsonToString,
        valueType: dcei_engine_validator_proto.Validator,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._validators;
  }
  get expressions() {
    if (!this._expressions) {
      this._expressions = {
        name: "expressions",
        Name: "Expressions",
        number: 14,
        protoType: 11,
        protoName: "expressions",
        isMap: true,
        keyType: JsonToString,
        valueType: dcei_engine_expression_proto.ValidatorExpressions.Expression,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._expressions;
  }
  get dataUpgrades() {
    if (!this._dataUpgrades) {
      this._dataUpgrades = {
        name: "dataUpgrades",
        Name: "DataUpgrades",
        number: 15,
        protoType: 11,
        protoName: "data_upgrades",
        isMap: true,
        keyType: JsonToString,
        valueType: dcei_engine_upgrade_proto.DataUpgrade,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dataUpgrades;
  }
  get actors() {
    if (!this._actors) {
      this._actors = {
        name: "actors",
        Name: "Actors",
        number: 21,
        protoType: 11,
        protoName: "actors",
        isMap: true,
        keyType: JsonToString,
        valueType: dcei_engine_actor_proto.Actor,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actors;
  }
  get actorEventMacros() {
    if (!this._actorEventMacros) {
      this._actorEventMacros = {
        name: "actorEventMacros",
        Name: "ActorEventMacros",
        number: 22,
        protoType: 11,
        protoName: "actor_event_macros",
        isMap: true,
        keyType: JsonToString,
        valueType: dcei_engine_actor_proto.ActorEventMacro,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._actorEventMacros;
  }
  get spawnPatterns() {
    if (!this._spawnPatterns) {
      this._spawnPatterns = {
        name: "spawnPatterns",
        Name: "SpawnPatterns",
        number: 31,
        protoType: 11,
        protoName: "spawn_patterns",
        isMap: true,
        keyType: JsonToString,
        valueType: dcei_engine_spawn_pattern_proto.SpawnPattern,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._spawnPatterns;
  }
  get spawnWaves() {
    if (!this._spawnWaves) {
      this._spawnWaves = {
        name: "spawnWaves",
        Name: "SpawnWaves",
        number: 32,
        protoType: 11,
        protoName: "spawn_waves",
        isMap: true,
        keyType: JsonToString,
        valueType: dcei_engine_spawn_wave_proto.SpawnWave,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._spawnWaves;
  }
  get spawnPatternGroups() {
    if (!this._spawnPatternGroups) {
      this._spawnPatternGroups = {
        name: "spawnPatternGroups",
        Name: "SpawnPatternGroups",
        number: 33,
        protoType: 11,
        protoName: "spawn_pattern_groups",
        isMap: true,
        keyType: JsonToString,
        valueType: dcei_engine_spawn_pattern_proto.SpawnGroup,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._spawnPatternGroups;
  }
  get triggers() {
    if (!this._triggers) {
      this._triggers = {
        name: "triggers",
        Name: "Triggers",
        number: 41,
        protoType: 11,
        protoName: "triggers",
        isMap: true,
        keyType: JsonToString,
        valueType: dcei_engine_trigger_proto.Trigger,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._triggers;
  }
  get triggerGlobalVariables() {
    if (!this._triggerGlobalVariables) {
      this._triggerGlobalVariables = {
        name: "triggerGlobalVariables",
        Name: "TriggerGlobalVariables",
        number: 42,
        protoType: 11,
        protoName: "trigger_global_variables",
        isMap: true,
        keyType: JsonToString,
        valueType: dcei_engine_trigger_proto.VariableDefinition,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._triggerGlobalVariables;
  }
  get triggerCustomFunctions() {
    if (!this._triggerCustomFunctions) {
      this._triggerCustomFunctions = {
        name: "triggerCustomFunctions",
        Name: "TriggerCustomFunctions",
        number: 43,
        protoType: 11,
        protoName: "trigger_custom_functions",
        isMap: true,
        keyType: JsonToString,
        valueType: dcei_engine_trigger_proto.CustomFunctionDefinition,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._triggerCustomFunctions;
  }
  get triggerCustomTypes() {
    if (!this._triggerCustomTypes) {
      this._triggerCustomTypes = {
        name: "triggerCustomTypes",
        Name: "TriggerCustomTypes",
        number: 44,
        protoType: 11,
        protoName: "trigger_custom_types",
        isMap: true,
        keyType: JsonToString,
        valueType: dcei_engine_trigger_proto.CompositeTypeDefinition,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._triggerCustomTypes;
  }
  get localizationEntries() {
    if (!this._localizationEntries) {
      this._localizationEntries = {
        name: "localizationEntries",
        Name: "LocalizationEntries",
        number: 51,
        protoType: 11,
        protoName: "localization_entries",
        isMap: true,
        keyType: JsonToString,
        valueType: dcei_engine_localization_proto.LocalizationEntry,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._localizationEntries;
  }
  get userDataTypes() {
    if (!this._userDataTypes) {
      this._userDataTypes = {
        name: "userDataTypes",
        Name: "UserDataTypes",
        number: 61,
        protoType: 11,
        protoName: "user_data_types",
        isMap: true,
        keyType: JsonToString,
        valueType: dcei_engine_user_data_proto.UserDataObjectType,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._userDataTypes;
  }
  get userDataValues() {
    if (!this._userDataValues) {
      this._userDataValues = {
        name: "userDataValues",
        Name: "UserDataValues",
        number: 62,
        protoType: 11,
        protoName: "user_data_values",
        isMap: true,
        keyType: JsonToString,
        valueType: dcei_engine_user_data_proto.UserDataValue,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._userDataValues;
  }
  get settings() {
    if (!this._settings) {
      this._settings = {
        name: "settings",
        Name: "Settings",
        number: 101,
        protoType: 11,
        protoName: "settings",
        type: MapSettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._settings;
  }
  get playerSettings() {
    if (!this._playerSettings) {
      this._playerSettings = {
        name: "playerSettings",
        Name: "PlayerSettings",
        number: 102,
        protoType: 11,
        protoName: "player_settings",
        type: PlayerSettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerSettings;
  }
  get displaySettings() {
    if (!this._displaySettings) {
      this._displaySettings = {
        name: "displaySettings",
        Name: "DisplaySettings",
        number: 103,
        protoType: 11,
        protoName: "display_settings",
        type: DisplaySettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displaySettings;
  }
  get inputSettings() {
    if (!this._inputSettings) {
      this._inputSettings = {
        name: "inputSettings",
        Name: "InputSettings",
        number: 104,
        protoType: 11,
        protoName: "input_settings",
        type: InputSettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._inputSettings;
  }
  get graphicsSettings() {
    if (!this._graphicsSettings) {
      this._graphicsSettings = {
        name: "graphicsSettings",
        Name: "GraphicsSettings",
        number: 105,
        protoType: 11,
        protoName: "graphics_settings",
        type: GraphicsSettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._graphicsSettings;
  }
  get cameraSettings() {
    if (!this._cameraSettings) {
      this._cameraSettings = {
        name: "cameraSettings",
        Name: "CameraSettings",
        number: 110,
        protoType: 11,
        protoName: "camera_settings",
        type: dcei_engine_spawn_wave_proto.CameraSettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cameraSettings;
  }
  get musicSettings() {
    if (!this._musicSettings) {
      this._musicSettings = {
        name: "musicSettings",
        Name: "MusicSettings",
        number: 111,
        protoType: 11,
        protoName: "music_settings",
        type: MusicSettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._musicSettings;
  }
  get weatherSettings() {
    if (!this._weatherSettings) {
      this._weatherSettings = {
        name: "weatherSettings",
        Name: "WeatherSettings",
        number: 112,
        protoType: 11,
        protoName: "weather_settings",
        type: WeatherSettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._weatherSettings;
  }
  get triggerSettings() {
    if (!this._triggerSettings) {
      this._triggerSettings = {
        name: "triggerSettings",
        Name: "TriggerSettings",
        number: 113,
        protoType: 11,
        protoName: "trigger_settings",
        type: TriggerSettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._triggerSettings;
  }
  get fontSettings() {
    if (!this._fontSettings) {
      this._fontSettings = {
        name: "fontSettings",
        Name: "FontSettings",
        number: 121,
        protoType: 11,
        protoName: "font_settings",
        type: FontSettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._fontSettings;
  }
  get ingameSettings() {
    if (!this._ingameSettings) {
      this._ingameSettings = {
        name: "ingameSettings",
        Name: "IngameSettings",
        number: 201,
        protoType: 11,
        protoName: "ingame_settings",
        type: InGameSettings,
        options: {
          comments: "Used to customize a gameplay. Not part of saved data.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ingameSettings;
  }
  get customAssetSettings() {
    if (!this._customAssetSettings) {
      this._customAssetSettings = {
        name: "customAssetSettings",
        Name: "CustomAssetSettings",
        number: 211,
        protoType: 11,
        protoName: "custom_asset_settings",
        type: CustomAssetSettings,
        options: {
          comments: "Used to set custom asset while building",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._customAssetSettings;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.units,
        this.weapons,
        this.abilities,
        this.effects,
        this.behaviors,
        this.upgrades,
        this.movers,
        this.validators,
        this.expressions,
        this.dataUpgrades,
        this.actors,
        this.actorEventMacros,
        this.spawnPatterns,
        this.spawnWaves,
        this.spawnPatternGroups,
        this.triggers,
        this.triggerGlobalVariables,
        this.triggerCustomFunctions,
        this.triggerCustomTypes,
        this.localizationEntries,
        this.userDataTypes,
        this.userDataValues,
        this.settings,
        this.playerSettings,
        this.displaySettings,
        this.inputSettings,
        this.graphicsSettings,
        this.cameraSettings,
        this.musicSettings,
        this.weatherSettings,
        this.triggerSettings,
        this.fontSettings,
        this.ingameSettings,
        this.customAssetSettings,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForSettings",
        Name: "DummyOneofForSettings",
        fields: [
          this.fields[22],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPlayerSettings",
        Name: "DummyOneofForPlayerSettings",
        fields: [
          this.fields[23],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplaySettings",
        Name: "DummyOneofForDisplaySettings",
        fields: [
          this.fields[24],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForInputSettings",
        Name: "DummyOneofForInputSettings",
        fields: [
          this.fields[25],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGraphicsSettings",
        Name: "DummyOneofForGraphicsSettings",
        fields: [
          this.fields[26],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCameraSettings",
        Name: "DummyOneofForCameraSettings",
        fields: [
          this.fields[27],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMusicSettings",
        Name: "DummyOneofForMusicSettings",
        fields: [
          this.fields[28],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForWeatherSettings",
        Name: "DummyOneofForWeatherSettings",
        fields: [
          this.fields[29],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTriggerSettings",
        Name: "DummyOneofForTriggerSettings",
        fields: [
          this.fields[30],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFontSettings",
        Name: "DummyOneofForFontSettings",
        fields: [
          this.fields[31],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIngameSettings",
        Name: "DummyOneofForIngameSettings",
        fields: [
          this.fields[32],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCustomAssetSettings",
        Name: "DummyOneofForCustomAssetSettings",
        fields: [
          this.fields[33],
        ],
      });
    }
    return this._oneofs;
  }
}
DataFile.descriptor = new DataFile_Descriptor();
class InputSettings_KeyMapping {
  get descriptor() {
    return InputSettings_KeyMapping.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
    this._hasKey = false;
    this._key = null;
  }
  isEmpty() {
    if (this._hasName) return false;
    if (this._hasKey) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InputSettings_KeyMapping) {
      return value;
    }
    return InputSettings_KeyMapping.fromJson(value);
  }
  static fromJson(json) {
    const result = new InputSettings_KeyMapping();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    if (json.key != null) {
      result._hasKey = true;
      result._key = dcei_engine_input_keys_proto.KeyCode.fromJson(json.key);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._hasKey) {
      result.key = dcei_engine_input_keys_proto.KeyCode.toJson(this._key);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {number}
   */
  get key() {
    return this._hasKey ? this._key : dcei_engine_input_keys_proto.KeyCode.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InputSettings_KeyMapping(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new InputSettings_KeyMapping(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InputSettings_KeyMapping(this);
              copy._hasKey = true;
              copy._key = dcei_engine_input_keys_proto.KeyCode.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new InputSettings_KeyMapping(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InputSettings_KeyMapping} other
   * @returns {InputSettings_KeyMapping}
   */
  merge(other) {
    const copy = new InputSettings_KeyMapping(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    return copy;
  }
}
InputSettings_KeyMapping.default = new InputSettings_KeyMapping();
class InputSettings_KeyMapping_Builder {
  constructor(value) {
    this._value = new InputSettings_KeyMapping(value);
  }
  build() {
    return new InputSettings_KeyMapping(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
}
InputSettings_KeyMapping.Builder = InputSettings_KeyMapping_Builder;
class InputSettings_KeyMapping_WithParent {
  /**
   * @param {InputSettings_KeyMapping} value
   * @param {InputSettings_KeyMapping_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InputSettings_KeyMapping.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  update(current, parent) {
    const result = new InputSettings_KeyMapping_WithParent(current, parent);
    return result;
  }
}
InputSettings_KeyMapping_WithParent.default = new InputSettings_KeyMapping_WithParent(InputSettings_KeyMapping.default, null);
InputSettings_KeyMapping.WithParent = InputSettings_KeyMapping_WithParent;
class InputSettings_KeyMapping_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
          comments: "The name to use for the mapped key event (ex: \"shoot\").",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 2,
        protoType: 14,
        protoName: "key",
        type: dcei_engine_input_keys_proto.KeyCode,
        options: {
          comments: "The key mapped to this name.",
          ignorePrefix: "Alpha",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
        this.key,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
InputSettings_KeyMapping.descriptor = new InputSettings_KeyMapping_Descriptor();
export class InputSettings {
  get descriptor() {
    return InputSettings.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._keyMappings = [];
  }
  isEmpty() {
    if (this._keyMappings.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InputSettings) {
      return value;
    }
    return InputSettings.fromJson(value);
  }
  static fromJson(json) {
    const result = new InputSettings();
    result._keyMappings = JsonToList(json.keyMappings, InputSettings_KeyMapping);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._keyMappings.length > 0) {
      result.keyMappings = ArrayToJson(this._keyMappings, InputSettings_KeyMapping);
    }
    return result;
  }
  /**
   * @returns {InputSettings_KeyMapping[]}
   */
  get keyMappings() {
    return this._keyMappings;
  }
  addKeyMappings(path, value) {
    return {type: 'ADD', path: path.concat(['keyMappings']), value: value.toJson()};
  }
  setKeyMappings(path, value) {
    return {type: 'SET', path: path.concat(['keyMappings']), value: ArrayToJson(value, InputSettings_KeyMapping)};
  }
  setKeyMappingsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['keyMappings', key]), value: value.toJson()};
  }
  deleteKeyMappings(path) {
    return {type: 'DELETE', path: path.concat(['keyMappings'])};
  }
  deleteKeyMappingsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['keyMappings', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "keyMappings": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InputSettings(this);
              copy._keyMappings = [];        for (let i of value) {
                copy._keyMappings.push(InputSettings_KeyMapping.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InputSettings(this);
              copy._keyMappings = copy._keyMappings.concat([InputSettings_KeyMapping.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._keyMappings.length === 0) {
                return this;
              }
              const copy = new InputSettings(this);
              copy._keyMappings = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._keyMappings.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InputSettings(this);
              copy._keyMappings = copy._keyMappings.slice();
              copy._keyMappings[path[1]] = InputSettings_KeyMapping.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InputSettings(this);
              copy._keyMappings = copy._keyMappings.slice(0, path[1]).concat(copy._keyMappings.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._keyMappings.length) {
            return this;
          }
          const oldValue = this._keyMappings[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InputSettings(this);
          copy._keyMappings = copy._keyMappings.slice();
          copy._keyMappings[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InputSettings} other
   * @returns {InputSettings}
   */
  merge(other) {
    const copy = new InputSettings(this);
    copy._keyMappings = this._keyMappings.concat(other._keyMappings);
    return copy;
  }
}
InputSettings.default = new InputSettings();
InputSettings.KeyMapping = InputSettings_KeyMapping;
class InputSettings_Builder {
  constructor(value) {
    this._value = new InputSettings(value);
  }
  build() {
    return new InputSettings(this._value);
  }
  addAllKeyMappings(values) {
    this._value._keyMappings = this._value._keyMappings.concat(values);
    return this;
  }
  addKeyMappings(value) {
    this._value._keyMappings = this._value._keyMappings.concat([value]);
    return this;
  }
  setKeyMappings(index, value) {
    this._value._keyMappings = this._value._keyMappings.concat();
    this._value._keyMappings[index] = value;
    return this;
  }
  clearKeyMappings() {
    this._value._keyMappings = [];
    return this;
  }
}
InputSettings.Builder = InputSettings_Builder;
class InputSettings_WithParent {
  /**
   * @param {InputSettings} value
   * @param {InputSettings_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InputSettings.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfKeyMappings() {
    if (!this._selfKeyMappings) {
      this._selfKeyMappings = [];
      for (let i of this._value.keyMappings) {
        this._selfKeyMappings.push(new InputSettings_KeyMapping.WithParent(i, null));
      }
    }
    return this._selfKeyMappings;
  }
  get inherentKeyMappings() {
    if (!this._inherentKeyMappings) {
      this._inherentKeyMappings = this._parent ? this._parent.keyMappings : [];
    }
    return this._inherentKeyMappings;
  }
  get keyMappings() {
    if (!this._allKeyMappings) {
      this._allKeyMappings = this._parent ? this._parent.keyMappings.concat(this.selfKeyMappings) : this.selfKeyMappings;
    }
    return this._allKeyMappings;
  }
  update(current, parent) {
    const result = new InputSettings_WithParent(current, parent);
    if (this._selfKeyMappings) {
      if (this._value.keyMappings === current.keyMappings) {
        result._selfKeyMappings = this._selfKeyMappings;
      } else {
        result._selfKeyMappings = [];
        for (let i = 0; i < current.keyMappings.length; i++) {
          const oldValue = this._value.keyMappings[i];
          if (oldValue) {
            const oldCache = this._selfKeyMappings[i];
            if (oldValue === current.keyMappings[i]) {
              result._selfKeyMappings[i] = oldCache;
            } else {
              result._selfKeyMappings[i] = oldCache.update(current.keyMappings[i], null);
            }
          } else {
            result._selfKeyMappings[i] = new InputSettings_KeyMapping.WithParent(current.keyMappings[i], null);
          }
        }
      }
    }
    return result;
  }
}
InputSettings_WithParent.default = new InputSettings_WithParent(InputSettings.default, null);
InputSettings.WithParent = InputSettings_WithParent;
class InputSettings_Descriptor {
  get keyMappings() {
    if (!this._keyMappings) {
      this._keyMappings = {
        name: "keyMappings",
        Name: "KeyMappings",
        number: 1,
        protoType: 11,
        protoName: "key_mappings",
        type: InputSettings_KeyMapping,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._keyMappings;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.keyMappings,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
InputSettings.descriptor = new InputSettings_Descriptor();
class MapSettings_Type {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "MAP": return 0;
        case "DATA_MODULE": return 1;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return MapSettings_Type.fromJson(value);
  }
  static fromReact(e) {
    return MapSettings_Type.fromJson(e);
  }
}
MapSettings_Type.MAP = 0;
MapSettings_Type.DATA_MODULE = 1;
MapSettings_Type.default = 0;
MapSettings_Type.values = {
  MAP: 0,
  DATA_MODULE: 1,
};
MapSettings_Type.names = {
  0: "MAP",
  1: "DATA_MODULE",
};
export class MapSettings {
  get descriptor() {
    return MapSettings.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasIdentifier = false;
    this._identifier = null;
    this._hasVersion = false;
    this._version = null;
    this._hasDescription = false;
    this._description = null;
    this._hasType = false;
    this._type = null;
    this._dependencies = [];
    this._registryDependencies = [];
    this._deprecatedResolvedRegistryDependencies = [];
    this._transitionMaps = [];
    this._hasIsWildSkyLevel = false;
    this._isWildSkyLevel = null;
  }
  isEmpty() {
    if (this._hasIdentifier) return false;
    if (this._hasVersion) return false;
    if (this._hasDescription) return false;
    if (this._hasType) return false;
    if (this._dependencies.length > 0) return false;
    if (this._registryDependencies.length > 0) return false;
    if (this._deprecatedResolvedRegistryDependencies.length > 0) return false;
    if (this._transitionMaps.length > 0) return false;
    if (this._hasIsWildSkyLevel) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MapSettings) {
      return value;
    }
    return MapSettings.fromJson(value);
  }
  static fromJson(json) {
    const result = new MapSettings();
    if (json.identifier != null) {
      result._hasIdentifier = true;
      result._identifier = JsonToString.fromJson(json.identifier);
    }
    if (json.version != null) {
      result._hasVersion = true;
      result._version = JsonToString.fromJson(json.version);
    }
    if (json.description != null) {
      result._hasDescription = true;
      result._description = JsonToString.fromJson(json.description);
    }
    if (json.type != null) {
      result._hasType = true;
      result._type = MapSettings_Type.fromJson(json.type);
    }
    result._dependencies = JsonToList(json.dependencies, JsonToString);
    result._registryDependencies = JsonToList(json.registryDependencies, RegistryDependency);
    result._deprecatedResolvedRegistryDependencies = JsonToList(json.deprecatedResolvedRegistryDependencies, RegistryDependency);
    result._transitionMaps = JsonToList(json.transitionMaps, JsonToString);
    if (json.isWildSkyLevel != null) {
      result._hasIsWildSkyLevel = true;
      result._isWildSkyLevel = JsonToBoolean.fromJson(json.isWildSkyLevel);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasIdentifier) {
      result.identifier = JsonToString.toJson(this._identifier);
    }
    if (this._hasVersion) {
      result.version = JsonToString.toJson(this._version);
    }
    if (this._hasDescription) {
      result.description = JsonToString.toJson(this._description);
    }
    if (this._hasType) {
      result.type = MapSettings_Type.toJson(this._type);
    }
    if (this._dependencies.length > 0) {
      result.dependencies = ArrayToJson(this._dependencies, JsonToString);
    }
    if (this._registryDependencies.length > 0) {
      result.registryDependencies = ArrayToJson(this._registryDependencies, RegistryDependency);
    }
    if (this._deprecatedResolvedRegistryDependencies.length > 0) {
      result.deprecatedResolvedRegistryDependencies = ArrayToJson(this._deprecatedResolvedRegistryDependencies, RegistryDependency);
    }
    if (this._transitionMaps.length > 0) {
      result.transitionMaps = ArrayToJson(this._transitionMaps, JsonToString);
    }
    if (this._hasIsWildSkyLevel) {
      result.isWildSkyLevel = JsonToBoolean.toJson(this._isWildSkyLevel);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get identifier() {
    return this._hasIdentifier ? this._identifier : JsonToString.default;
  }
  get hasIdentifier() {
    return this._hasIdentifier;
  }
  setIdentifier(path, value) {
    return {type: 'SET', path: path.concat(['identifier']), value};
  }
  deleteIdentifier(path) {
    return {type: 'DELETE', path: path.concat(['identifier'])};
  }
  /**
   * @returns {string}
   */
  get version() {
    return this._hasVersion ? this._version : JsonToString.default;
  }
  get hasVersion() {
    return this._hasVersion;
  }
  setVersion(path, value) {
    return {type: 'SET', path: path.concat(['version']), value};
  }
  deleteVersion(path) {
    return {type: 'DELETE', path: path.concat(['version'])};
  }
  /**
   * @returns {string}
   */
  get description() {
    return this._hasDescription ? this._description : JsonToString.default;
  }
  get hasDescription() {
    return this._hasDescription;
  }
  setDescription(path, value) {
    return {type: 'SET', path: path.concat(['description']), value};
  }
  deleteDescription(path) {
    return {type: 'DELETE', path: path.concat(['description'])};
  }
  /**
   * @returns {number}
   */
  get type() {
    return this._hasType ? this._type : MapSettings_Type.default;
  }
  get hasType() {
    return this._hasType;
  }
  setType(path, value) {
    return {type: 'SET', path: path.concat(['type']), value};
  }
  deleteType(path) {
    return {type: 'DELETE', path: path.concat(['type'])};
  }
  /**
   * @returns {string[]}
   */
  get dependencies() {
    return this._dependencies;
  }
  addDependencies(path, value) {
    return {type: 'ADD', path: path.concat(['dependencies']), value};
  }
  setDependencies(path, value) {
    return {type: 'SET', path: path.concat(['dependencies']), value: ArrayToJson(value, JsonToString)};
  }
  setDependenciesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['dependencies', key]), value};
  }
  deleteDependencies(path) {
    return {type: 'DELETE', path: path.concat(['dependencies'])};
  }
  deleteDependenciesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['dependencies', key])};
  }
  /**
   * @returns {RegistryDependency[]}
   */
  get registryDependencies() {
    return this._registryDependencies;
  }
  addRegistryDependencies(path, value) {
    return {type: 'ADD', path: path.concat(['registryDependencies']), value: value.toJson()};
  }
  setRegistryDependencies(path, value) {
    return {type: 'SET', path: path.concat(['registryDependencies']), value: ArrayToJson(value, RegistryDependency)};
  }
  setRegistryDependenciesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['registryDependencies', key]), value: value.toJson()};
  }
  deleteRegistryDependencies(path) {
    return {type: 'DELETE', path: path.concat(['registryDependencies'])};
  }
  deleteRegistryDependenciesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['registryDependencies', key])};
  }
  /**
   * @returns {RegistryDependency[]}
   */
  get deprecatedResolvedRegistryDependencies() {
    return this._deprecatedResolvedRegistryDependencies;
  }
  addDeprecatedResolvedRegistryDependencies(path, value) {
    return {type: 'ADD', path: path.concat(['deprecatedResolvedRegistryDependencies']), value: value.toJson()};
  }
  setDeprecatedResolvedRegistryDependencies(path, value) {
    return {type: 'SET', path: path.concat(['deprecatedResolvedRegistryDependencies']), value: ArrayToJson(value, RegistryDependency)};
  }
  setDeprecatedResolvedRegistryDependenciesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['deprecatedResolvedRegistryDependencies', key]), value: value.toJson()};
  }
  deleteDeprecatedResolvedRegistryDependencies(path) {
    return {type: 'DELETE', path: path.concat(['deprecatedResolvedRegistryDependencies'])};
  }
  deleteDeprecatedResolvedRegistryDependenciesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['deprecatedResolvedRegistryDependencies', key])};
  }
  /**
   * @returns {string[]}
   */
  get transitionMaps() {
    return this._transitionMaps;
  }
  addTransitionMaps(path, value) {
    return {type: 'ADD', path: path.concat(['transitionMaps']), value};
  }
  setTransitionMaps(path, value) {
    return {type: 'SET', path: path.concat(['transitionMaps']), value: ArrayToJson(value, JsonToString)};
  }
  setTransitionMapsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['transitionMaps', key]), value};
  }
  deleteTransitionMaps(path) {
    return {type: 'DELETE', path: path.concat(['transitionMaps'])};
  }
  deleteTransitionMapsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['transitionMaps', key])};
  }
  /**
   * @returns {boolean}
   */
  get isWildSkyLevel() {
    return this._hasIsWildSkyLevel ? this._isWildSkyLevel : JsonToBoolean.default;
  }
  get hasIsWildSkyLevel() {
    return this._hasIsWildSkyLevel;
  }
  setIsWildSkyLevel(path, value) {
    return {type: 'SET', path: path.concat(['isWildSkyLevel']), value};
  }
  deleteIsWildSkyLevel(path) {
    return {type: 'DELETE', path: path.concat(['isWildSkyLevel'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "identifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapSettings(this);
              copy._hasIdentifier = true;
              copy._identifier = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIdentifier) {
                return this;
              }
              const copy = new MapSettings(this);
              copy._hasIdentifier = false;
              copy._identifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "version": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapSettings(this);
              copy._hasVersion = true;
              copy._version = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasVersion) {
                return this;
              }
              const copy = new MapSettings(this);
              copy._hasVersion = false;
              copy._version = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "description": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapSettings(this);
              copy._hasDescription = true;
              copy._description = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDescription) {
                return this;
              }
              const copy = new MapSettings(this);
              copy._hasDescription = false;
              copy._description = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "type": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapSettings(this);
              copy._hasType = true;
              copy._type = MapSettings_Type.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasType) {
                return this;
              }
              const copy = new MapSettings(this);
              copy._hasType = false;
              copy._type = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "dependencies": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapSettings(this);
              copy._dependencies = [];        for (let i of value) {
                copy._dependencies.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapSettings(this);
              copy._dependencies = copy._dependencies.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._dependencies.length === 0) {
                return this;
              }
              const copy = new MapSettings(this);
              copy._dependencies = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._dependencies.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapSettings(this);
              copy._dependencies = copy._dependencies.slice();
              copy._dependencies[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapSettings(this);
              copy._dependencies = copy._dependencies.slice(0, path[1]).concat(copy._dependencies.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._dependencies.length) {
            return this;
          }
          const oldValue = this._dependencies[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapSettings(this);
          copy._dependencies = copy._dependencies.slice();
          copy._dependencies[key] = newValue;
          return copy;
        }
      }
      case "registryDependencies": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapSettings(this);
              copy._registryDependencies = [];        for (let i of value) {
                copy._registryDependencies.push(RegistryDependency.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapSettings(this);
              copy._registryDependencies = copy._registryDependencies.concat([RegistryDependency.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._registryDependencies.length === 0) {
                return this;
              }
              const copy = new MapSettings(this);
              copy._registryDependencies = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._registryDependencies.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapSettings(this);
              copy._registryDependencies = copy._registryDependencies.slice();
              copy._registryDependencies[path[1]] = RegistryDependency.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapSettings(this);
              copy._registryDependencies = copy._registryDependencies.slice(0, path[1]).concat(copy._registryDependencies.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._registryDependencies.length) {
            return this;
          }
          const oldValue = this._registryDependencies[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapSettings(this);
          copy._registryDependencies = copy._registryDependencies.slice();
          copy._registryDependencies[key] = newValue;
          return copy;
        }
      }
      case "deprecatedResolvedRegistryDependencies": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapSettings(this);
              copy._deprecatedResolvedRegistryDependencies = [];        for (let i of value) {
                copy._deprecatedResolvedRegistryDependencies.push(RegistryDependency.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapSettings(this);
              copy._deprecatedResolvedRegistryDependencies = copy._deprecatedResolvedRegistryDependencies.concat([RegistryDependency.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._deprecatedResolvedRegistryDependencies.length === 0) {
                return this;
              }
              const copy = new MapSettings(this);
              copy._deprecatedResolvedRegistryDependencies = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._deprecatedResolvedRegistryDependencies.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapSettings(this);
              copy._deprecatedResolvedRegistryDependencies = copy._deprecatedResolvedRegistryDependencies.slice();
              copy._deprecatedResolvedRegistryDependencies[path[1]] = RegistryDependency.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapSettings(this);
              copy._deprecatedResolvedRegistryDependencies = copy._deprecatedResolvedRegistryDependencies.slice(0, path[1]).concat(copy._deprecatedResolvedRegistryDependencies.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._deprecatedResolvedRegistryDependencies.length) {
            return this;
          }
          const oldValue = this._deprecatedResolvedRegistryDependencies[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapSettings(this);
          copy._deprecatedResolvedRegistryDependencies = copy._deprecatedResolvedRegistryDependencies.slice();
          copy._deprecatedResolvedRegistryDependencies[key] = newValue;
          return copy;
        }
      }
      case "transitionMaps": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapSettings(this);
              copy._transitionMaps = [];        for (let i of value) {
                copy._transitionMaps.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MapSettings(this);
              copy._transitionMaps = copy._transitionMaps.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._transitionMaps.length === 0) {
                return this;
              }
              const copy = new MapSettings(this);
              copy._transitionMaps = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._transitionMaps.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MapSettings(this);
              copy._transitionMaps = copy._transitionMaps.slice();
              copy._transitionMaps[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MapSettings(this);
              copy._transitionMaps = copy._transitionMaps.slice(0, path[1]).concat(copy._transitionMaps.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._transitionMaps.length) {
            return this;
          }
          const oldValue = this._transitionMaps[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MapSettings(this);
          copy._transitionMaps = copy._transitionMaps.slice();
          copy._transitionMaps[key] = newValue;
          return copy;
        }
      }
      case "isWildSkyLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MapSettings(this);
              copy._hasIsWildSkyLevel = true;
              copy._isWildSkyLevel = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIsWildSkyLevel) {
                return this;
              }
              const copy = new MapSettings(this);
              copy._hasIsWildSkyLevel = false;
              copy._isWildSkyLevel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MapSettings} other
   * @returns {MapSettings}
   */
  merge(other) {
    const copy = new MapSettings(this);
    if (other._hasIdentifier) {
      copy._hasIdentifier = true;
      copy._identifier = other._identifier;
    }
    if (other._hasVersion) {
      copy._hasVersion = true;
      copy._version = other._version;
    }
    if (other._hasDescription) {
      copy._hasDescription = true;
      copy._description = other._description;
    }
    if (other._hasType) {
      copy._hasType = true;
      copy._type = other._type;
    }
    copy._dependencies = this._dependencies.concat(other._dependencies);
    copy._registryDependencies = this._registryDependencies.concat(other._registryDependencies);
    copy._deprecatedResolvedRegistryDependencies = this._deprecatedResolvedRegistryDependencies.concat(other._deprecatedResolvedRegistryDependencies);
    copy._transitionMaps = this._transitionMaps.concat(other._transitionMaps);
    if (other._hasIsWildSkyLevel) {
      copy._hasIsWildSkyLevel = true;
      copy._isWildSkyLevel = other._isWildSkyLevel;
    }
    return copy;
  }
}
MapSettings.default = new MapSettings();
MapSettings.Type = MapSettings_Type;
class MapSettings_Builder {
  constructor(value) {
    this._value = new MapSettings(value);
  }
  build() {
    return new MapSettings(this._value);
  }
  setIdentifier(value) {
    this._value._hasIdentifier = true;
    this._value._identifier = value;
    return this;
  }
  deleteIdentifier() {
    this._value._hasIdentifier = false;
    this._value._identifier = null;
    return this;
  }
  setVersion(value) {
    this._value._hasVersion = true;
    this._value._version = value;
    return this;
  }
  deleteVersion() {
    this._value._hasVersion = false;
    this._value._version = null;
    return this;
  }
  setDescription(value) {
    this._value._hasDescription = true;
    this._value._description = value;
    return this;
  }
  deleteDescription() {
    this._value._hasDescription = false;
    this._value._description = null;
    return this;
  }
  setType(value) {
    this._value._hasType = true;
    this._value._type = value;
    return this;
  }
  deleteType() {
    this._value._hasType = false;
    this._value._type = null;
    return this;
  }
  addAllDependencies(values) {
    this._value._dependencies = this._value._dependencies.concat(values);
    return this;
  }
  addDependencies(value) {
    this._value._dependencies = this._value._dependencies.concat([value]);
    return this;
  }
  setDependencies(index, value) {
    this._value._dependencies = this._value._dependencies.concat();
    this._value._dependencies[index] = value;
    return this;
  }
  clearDependencies() {
    this._value._dependencies = [];
    return this;
  }
  addAllRegistryDependencies(values) {
    this._value._registryDependencies = this._value._registryDependencies.concat(values);
    return this;
  }
  addRegistryDependencies(value) {
    this._value._registryDependencies = this._value._registryDependencies.concat([value]);
    return this;
  }
  setRegistryDependencies(index, value) {
    this._value._registryDependencies = this._value._registryDependencies.concat();
    this._value._registryDependencies[index] = value;
    return this;
  }
  clearRegistryDependencies() {
    this._value._registryDependencies = [];
    return this;
  }
  addAllDeprecatedResolvedRegistryDependencies(values) {
    this._value._deprecatedResolvedRegistryDependencies = this._value._deprecatedResolvedRegistryDependencies.concat(values);
    return this;
  }
  addDeprecatedResolvedRegistryDependencies(value) {
    this._value._deprecatedResolvedRegistryDependencies = this._value._deprecatedResolvedRegistryDependencies.concat([value]);
    return this;
  }
  setDeprecatedResolvedRegistryDependencies(index, value) {
    this._value._deprecatedResolvedRegistryDependencies = this._value._deprecatedResolvedRegistryDependencies.concat();
    this._value._deprecatedResolvedRegistryDependencies[index] = value;
    return this;
  }
  clearDeprecatedResolvedRegistryDependencies() {
    this._value._deprecatedResolvedRegistryDependencies = [];
    return this;
  }
  addAllTransitionMaps(values) {
    this._value._transitionMaps = this._value._transitionMaps.concat(values);
    return this;
  }
  addTransitionMaps(value) {
    this._value._transitionMaps = this._value._transitionMaps.concat([value]);
    return this;
  }
  setTransitionMaps(index, value) {
    this._value._transitionMaps = this._value._transitionMaps.concat();
    this._value._transitionMaps[index] = value;
    return this;
  }
  clearTransitionMaps() {
    this._value._transitionMaps = [];
    return this;
  }
  setIsWildSkyLevel(value) {
    this._value._hasIsWildSkyLevel = true;
    this._value._isWildSkyLevel = value;
    return this;
  }
  deleteIsWildSkyLevel() {
    this._value._hasIsWildSkyLevel = false;
    this._value._isWildSkyLevel = null;
    return this;
  }
}
MapSettings.Builder = MapSettings_Builder;
class MapSettings_WithParent {
  /**
   * @param {MapSettings} value
   * @param {MapSettings_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MapSettings.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasIdentifier() {
    if (this._cachedHasIdentifier === undefined) {
      if (this._value.hasIdentifier) {
        this._cachedHasIdentifier = true;
      } else {
        this._cachedHasIdentifier = this._parent ? this._parent.hasIdentifier : false;
      }
    }
    return this._cachedHasIdentifier;
  }
  get identifier() {
    if (this._cachedIdentifier === undefined) {
      if (this._value.hasIdentifier) {
        this._cachedIdentifier = this._value.identifier;
      } else {
        this._cachedIdentifier = this._parent ? this._parent.identifier : this._value.identifier;
      }
    }
    return this._cachedIdentifier;
  }
  get hasVersion() {
    if (this._cachedHasVersion === undefined) {
      if (this._value.hasVersion) {
        this._cachedHasVersion = true;
      } else {
        this._cachedHasVersion = this._parent ? this._parent.hasVersion : false;
      }
    }
    return this._cachedHasVersion;
  }
  get version() {
    if (this._cachedVersion === undefined) {
      if (this._value.hasVersion) {
        this._cachedVersion = this._value.version;
      } else {
        this._cachedVersion = this._parent ? this._parent.version : this._value.version;
      }
    }
    return this._cachedVersion;
  }
  get hasDescription() {
    if (this._cachedHasDescription === undefined) {
      if (this._value.hasDescription) {
        this._cachedHasDescription = true;
      } else {
        this._cachedHasDescription = this._parent ? this._parent.hasDescription : false;
      }
    }
    return this._cachedHasDescription;
  }
  get description() {
    if (this._cachedDescription === undefined) {
      if (this._value.hasDescription) {
        this._cachedDescription = this._value.description;
      } else {
        this._cachedDescription = this._parent ? this._parent.description : this._value.description;
      }
    }
    return this._cachedDescription;
  }
  get hasType() {
    if (this._cachedHasType === undefined) {
      if (this._value.hasType) {
        this._cachedHasType = true;
      } else {
        this._cachedHasType = this._parent ? this._parent.hasType : false;
      }
    }
    return this._cachedHasType;
  }
  get type() {
    if (this._cachedType === undefined) {
      if (this._value.hasType) {
        this._cachedType = this._value.type;
      } else {
        this._cachedType = this._parent ? this._parent.type : this._value.type;
      }
    }
    return this._cachedType;
  }
  get selfDependencies() {
    return this._value.dependencies;
  }
  get inherentDependencies() {
    if (!this._inherentDependencies) {
      this._inherentDependencies = this._parent ? this._parent.dependencies : [];
    }
    return this._inherentDependencies;
  }
  get dependencies() {
    if (!this._allDependencies) {
      this._allDependencies = this._parent ? this._parent.dependencies.concat(this.selfDependencies) : this.selfDependencies;
    }
    return this._allDependencies;
  }
  get selfRegistryDependencies() {
    if (!this._selfRegistryDependencies) {
      this._selfRegistryDependencies = [];
      for (let i of this._value.registryDependencies) {
        this._selfRegistryDependencies.push(new RegistryDependency.WithParent(i, null));
      }
    }
    return this._selfRegistryDependencies;
  }
  get inherentRegistryDependencies() {
    if (!this._inherentRegistryDependencies) {
      this._inherentRegistryDependencies = this._parent ? this._parent.registryDependencies : [];
    }
    return this._inherentRegistryDependencies;
  }
  get registryDependencies() {
    if (!this._allRegistryDependencies) {
      this._allRegistryDependencies = this._parent ? this._parent.registryDependencies.concat(this.selfRegistryDependencies) : this.selfRegistryDependencies;
    }
    return this._allRegistryDependencies;
  }
  get selfDeprecatedResolvedRegistryDependencies() {
    if (!this._selfDeprecatedResolvedRegistryDependencies) {
      this._selfDeprecatedResolvedRegistryDependencies = [];
      for (let i of this._value.deprecatedResolvedRegistryDependencies) {
        this._selfDeprecatedResolvedRegistryDependencies.push(new RegistryDependency.WithParent(i, null));
      }
    }
    return this._selfDeprecatedResolvedRegistryDependencies;
  }
  get inherentDeprecatedResolvedRegistryDependencies() {
    if (!this._inherentDeprecatedResolvedRegistryDependencies) {
      this._inherentDeprecatedResolvedRegistryDependencies = this._parent ? this._parent.deprecatedResolvedRegistryDependencies : [];
    }
    return this._inherentDeprecatedResolvedRegistryDependencies;
  }
  get deprecatedResolvedRegistryDependencies() {
    if (!this._allDeprecatedResolvedRegistryDependencies) {
      this._allDeprecatedResolvedRegistryDependencies = this._parent ? this._parent.deprecatedResolvedRegistryDependencies.concat(this.selfDeprecatedResolvedRegistryDependencies) : this.selfDeprecatedResolvedRegistryDependencies;
    }
    return this._allDeprecatedResolvedRegistryDependencies;
  }
  get selfTransitionMaps() {
    return this._value.transitionMaps;
  }
  get inherentTransitionMaps() {
    if (!this._inherentTransitionMaps) {
      this._inherentTransitionMaps = this._parent ? this._parent.transitionMaps : [];
    }
    return this._inherentTransitionMaps;
  }
  get transitionMaps() {
    if (!this._allTransitionMaps) {
      this._allTransitionMaps = this._parent ? this._parent.transitionMaps.concat(this.selfTransitionMaps) : this.selfTransitionMaps;
    }
    return this._allTransitionMaps;
  }
  get hasIsWildSkyLevel() {
    if (this._cachedHasIsWildSkyLevel === undefined) {
      if (this._value.hasIsWildSkyLevel) {
        this._cachedHasIsWildSkyLevel = true;
      } else {
        this._cachedHasIsWildSkyLevel = this._parent ? this._parent.hasIsWildSkyLevel : false;
      }
    }
    return this._cachedHasIsWildSkyLevel;
  }
  get isWildSkyLevel() {
    if (this._cachedIsWildSkyLevel === undefined) {
      if (this._value.hasIsWildSkyLevel) {
        this._cachedIsWildSkyLevel = this._value.isWildSkyLevel;
      } else {
        this._cachedIsWildSkyLevel = this._parent ? this._parent.isWildSkyLevel : this._value.isWildSkyLevel;
      }
    }
    return this._cachedIsWildSkyLevel;
  }
  update(current, parent) {
    const result = new MapSettings_WithParent(current, parent);
    if (this._selfRegistryDependencies) {
      if (this._value.registryDependencies === current.registryDependencies) {
        result._selfRegistryDependencies = this._selfRegistryDependencies;
      } else {
        result._selfRegistryDependencies = [];
        for (let i = 0; i < current.registryDependencies.length; i++) {
          const oldValue = this._value.registryDependencies[i];
          if (oldValue) {
            const oldCache = this._selfRegistryDependencies[i];
            if (oldValue === current.registryDependencies[i]) {
              result._selfRegistryDependencies[i] = oldCache;
            } else {
              result._selfRegistryDependencies[i] = oldCache.update(current.registryDependencies[i], null);
            }
          } else {
            result._selfRegistryDependencies[i] = new RegistryDependency.WithParent(current.registryDependencies[i], null);
          }
        }
      }
    }
    if (this._selfDeprecatedResolvedRegistryDependencies) {
      if (this._value.deprecatedResolvedRegistryDependencies === current.deprecatedResolvedRegistryDependencies) {
        result._selfDeprecatedResolvedRegistryDependencies = this._selfDeprecatedResolvedRegistryDependencies;
      } else {
        result._selfDeprecatedResolvedRegistryDependencies = [];
        for (let i = 0; i < current.deprecatedResolvedRegistryDependencies.length; i++) {
          const oldValue = this._value.deprecatedResolvedRegistryDependencies[i];
          if (oldValue) {
            const oldCache = this._selfDeprecatedResolvedRegistryDependencies[i];
            if (oldValue === current.deprecatedResolvedRegistryDependencies[i]) {
              result._selfDeprecatedResolvedRegistryDependencies[i] = oldCache;
            } else {
              result._selfDeprecatedResolvedRegistryDependencies[i] = oldCache.update(current.deprecatedResolvedRegistryDependencies[i], null);
            }
          } else {
            result._selfDeprecatedResolvedRegistryDependencies[i] = new RegistryDependency.WithParent(current.deprecatedResolvedRegistryDependencies[i], null);
          }
        }
      }
    }
    return result;
  }
}
MapSettings_WithParent.default = new MapSettings_WithParent(MapSettings.default, null);
MapSettings.WithParent = MapSettings_WithParent;
class MapSettings_Descriptor {
  get identifier() {
    if (!this._identifier) {
      this._identifier = {
        name: "identifier",
        Name: "Identifier",
        number: 5,
        protoType: 9,
        protoName: "identifier",
        type: JsonToString,
        options: {
          comments: "A globally unqiue name used to identify this module when uploading it to the module registry or importing it from the module registry.",
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._identifier;
  }
  get version() {
    if (!this._version) {
      this._version = {
        name: "version",
        Name: "Version",
        number: 3,
        protoType: 9,
        protoName: "version",
        type: JsonToString,
        options: {
          comments: "Version of the map (e.g., 1.2.3). Used when publishing the map.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._version;
  }
  get description() {
    if (!this._description) {
      this._description = {
        name: "description",
        Name: "Description",
        number: 8,
        protoType: 9,
        protoName: "description",
        type: JsonToString,
        options: {
          comments: "Description of the module which will be displayed on module registry.",
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._description;
  }
  get type() {
    if (!this._type) {
      this._type = {
        name: "type",
        Name: "Type",
        number: 1,
        protoType: 14,
        protoName: "type",
        type: MapSettings_Type,
        options: {
          comments: "Sets whether the game folder is a map or a mod.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._type;
  }
  get dependencies() {
    if (!this._dependencies) {
      this._dependencies = {
        name: "dependencies",
        Name: "Dependencies",
        number: 2,
        protoType: 9,
        protoName: "dependencies",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Defines which local dependency mods are used for this project.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dependencies;
  }
  get registryDependencies() {
    if (!this._registryDependencies) {
      this._registryDependencies = {
        name: "registryDependencies",
        Name: "RegistryDependencies",
        number: 6,
        protoType: 11,
        protoName: "registry_dependencies",
        type: RegistryDependency,
        isRepeated: true,
        options: {
          comments: "Defines which dependency mods from the module registry are used for this project.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._registryDependencies;
  }
  get deprecatedResolvedRegistryDependencies() {
    if (!this._deprecatedResolvedRegistryDependencies) {
      this._deprecatedResolvedRegistryDependencies = {
        name: "deprecatedResolvedRegistryDependencies",
        Name: "DeprecatedResolvedRegistryDependencies",
        number: 7,
        protoType: 11,
        protoName: "deprecated_resolved_registry_dependencies",
        type: RegistryDependency,
        isRepeated: true,
        options: {
          comments: "Editor would analysis registry dependencies and update this, then it would be consumed by engine, for choosing right version of dependencies. This would use latest version of dependencies possible.",
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._deprecatedResolvedRegistryDependencies;
  }
  get transitionMaps() {
    if (!this._transitionMaps) {
      this._transitionMaps = {
        name: "transitionMaps",
        Name: "TransitionMaps",
        number: 4,
        protoType: 9,
        protoName: "transition_maps",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._transitionMaps;
  }
  get isWildSkyLevel() {
    if (!this._isWildSkyLevel) {
      this._isWildSkyLevel = {
        name: "isWildSkyLevel",
        Name: "IsWildSkyLevel",
        number: 9,
        protoType: 8,
        protoName: "is_wild_sky_level",
        type: JsonToBoolean,
        options: {
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._isWildSkyLevel;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.identifier,
        this.version,
        this.description,
        this.type,
        this.dependencies,
        this.registryDependencies,
        this.deprecatedResolvedRegistryDependencies,
        this.transitionMaps,
        this.isWildSkyLevel,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForIdentifier",
        Name: "DummyOneofForIdentifier",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForVersion",
        Name: "DummyOneofForVersion",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDescription",
        Name: "DummyOneofForDescription",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForType",
        Name: "DummyOneofForType",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIsWildSkyLevel",
        Name: "DummyOneofForIsWildSkyLevel",
        fields: [
          this.fields[8],
        ],
      });
    }
    return this._oneofs;
  }
}
MapSettings.descriptor = new MapSettings_Descriptor();
export class RegistryDependency {
  get descriptor() {
    return RegistryDependency.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasIdentifier = false;
    this._identifier = null;
    this._hasVersion = false;
    this._version = null;
  }
  isEmpty() {
    if (this._hasIdentifier) return false;
    if (this._hasVersion) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof RegistryDependency) {
      return value;
    }
    return RegistryDependency.fromJson(value);
  }
  static fromJson(json) {
    const result = new RegistryDependency();
    if (json.identifier != null) {
      result._hasIdentifier = true;
      result._identifier = JsonToString.fromJson(json.identifier);
    }
    if (json.version != null) {
      result._hasVersion = true;
      result._version = JsonToString.fromJson(json.version);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasIdentifier) {
      result.identifier = JsonToString.toJson(this._identifier);
    }
    if (this._hasVersion) {
      result.version = JsonToString.toJson(this._version);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get identifier() {
    return this._hasIdentifier ? this._identifier : JsonToString.default;
  }
  get hasIdentifier() {
    return this._hasIdentifier;
  }
  setIdentifier(path, value) {
    return {type: 'SET', path: path.concat(['identifier']), value};
  }
  deleteIdentifier(path) {
    return {type: 'DELETE', path: path.concat(['identifier'])};
  }
  /**
   * @returns {string}
   */
  get version() {
    return this._hasVersion ? this._version : JsonToString.default;
  }
  get hasVersion() {
    return this._hasVersion;
  }
  setVersion(path, value) {
    return {type: 'SET', path: path.concat(['version']), value};
  }
  deleteVersion(path) {
    return {type: 'DELETE', path: path.concat(['version'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "identifier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RegistryDependency(this);
              copy._hasIdentifier = true;
              copy._identifier = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIdentifier) {
                return this;
              }
              const copy = new RegistryDependency(this);
              copy._hasIdentifier = false;
              copy._identifier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "version": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RegistryDependency(this);
              copy._hasVersion = true;
              copy._version = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasVersion) {
                return this;
              }
              const copy = new RegistryDependency(this);
              copy._hasVersion = false;
              copy._version = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {RegistryDependency} other
   * @returns {RegistryDependency}
   */
  merge(other) {
    const copy = new RegistryDependency(this);
    if (other._hasIdentifier) {
      copy._hasIdentifier = true;
      copy._identifier = other._identifier;
    }
    if (other._hasVersion) {
      copy._hasVersion = true;
      copy._version = other._version;
    }
    return copy;
  }
}
RegistryDependency.default = new RegistryDependency();
class RegistryDependency_Builder {
  constructor(value) {
    this._value = new RegistryDependency(value);
  }
  build() {
    return new RegistryDependency(this._value);
  }
  setIdentifier(value) {
    this._value._hasIdentifier = true;
    this._value._identifier = value;
    return this;
  }
  deleteIdentifier() {
    this._value._hasIdentifier = false;
    this._value._identifier = null;
    return this;
  }
  setVersion(value) {
    this._value._hasVersion = true;
    this._value._version = value;
    return this;
  }
  deleteVersion() {
    this._value._hasVersion = false;
    this._value._version = null;
    return this;
  }
}
RegistryDependency.Builder = RegistryDependency_Builder;
class RegistryDependency_WithParent {
  /**
   * @param {RegistryDependency} value
   * @param {RegistryDependency_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return RegistryDependency.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasIdentifier() {
    if (this._cachedHasIdentifier === undefined) {
      if (this._value.hasIdentifier) {
        this._cachedHasIdentifier = true;
      } else {
        this._cachedHasIdentifier = this._parent ? this._parent.hasIdentifier : false;
      }
    }
    return this._cachedHasIdentifier;
  }
  get identifier() {
    if (this._cachedIdentifier === undefined) {
      if (this._value.hasIdentifier) {
        this._cachedIdentifier = this._value.identifier;
      } else {
        this._cachedIdentifier = this._parent ? this._parent.identifier : this._value.identifier;
      }
    }
    return this._cachedIdentifier;
  }
  get hasVersion() {
    if (this._cachedHasVersion === undefined) {
      if (this._value.hasVersion) {
        this._cachedHasVersion = true;
      } else {
        this._cachedHasVersion = this._parent ? this._parent.hasVersion : false;
      }
    }
    return this._cachedHasVersion;
  }
  get version() {
    if (this._cachedVersion === undefined) {
      if (this._value.hasVersion) {
        this._cachedVersion = this._value.version;
      } else {
        this._cachedVersion = this._parent ? this._parent.version : this._value.version;
      }
    }
    return this._cachedVersion;
  }
  update(current, parent) {
    const result = new RegistryDependency_WithParent(current, parent);
    return result;
  }
}
RegistryDependency_WithParent.default = new RegistryDependency_WithParent(RegistryDependency.default, null);
RegistryDependency.WithParent = RegistryDependency_WithParent;
class RegistryDependency_Descriptor {
  get identifier() {
    if (!this._identifier) {
      this._identifier = {
        name: "identifier",
        Name: "Identifier",
        number: 1,
        protoType: 9,
        protoName: "identifier",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._identifier;
  }
  get version() {
    if (!this._version) {
      this._version = {
        name: "version",
        Name: "Version",
        number: 2,
        protoType: 9,
        protoName: "version",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._version;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.identifier,
        this.version,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForIdentifier",
        Name: "DummyOneofForIdentifier",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForVersion",
        Name: "DummyOneofForVersion",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
RegistryDependency.descriptor = new RegistryDependency_Descriptor();
export class PlayerSettings {
  get descriptor() {
    return PlayerSettings.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPlayerCount = false;
    this._playerCount = null;
  }
  isEmpty() {
    if (this._hasPlayerCount) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PlayerSettings) {
      return value;
    }
    return PlayerSettings.fromJson(value);
  }
  static fromJson(json) {
    const result = new PlayerSettings();
    if (json.playerCount != null) {
      result._hasPlayerCount = true;
      result._playerCount = JsonToInt32.fromJson(json.playerCount);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPlayerCount) {
      result.playerCount = JsonToInt32.toJson(this._playerCount);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get playerCount() {
    return this._hasPlayerCount ? this._playerCount : JsonToInt32.default;
  }
  get hasPlayerCount() {
    return this._hasPlayerCount;
  }
  setPlayerCount(path, value) {
    return {type: 'SET', path: path.concat(['playerCount']), value};
  }
  deletePlayerCount(path) {
    return {type: 'DELETE', path: path.concat(['playerCount'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "playerCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerSettings(this);
              copy._hasPlayerCount = true;
              copy._playerCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayerCount) {
                return this;
              }
              const copy = new PlayerSettings(this);
              copy._hasPlayerCount = false;
              copy._playerCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PlayerSettings} other
   * @returns {PlayerSettings}
   */
  merge(other) {
    const copy = new PlayerSettings(this);
    if (other._hasPlayerCount) {
      copy._hasPlayerCount = true;
      copy._playerCount = other._playerCount;
    }
    return copy;
  }
}
PlayerSettings.default = new PlayerSettings();
class PlayerSettings_Builder {
  constructor(value) {
    this._value = new PlayerSettings(value);
  }
  build() {
    return new PlayerSettings(this._value);
  }
  setPlayerCount(value) {
    this._value._hasPlayerCount = true;
    this._value._playerCount = value;
    return this;
  }
  deletePlayerCount() {
    this._value._hasPlayerCount = false;
    this._value._playerCount = null;
    return this;
  }
}
PlayerSettings.Builder = PlayerSettings_Builder;
class PlayerSettings_WithParent {
  /**
   * @param {PlayerSettings} value
   * @param {PlayerSettings_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PlayerSettings.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPlayerCount() {
    if (this._cachedHasPlayerCount === undefined) {
      if (this._value.hasPlayerCount) {
        this._cachedHasPlayerCount = true;
      } else {
        this._cachedHasPlayerCount = this._parent ? this._parent.hasPlayerCount : false;
      }
    }
    return this._cachedHasPlayerCount;
  }
  get playerCount() {
    if (this._cachedPlayerCount === undefined) {
      if (this._value.hasPlayerCount) {
        this._cachedPlayerCount = this._value.playerCount;
      } else {
        this._cachedPlayerCount = this._parent ? this._parent.playerCount : this._value.playerCount;
      }
    }
    return this._cachedPlayerCount;
  }
  update(current, parent) {
    const result = new PlayerSettings_WithParent(current, parent);
    return result;
  }
}
PlayerSettings_WithParent.default = new PlayerSettings_WithParent(PlayerSettings.default, null);
PlayerSettings.WithParent = PlayerSettings_WithParent;
class PlayerSettings_Descriptor {
  get playerCount() {
    if (!this._playerCount) {
      this._playerCount = {
        name: "playerCount",
        Name: "PlayerCount",
        number: 1,
        protoType: 5,
        protoName: "player_count",
        type: JsonToInt32,
        options: {
          comments: "Used to set the maximum number of players for multiplayer games.",
          default: 1,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerCount;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.playerCount,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPlayerCount",
        Name: "DummyOneofForPlayerCount",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
PlayerSettings.descriptor = new PlayerSettings_Descriptor();
class InGameSettings_TowerBuildLimit {
  get descriptor() {
    return InGameSettings_TowerBuildLimit.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCardId = false;
    this._cardId = null;
    this._hasBuildLimit = false;
    this._buildLimit = null;
    this._hasCardName = false;
    this._cardName = null;
  }
  isEmpty() {
    if (this._hasCardId) return false;
    if (this._hasBuildLimit) return false;
    if (this._hasCardName) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InGameSettings_TowerBuildLimit) {
      return value;
    }
    return InGameSettings_TowerBuildLimit.fromJson(value);
  }
  static fromJson(json) {
    const result = new InGameSettings_TowerBuildLimit();
    if (json.cardId != null) {
      result._hasCardId = true;
      result._cardId = JsonToInt32.fromJson(json.cardId);
    }
    if (json.buildLimit != null) {
      result._hasBuildLimit = true;
      result._buildLimit = JsonToInt32.fromJson(json.buildLimit);
    }
    if (json.cardName != null) {
      result._hasCardName = true;
      result._cardName = JsonToString.fromJson(json.cardName);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCardId) {
      result.cardId = JsonToInt32.toJson(this._cardId);
    }
    if (this._hasBuildLimit) {
      result.buildLimit = JsonToInt32.toJson(this._buildLimit);
    }
    if (this._hasCardName) {
      result.cardName = JsonToString.toJson(this._cardName);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get cardId() {
    return this._hasCardId ? this._cardId : JsonToInt32.default;
  }
  get hasCardId() {
    return this._hasCardId;
  }
  setCardId(path, value) {
    return {type: 'SET', path: path.concat(['cardId']), value};
  }
  deleteCardId(path) {
    return {type: 'DELETE', path: path.concat(['cardId'])};
  }
  /**
   * @returns {number}
   */
  get buildLimit() {
    return this._hasBuildLimit ? this._buildLimit : JsonToInt32.default;
  }
  get hasBuildLimit() {
    return this._hasBuildLimit;
  }
  setBuildLimit(path, value) {
    return {type: 'SET', path: path.concat(['buildLimit']), value};
  }
  deleteBuildLimit(path) {
    return {type: 'DELETE', path: path.concat(['buildLimit'])};
  }
  /**
   * @returns {string}
   */
  get cardName() {
    return this._hasCardName ? this._cardName : JsonToString.default;
  }
  get hasCardName() {
    return this._hasCardName;
  }
  setCardName(path, value) {
    return {type: 'SET', path: path.concat(['cardName']), value};
  }
  deleteCardName(path) {
    return {type: 'DELETE', path: path.concat(['cardName'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "cardId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InGameSettings_TowerBuildLimit(this);
              copy._hasCardId = true;
              copy._cardId = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardId) {
                return this;
              }
              const copy = new InGameSettings_TowerBuildLimit(this);
              copy._hasCardId = false;
              copy._cardId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "buildLimit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InGameSettings_TowerBuildLimit(this);
              copy._hasBuildLimit = true;
              copy._buildLimit = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBuildLimit) {
                return this;
              }
              const copy = new InGameSettings_TowerBuildLimit(this);
              copy._hasBuildLimit = false;
              copy._buildLimit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cardName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InGameSettings_TowerBuildLimit(this);
              copy._hasCardName = true;
              copy._cardName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardName) {
                return this;
              }
              const copy = new InGameSettings_TowerBuildLimit(this);
              copy._hasCardName = false;
              copy._cardName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InGameSettings_TowerBuildLimit} other
   * @returns {InGameSettings_TowerBuildLimit}
   */
  merge(other) {
    const copy = new InGameSettings_TowerBuildLimit(this);
    if (other._hasCardId) {
      copy._hasCardId = true;
      copy._cardId = other._cardId;
    }
    if (other._hasBuildLimit) {
      copy._hasBuildLimit = true;
      copy._buildLimit = other._buildLimit;
    }
    if (other._hasCardName) {
      copy._hasCardName = true;
      copy._cardName = other._cardName;
    }
    return copy;
  }
}
InGameSettings_TowerBuildLimit.default = new InGameSettings_TowerBuildLimit();
class InGameSettings_TowerBuildLimit_Builder {
  constructor(value) {
    this._value = new InGameSettings_TowerBuildLimit(value);
  }
  build() {
    return new InGameSettings_TowerBuildLimit(this._value);
  }
  setCardId(value) {
    this._value._hasCardId = true;
    this._value._cardId = value;
    return this;
  }
  deleteCardId() {
    this._value._hasCardId = false;
    this._value._cardId = null;
    return this;
  }
  setBuildLimit(value) {
    this._value._hasBuildLimit = true;
    this._value._buildLimit = value;
    return this;
  }
  deleteBuildLimit() {
    this._value._hasBuildLimit = false;
    this._value._buildLimit = null;
    return this;
  }
  setCardName(value) {
    this._value._hasCardName = true;
    this._value._cardName = value;
    return this;
  }
  deleteCardName() {
    this._value._hasCardName = false;
    this._value._cardName = null;
    return this;
  }
}
InGameSettings_TowerBuildLimit.Builder = InGameSettings_TowerBuildLimit_Builder;
class InGameSettings_TowerBuildLimit_WithParent {
  /**
   * @param {InGameSettings_TowerBuildLimit} value
   * @param {InGameSettings_TowerBuildLimit_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InGameSettings_TowerBuildLimit.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCardId() {
    if (this._cachedHasCardId === undefined) {
      if (this._value.hasCardId) {
        this._cachedHasCardId = true;
      } else {
        this._cachedHasCardId = this._parent ? this._parent.hasCardId : false;
      }
    }
    return this._cachedHasCardId;
  }
  get cardId() {
    if (this._cachedCardId === undefined) {
      if (this._value.hasCardId) {
        this._cachedCardId = this._value.cardId;
      } else {
        this._cachedCardId = this._parent ? this._parent.cardId : this._value.cardId;
      }
    }
    return this._cachedCardId;
  }
  get hasBuildLimit() {
    if (this._cachedHasBuildLimit === undefined) {
      if (this._value.hasBuildLimit) {
        this._cachedHasBuildLimit = true;
      } else {
        this._cachedHasBuildLimit = this._parent ? this._parent.hasBuildLimit : false;
      }
    }
    return this._cachedHasBuildLimit;
  }
  get buildLimit() {
    if (this._cachedBuildLimit === undefined) {
      if (this._value.hasBuildLimit) {
        this._cachedBuildLimit = this._value.buildLimit;
      } else {
        this._cachedBuildLimit = this._parent ? this._parent.buildLimit : this._value.buildLimit;
      }
    }
    return this._cachedBuildLimit;
  }
  get hasCardName() {
    if (this._cachedHasCardName === undefined) {
      if (this._value.hasCardName) {
        this._cachedHasCardName = true;
      } else {
        this._cachedHasCardName = this._parent ? this._parent.hasCardName : false;
      }
    }
    return this._cachedHasCardName;
  }
  get cardName() {
    if (this._cachedCardName === undefined) {
      if (this._value.hasCardName) {
        this._cachedCardName = this._value.cardName;
      } else {
        this._cachedCardName = this._parent ? this._parent.cardName : this._value.cardName;
      }
    }
    return this._cachedCardName;
  }
  update(current, parent) {
    const result = new InGameSettings_TowerBuildLimit_WithParent(current, parent);
    return result;
  }
}
InGameSettings_TowerBuildLimit_WithParent.default = new InGameSettings_TowerBuildLimit_WithParent(InGameSettings_TowerBuildLimit.default, null);
InGameSettings_TowerBuildLimit.WithParent = InGameSettings_TowerBuildLimit_WithParent;
class InGameSettings_TowerBuildLimit_Descriptor {
  get cardId() {
    if (!this._cardId) {
      this._cardId = {
        name: "cardId",
        Name: "CardId",
        number: 1,
        protoType: 5,
        protoName: "card_id",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardId;
  }
  get buildLimit() {
    if (!this._buildLimit) {
      this._buildLimit = {
        name: "buildLimit",
        Name: "BuildLimit",
        number: 2,
        protoType: 5,
        protoName: "build_limit",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._buildLimit;
  }
  get cardName() {
    if (!this._cardName) {
      this._cardName = {
        name: "cardName",
        Name: "CardName",
        number: 3,
        protoType: 9,
        protoName: "card_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardName;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.cardId,
        this.buildLimit,
        this.cardName,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCardId",
        Name: "DummyOneofForCardId",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBuildLimit",
        Name: "DummyOneofForBuildLimit",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCardName",
        Name: "DummyOneofForCardName",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
InGameSettings_TowerBuildLimit.descriptor = new InGameSettings_TowerBuildLimit_Descriptor();
export class InGameSettings {
  get descriptor() {
    return InGameSettings.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDefaultHero = false;
    this._defaultHero = null;
    this._towerBuildLimits = [];
    this._extraHeros = [];
  }
  isEmpty() {
    if (this._hasDefaultHero) return false;
    if (this._towerBuildLimits.length > 0) return false;
    if (this._extraHeros.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InGameSettings) {
      return value;
    }
    return InGameSettings.fromJson(value);
  }
  static fromJson(json) {
    const result = new InGameSettings();
    if (json.defaultHero != null) {
      result._hasDefaultHero = true;
      result._defaultHero = JsonToString.fromJson(json.defaultHero);
    }
    result._towerBuildLimits = JsonToList(json.towerBuildLimits, InGameSettings_TowerBuildLimit);
    result._extraHeros = JsonToList(json.extraHeros, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDefaultHero) {
      result.defaultHero = JsonToString.toJson(this._defaultHero);
    }
    if (this._towerBuildLimits.length > 0) {
      result.towerBuildLimits = ArrayToJson(this._towerBuildLimits, InGameSettings_TowerBuildLimit);
    }
    if (this._extraHeros.length > 0) {
      result.extraHeros = ArrayToJson(this._extraHeros, JsonToString);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get defaultHero() {
    return this._hasDefaultHero ? this._defaultHero : JsonToString.default;
  }
  get hasDefaultHero() {
    return this._hasDefaultHero;
  }
  setDefaultHero(path, value) {
    return {type: 'SET', path: path.concat(['defaultHero']), value};
  }
  deleteDefaultHero(path) {
    return {type: 'DELETE', path: path.concat(['defaultHero'])};
  }
  /**
   * @returns {InGameSettings_TowerBuildLimit[]}
   */
  get towerBuildLimits() {
    return this._towerBuildLimits;
  }
  addTowerBuildLimits(path, value) {
    return {type: 'ADD', path: path.concat(['towerBuildLimits']), value: value.toJson()};
  }
  setTowerBuildLimits(path, value) {
    return {type: 'SET', path: path.concat(['towerBuildLimits']), value: ArrayToJson(value, InGameSettings_TowerBuildLimit)};
  }
  setTowerBuildLimitsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['towerBuildLimits', key]), value: value.toJson()};
  }
  deleteTowerBuildLimits(path) {
    return {type: 'DELETE', path: path.concat(['towerBuildLimits'])};
  }
  deleteTowerBuildLimitsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['towerBuildLimits', key])};
  }
  /**
   * @returns {string[]}
   */
  get extraHeros() {
    return this._extraHeros;
  }
  addExtraHeros(path, value) {
    return {type: 'ADD', path: path.concat(['extraHeros']), value};
  }
  setExtraHeros(path, value) {
    return {type: 'SET', path: path.concat(['extraHeros']), value: ArrayToJson(value, JsonToString)};
  }
  setExtraHerosByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['extraHeros', key]), value};
  }
  deleteExtraHeros(path) {
    return {type: 'DELETE', path: path.concat(['extraHeros'])};
  }
  deleteExtraHerosByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['extraHeros', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "defaultHero": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InGameSettings(this);
              copy._hasDefaultHero = true;
              copy._defaultHero = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDefaultHero) {
                return this;
              }
              const copy = new InGameSettings(this);
              copy._hasDefaultHero = false;
              copy._defaultHero = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "towerBuildLimits": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InGameSettings(this);
              copy._towerBuildLimits = [];        for (let i of value) {
                copy._towerBuildLimits.push(InGameSettings_TowerBuildLimit.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InGameSettings(this);
              copy._towerBuildLimits = copy._towerBuildLimits.concat([InGameSettings_TowerBuildLimit.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._towerBuildLimits.length === 0) {
                return this;
              }
              const copy = new InGameSettings(this);
              copy._towerBuildLimits = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._towerBuildLimits.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InGameSettings(this);
              copy._towerBuildLimits = copy._towerBuildLimits.slice();
              copy._towerBuildLimits[path[1]] = InGameSettings_TowerBuildLimit.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InGameSettings(this);
              copy._towerBuildLimits = copy._towerBuildLimits.slice(0, path[1]).concat(copy._towerBuildLimits.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._towerBuildLimits.length) {
            return this;
          }
          const oldValue = this._towerBuildLimits[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InGameSettings(this);
          copy._towerBuildLimits = copy._towerBuildLimits.slice();
          copy._towerBuildLimits[key] = newValue;
          return copy;
        }
      }
      case "extraHeros": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InGameSettings(this);
              copy._extraHeros = [];        for (let i of value) {
                copy._extraHeros.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InGameSettings(this);
              copy._extraHeros = copy._extraHeros.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._extraHeros.length === 0) {
                return this;
              }
              const copy = new InGameSettings(this);
              copy._extraHeros = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._extraHeros.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InGameSettings(this);
              copy._extraHeros = copy._extraHeros.slice();
              copy._extraHeros[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InGameSettings(this);
              copy._extraHeros = copy._extraHeros.slice(0, path[1]).concat(copy._extraHeros.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._extraHeros.length) {
            return this;
          }
          const oldValue = this._extraHeros[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InGameSettings(this);
          copy._extraHeros = copy._extraHeros.slice();
          copy._extraHeros[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InGameSettings} other
   * @returns {InGameSettings}
   */
  merge(other) {
    const copy = new InGameSettings(this);
    if (other._hasDefaultHero) {
      copy._hasDefaultHero = true;
      copy._defaultHero = other._defaultHero;
    }
    copy._towerBuildLimits = this._towerBuildLimits.concat(other._towerBuildLimits);
    copy._extraHeros = this._extraHeros.concat(other._extraHeros);
    return copy;
  }
}
InGameSettings.default = new InGameSettings();
InGameSettings.TowerBuildLimit = InGameSettings_TowerBuildLimit;
class InGameSettings_Builder {
  constructor(value) {
    this._value = new InGameSettings(value);
  }
  build() {
    return new InGameSettings(this._value);
  }
  setDefaultHero(value) {
    this._value._hasDefaultHero = true;
    this._value._defaultHero = value;
    return this;
  }
  deleteDefaultHero() {
    this._value._hasDefaultHero = false;
    this._value._defaultHero = null;
    return this;
  }
  addAllTowerBuildLimits(values) {
    this._value._towerBuildLimits = this._value._towerBuildLimits.concat(values);
    return this;
  }
  addTowerBuildLimits(value) {
    this._value._towerBuildLimits = this._value._towerBuildLimits.concat([value]);
    return this;
  }
  setTowerBuildLimits(index, value) {
    this._value._towerBuildLimits = this._value._towerBuildLimits.concat();
    this._value._towerBuildLimits[index] = value;
    return this;
  }
  clearTowerBuildLimits() {
    this._value._towerBuildLimits = [];
    return this;
  }
  addAllExtraHeros(values) {
    this._value._extraHeros = this._value._extraHeros.concat(values);
    return this;
  }
  addExtraHeros(value) {
    this._value._extraHeros = this._value._extraHeros.concat([value]);
    return this;
  }
  setExtraHeros(index, value) {
    this._value._extraHeros = this._value._extraHeros.concat();
    this._value._extraHeros[index] = value;
    return this;
  }
  clearExtraHeros() {
    this._value._extraHeros = [];
    return this;
  }
}
InGameSettings.Builder = InGameSettings_Builder;
class InGameSettings_WithParent {
  /**
   * @param {InGameSettings} value
   * @param {InGameSettings_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InGameSettings.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDefaultHero() {
    if (this._cachedHasDefaultHero === undefined) {
      if (this._value.hasDefaultHero) {
        this._cachedHasDefaultHero = true;
      } else {
        this._cachedHasDefaultHero = this._parent ? this._parent.hasDefaultHero : false;
      }
    }
    return this._cachedHasDefaultHero;
  }
  get defaultHero() {
    if (this._cachedDefaultHero === undefined) {
      if (this._value.hasDefaultHero) {
        this._cachedDefaultHero = this._value.defaultHero;
      } else {
        this._cachedDefaultHero = this._parent ? this._parent.defaultHero : this._value.defaultHero;
      }
    }
    return this._cachedDefaultHero;
  }
  get selfTowerBuildLimits() {
    if (!this._selfTowerBuildLimits) {
      this._selfTowerBuildLimits = [];
      for (let i of this._value.towerBuildLimits) {
        this._selfTowerBuildLimits.push(new InGameSettings_TowerBuildLimit.WithParent(i, null));
      }
    }
    return this._selfTowerBuildLimits;
  }
  get inherentTowerBuildLimits() {
    if (!this._inherentTowerBuildLimits) {
      this._inherentTowerBuildLimits = this._parent ? this._parent.towerBuildLimits : [];
    }
    return this._inherentTowerBuildLimits;
  }
  get towerBuildLimits() {
    if (!this._allTowerBuildLimits) {
      this._allTowerBuildLimits = this._parent ? this._parent.towerBuildLimits.concat(this.selfTowerBuildLimits) : this.selfTowerBuildLimits;
    }
    return this._allTowerBuildLimits;
  }
  get selfExtraHeros() {
    return this._value.extraHeros;
  }
  get inherentExtraHeros() {
    if (!this._inherentExtraHeros) {
      this._inherentExtraHeros = this._parent ? this._parent.extraHeros : [];
    }
    return this._inherentExtraHeros;
  }
  get extraHeros() {
    if (!this._allExtraHeros) {
      this._allExtraHeros = this._parent ? this._parent.extraHeros.concat(this.selfExtraHeros) : this.selfExtraHeros;
    }
    return this._allExtraHeros;
  }
  update(current, parent) {
    const result = new InGameSettings_WithParent(current, parent);
    if (this._selfTowerBuildLimits) {
      if (this._value.towerBuildLimits === current.towerBuildLimits) {
        result._selfTowerBuildLimits = this._selfTowerBuildLimits;
      } else {
        result._selfTowerBuildLimits = [];
        for (let i = 0; i < current.towerBuildLimits.length; i++) {
          const oldValue = this._value.towerBuildLimits[i];
          if (oldValue) {
            const oldCache = this._selfTowerBuildLimits[i];
            if (oldValue === current.towerBuildLimits[i]) {
              result._selfTowerBuildLimits[i] = oldCache;
            } else {
              result._selfTowerBuildLimits[i] = oldCache.update(current.towerBuildLimits[i], null);
            }
          } else {
            result._selfTowerBuildLimits[i] = new InGameSettings_TowerBuildLimit.WithParent(current.towerBuildLimits[i], null);
          }
        }
      }
    }
    return result;
  }
}
InGameSettings_WithParent.default = new InGameSettings_WithParent(InGameSettings.default, null);
InGameSettings.WithParent = InGameSettings_WithParent;
class InGameSettings_Descriptor {
  get defaultHero() {
    if (!this._defaultHero) {
      this._defaultHero = {
        name: "defaultHero",
        Name: "DefaultHero",
        number: 1,
        protoType: 9,
        protoName: "default_hero",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._defaultHero;
  }
  get towerBuildLimits() {
    if (!this._towerBuildLimits) {
      this._towerBuildLimits = {
        name: "towerBuildLimits",
        Name: "TowerBuildLimits",
        number: 2,
        protoType: 11,
        protoName: "tower_build_limits",
        type: InGameSettings_TowerBuildLimit,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._towerBuildLimits;
  }
  get extraHeros() {
    if (!this._extraHeros) {
      this._extraHeros = {
        name: "extraHeros",
        Name: "ExtraHeros",
        number: 3,
        protoType: 9,
        protoName: "extra_heros",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "The other heros if more than one hero are available in this level.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._extraHeros;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.defaultHero,
        this.towerBuildLimits,
        this.extraHeros,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDefaultHero",
        Name: "DummyOneofForDefaultHero",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
InGameSettings.descriptor = new InGameSettings_Descriptor();
export class MusicSettings {
  get descriptor() {
    return MusicSettings.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._musicNames = [];
  }
  isEmpty() {
    if (this._musicNames.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof MusicSettings) {
      return value;
    }
    return MusicSettings.fromJson(value);
  }
  static fromJson(json) {
    const result = new MusicSettings();
    result._musicNames = JsonToList(json.musicNames, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._musicNames.length > 0) {
      result.musicNames = ArrayToJson(this._musicNames, JsonToString);
    }
    return result;
  }
  /**
   * @returns {string[]}
   */
  get musicNames() {
    return this._musicNames;
  }
  addMusicNames(path, value) {
    return {type: 'ADD', path: path.concat(['musicNames']), value};
  }
  setMusicNames(path, value) {
    return {type: 'SET', path: path.concat(['musicNames']), value: ArrayToJson(value, JsonToString)};
  }
  setMusicNamesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['musicNames', key]), value};
  }
  deleteMusicNames(path) {
    return {type: 'DELETE', path: path.concat(['musicNames'])};
  }
  deleteMusicNamesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['musicNames', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "musicNames": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new MusicSettings(this);
              copy._musicNames = [];        for (let i of value) {
                copy._musicNames.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new MusicSettings(this);
              copy._musicNames = copy._musicNames.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._musicNames.length === 0) {
                return this;
              }
              const copy = new MusicSettings(this);
              copy._musicNames = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._musicNames.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new MusicSettings(this);
              copy._musicNames = copy._musicNames.slice();
              copy._musicNames[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new MusicSettings(this);
              copy._musicNames = copy._musicNames.slice(0, path[1]).concat(copy._musicNames.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._musicNames.length) {
            return this;
          }
          const oldValue = this._musicNames[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new MusicSettings(this);
          copy._musicNames = copy._musicNames.slice();
          copy._musicNames[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {MusicSettings} other
   * @returns {MusicSettings}
   */
  merge(other) {
    const copy = new MusicSettings(this);
    copy._musicNames = this._musicNames.concat(other._musicNames);
    return copy;
  }
}
MusicSettings.default = new MusicSettings();
class MusicSettings_Builder {
  constructor(value) {
    this._value = new MusicSettings(value);
  }
  build() {
    return new MusicSettings(this._value);
  }
  addAllMusicNames(values) {
    this._value._musicNames = this._value._musicNames.concat(values);
    return this;
  }
  addMusicNames(value) {
    this._value._musicNames = this._value._musicNames.concat([value]);
    return this;
  }
  setMusicNames(index, value) {
    this._value._musicNames = this._value._musicNames.concat();
    this._value._musicNames[index] = value;
    return this;
  }
  clearMusicNames() {
    this._value._musicNames = [];
    return this;
  }
}
MusicSettings.Builder = MusicSettings_Builder;
class MusicSettings_WithParent {
  /**
   * @param {MusicSettings} value
   * @param {MusicSettings_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return MusicSettings.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfMusicNames() {
    return this._value.musicNames;
  }
  get inherentMusicNames() {
    if (!this._inherentMusicNames) {
      this._inherentMusicNames = this._parent ? this._parent.musicNames : [];
    }
    return this._inherentMusicNames;
  }
  get musicNames() {
    if (!this._allMusicNames) {
      this._allMusicNames = this._parent ? this._parent.musicNames.concat(this.selfMusicNames) : this.selfMusicNames;
    }
    return this._allMusicNames;
  }
  update(current, parent) {
    const result = new MusicSettings_WithParent(current, parent);
    return result;
  }
}
MusicSettings_WithParent.default = new MusicSettings_WithParent(MusicSettings.default, null);
MusicSettings.WithParent = MusicSettings_WithParent;
class MusicSettings_Descriptor {
  get musicNames() {
    if (!this._musicNames) {
      this._musicNames = {
        name: "musicNames",
        Name: "MusicNames",
        number: 1,
        protoType: 9,
        protoName: "music_names",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "A list of soundtracks that can be played during the game. The first song listed will be used as the game\'s default track.",
          valueDropdown: "SupportedMusicNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._musicNames;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.musicNames,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
MusicSettings.descriptor = new MusicSettings_Descriptor();
class WeatherSettings_Time {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NOON": return 0;
        case "NIGHT": return 1;
        case "VOID": return 2;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return WeatherSettings_Time.fromJson(value);
  }
  static fromReact(e) {
    return WeatherSettings_Time.fromJson(e);
  }
}
WeatherSettings_Time.NOON = 0;
WeatherSettings_Time.NIGHT = 1;
WeatherSettings_Time.VOID = 2;
WeatherSettings_Time.default = 0;
WeatherSettings_Time.values = {
  NOON: 0,
  NIGHT: 1,
  VOID: 2,
};
WeatherSettings_Time.names = {
  0: "NOON",
  1: "NIGHT",
  2: "VOID",
};
class WeatherSettings_Weather {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NORMAL": return 0;
        case "RAIN": return 1;
        case "SNOW": return 2;
        case "HEATWAVE": return 3;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return WeatherSettings_Weather.fromJson(value);
  }
  static fromReact(e) {
    return WeatherSettings_Weather.fromJson(e);
  }
}
WeatherSettings_Weather.NORMAL = 0;
WeatherSettings_Weather.RAIN = 1;
WeatherSettings_Weather.SNOW = 2;
WeatherSettings_Weather.HEATWAVE = 3;
WeatherSettings_Weather.default = 0;
WeatherSettings_Weather.values = {
  NORMAL: 0,
  RAIN: 1,
  SNOW: 2,
  HEATWAVE: 3,
};
WeatherSettings_Weather.names = {
  0: "NORMAL",
  1: "RAIN",
  2: "SNOW",
  3: "HEATWAVE",
};
export class WeatherSettings {
  get descriptor() {
    return WeatherSettings.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasHasRain = false;
    this._hasRain = null;
    this._hasHasSnow = false;
    this._hasSnow = null;
    this._hasHasCloud = false;
    this._hasCloud = null;
    this._hasHasVoidStar = false;
    this._hasVoidStar = null;
    this._hasTime = false;
    this._time = null;
    this._hasWeather = false;
    this._weather = null;
  }
  isEmpty() {
    if (this._hasHasRain) return false;
    if (this._hasHasSnow) return false;
    if (this._hasHasCloud) return false;
    if (this._hasHasVoidStar) return false;
    if (this._hasTime) return false;
    if (this._hasWeather) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof WeatherSettings) {
      return value;
    }
    return WeatherSettings.fromJson(value);
  }
  static fromJson(json) {
    const result = new WeatherSettings();
    if (json.hasRain != null) {
      result._hasHasRain = true;
      result._hasRain = JsonToBoolean.fromJson(json.hasRain);
    }
    if (json.hasSnow != null) {
      result._hasHasSnow = true;
      result._hasSnow = JsonToBoolean.fromJson(json.hasSnow);
    }
    if (json.hasCloud != null) {
      result._hasHasCloud = true;
      result._hasCloud = JsonToBoolean.fromJson(json.hasCloud);
    }
    if (json.hasVoidStar != null) {
      result._hasHasVoidStar = true;
      result._hasVoidStar = JsonToBoolean.fromJson(json.hasVoidStar);
    }
    if (json.time != null) {
      result._hasTime = true;
      result._time = WeatherSettings_Time.fromJson(json.time);
    }
    if (json.weather != null) {
      result._hasWeather = true;
      result._weather = WeatherSettings_Weather.fromJson(json.weather);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasHasRain) {
      result.hasRain = JsonToBoolean.toJson(this._hasRain);
    }
    if (this._hasHasSnow) {
      result.hasSnow = JsonToBoolean.toJson(this._hasSnow);
    }
    if (this._hasHasCloud) {
      result.hasCloud = JsonToBoolean.toJson(this._hasCloud);
    }
    if (this._hasHasVoidStar) {
      result.hasVoidStar = JsonToBoolean.toJson(this._hasVoidStar);
    }
    if (this._hasTime) {
      result.time = WeatherSettings_Time.toJson(this._time);
    }
    if (this._hasWeather) {
      result.weather = WeatherSettings_Weather.toJson(this._weather);
    }
    return result;
  }
  /**
   * @returns {boolean}
   */
  get hasRain() {
    return this._hasHasRain ? this._hasRain : JsonToBoolean.default;
  }
  get hasHasRain() {
    return this._hasHasRain;
  }
  setHasRain(path, value) {
    return {type: 'SET', path: path.concat(['hasRain']), value};
  }
  deleteHasRain(path) {
    return {type: 'DELETE', path: path.concat(['hasRain'])};
  }
  /**
   * @returns {boolean}
   */
  get hasSnow() {
    return this._hasHasSnow ? this._hasSnow : JsonToBoolean.default;
  }
  get hasHasSnow() {
    return this._hasHasSnow;
  }
  setHasSnow(path, value) {
    return {type: 'SET', path: path.concat(['hasSnow']), value};
  }
  deleteHasSnow(path) {
    return {type: 'DELETE', path: path.concat(['hasSnow'])};
  }
  /**
   * @returns {boolean}
   */
  get hasCloud() {
    return this._hasHasCloud ? this._hasCloud : JsonToBoolean.default;
  }
  get hasHasCloud() {
    return this._hasHasCloud;
  }
  setHasCloud(path, value) {
    return {type: 'SET', path: path.concat(['hasCloud']), value};
  }
  deleteHasCloud(path) {
    return {type: 'DELETE', path: path.concat(['hasCloud'])};
  }
  /**
   * @returns {boolean}
   */
  get hasVoidStar() {
    return this._hasHasVoidStar ? this._hasVoidStar : JsonToBoolean.default;
  }
  get hasHasVoidStar() {
    return this._hasHasVoidStar;
  }
  setHasVoidStar(path, value) {
    return {type: 'SET', path: path.concat(['hasVoidStar']), value};
  }
  deleteHasVoidStar(path) {
    return {type: 'DELETE', path: path.concat(['hasVoidStar'])};
  }
  /**
   * @returns {number}
   */
  get time() {
    return this._hasTime ? this._time : WeatherSettings_Time.default;
  }
  get hasTime() {
    return this._hasTime;
  }
  setTime(path, value) {
    return {type: 'SET', path: path.concat(['time']), value};
  }
  deleteTime(path) {
    return {type: 'DELETE', path: path.concat(['time'])};
  }
  /**
   * @returns {number}
   */
  get weather() {
    return this._hasWeather ? this._weather : WeatherSettings_Weather.default;
  }
  get hasWeather() {
    return this._hasWeather;
  }
  setWeather(path, value) {
    return {type: 'SET', path: path.concat(['weather']), value};
  }
  deleteWeather(path) {
    return {type: 'DELETE', path: path.concat(['weather'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "hasRain": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WeatherSettings(this);
              copy._hasHasRain = true;
              copy._hasRain = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHasRain) {
                return this;
              }
              const copy = new WeatherSettings(this);
              copy._hasHasRain = false;
              copy._hasRain = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "hasSnow": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WeatherSettings(this);
              copy._hasHasSnow = true;
              copy._hasSnow = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHasSnow) {
                return this;
              }
              const copy = new WeatherSettings(this);
              copy._hasHasSnow = false;
              copy._hasSnow = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "hasCloud": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WeatherSettings(this);
              copy._hasHasCloud = true;
              copy._hasCloud = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHasCloud) {
                return this;
              }
              const copy = new WeatherSettings(this);
              copy._hasHasCloud = false;
              copy._hasCloud = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "hasVoidStar": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WeatherSettings(this);
              copy._hasHasVoidStar = true;
              copy._hasVoidStar = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHasVoidStar) {
                return this;
              }
              const copy = new WeatherSettings(this);
              copy._hasHasVoidStar = false;
              copy._hasVoidStar = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "time": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WeatherSettings(this);
              copy._hasTime = true;
              copy._time = WeatherSettings_Time.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTime) {
                return this;
              }
              const copy = new WeatherSettings(this);
              copy._hasTime = false;
              copy._time = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "weather": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new WeatherSettings(this);
              copy._hasWeather = true;
              copy._weather = WeatherSettings_Weather.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWeather) {
                return this;
              }
              const copy = new WeatherSettings(this);
              copy._hasWeather = false;
              copy._weather = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {WeatherSettings} other
   * @returns {WeatherSettings}
   */
  merge(other) {
    const copy = new WeatherSettings(this);
    if (other._hasHasRain) {
      copy._hasHasRain = true;
      copy._hasRain = other._hasRain;
    }
    if (other._hasHasSnow) {
      copy._hasHasSnow = true;
      copy._hasSnow = other._hasSnow;
    }
    if (other._hasHasCloud) {
      copy._hasHasCloud = true;
      copy._hasCloud = other._hasCloud;
    }
    if (other._hasHasVoidStar) {
      copy._hasHasVoidStar = true;
      copy._hasVoidStar = other._hasVoidStar;
    }
    if (other._hasTime) {
      copy._hasTime = true;
      copy._time = other._time;
    }
    if (other._hasWeather) {
      copy._hasWeather = true;
      copy._weather = other._weather;
    }
    return copy;
  }
}
WeatherSettings.default = new WeatherSettings();
WeatherSettings.Time = WeatherSettings_Time;
WeatherSettings.Weather = WeatherSettings_Weather;
class WeatherSettings_Builder {
  constructor(value) {
    this._value = new WeatherSettings(value);
  }
  build() {
    return new WeatherSettings(this._value);
  }
  setHasRain(value) {
    this._value._hasHasRain = true;
    this._value._hasRain = value;
    return this;
  }
  deleteHasRain() {
    this._value._hasHasRain = false;
    this._value._hasRain = null;
    return this;
  }
  setHasSnow(value) {
    this._value._hasHasSnow = true;
    this._value._hasSnow = value;
    return this;
  }
  deleteHasSnow() {
    this._value._hasHasSnow = false;
    this._value._hasSnow = null;
    return this;
  }
  setHasCloud(value) {
    this._value._hasHasCloud = true;
    this._value._hasCloud = value;
    return this;
  }
  deleteHasCloud() {
    this._value._hasHasCloud = false;
    this._value._hasCloud = null;
    return this;
  }
  setHasVoidStar(value) {
    this._value._hasHasVoidStar = true;
    this._value._hasVoidStar = value;
    return this;
  }
  deleteHasVoidStar() {
    this._value._hasHasVoidStar = false;
    this._value._hasVoidStar = null;
    return this;
  }
  setTime(value) {
    this._value._hasTime = true;
    this._value._time = value;
    return this;
  }
  deleteTime() {
    this._value._hasTime = false;
    this._value._time = null;
    return this;
  }
  setWeather(value) {
    this._value._hasWeather = true;
    this._value._weather = value;
    return this;
  }
  deleteWeather() {
    this._value._hasWeather = false;
    this._value._weather = null;
    return this;
  }
}
WeatherSettings.Builder = WeatherSettings_Builder;
class WeatherSettings_WithParent {
  /**
   * @param {WeatherSettings} value
   * @param {WeatherSettings_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return WeatherSettings.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasHasRain() {
    if (this._cachedHasHasRain === undefined) {
      if (this._value.hasHasRain) {
        this._cachedHasHasRain = true;
      } else {
        this._cachedHasHasRain = this._parent ? this._parent.hasHasRain : false;
      }
    }
    return this._cachedHasHasRain;
  }
  get hasRain() {
    if (this._cachedHasRain === undefined) {
      if (this._value.hasHasRain) {
        this._cachedHasRain = this._value.hasRain;
      } else {
        this._cachedHasRain = this._parent ? this._parent.hasRain : this._value.hasRain;
      }
    }
    return this._cachedHasRain;
  }
  get hasHasSnow() {
    if (this._cachedHasHasSnow === undefined) {
      if (this._value.hasHasSnow) {
        this._cachedHasHasSnow = true;
      } else {
        this._cachedHasHasSnow = this._parent ? this._parent.hasHasSnow : false;
      }
    }
    return this._cachedHasHasSnow;
  }
  get hasSnow() {
    if (this._cachedHasSnow === undefined) {
      if (this._value.hasHasSnow) {
        this._cachedHasSnow = this._value.hasSnow;
      } else {
        this._cachedHasSnow = this._parent ? this._parent.hasSnow : this._value.hasSnow;
      }
    }
    return this._cachedHasSnow;
  }
  get hasHasCloud() {
    if (this._cachedHasHasCloud === undefined) {
      if (this._value.hasHasCloud) {
        this._cachedHasHasCloud = true;
      } else {
        this._cachedHasHasCloud = this._parent ? this._parent.hasHasCloud : false;
      }
    }
    return this._cachedHasHasCloud;
  }
  get hasCloud() {
    if (this._cachedHasCloud === undefined) {
      if (this._value.hasHasCloud) {
        this._cachedHasCloud = this._value.hasCloud;
      } else {
        this._cachedHasCloud = this._parent ? this._parent.hasCloud : this._value.hasCloud;
      }
    }
    return this._cachedHasCloud;
  }
  get hasHasVoidStar() {
    if (this._cachedHasHasVoidStar === undefined) {
      if (this._value.hasHasVoidStar) {
        this._cachedHasHasVoidStar = true;
      } else {
        this._cachedHasHasVoidStar = this._parent ? this._parent.hasHasVoidStar : false;
      }
    }
    return this._cachedHasHasVoidStar;
  }
  get hasVoidStar() {
    if (this._cachedHasVoidStar === undefined) {
      if (this._value.hasHasVoidStar) {
        this._cachedHasVoidStar = this._value.hasVoidStar;
      } else {
        this._cachedHasVoidStar = this._parent ? this._parent.hasVoidStar : this._value.hasVoidStar;
      }
    }
    return this._cachedHasVoidStar;
  }
  get hasTime() {
    if (this._cachedHasTime === undefined) {
      if (this._value.hasTime) {
        this._cachedHasTime = true;
      } else {
        this._cachedHasTime = this._parent ? this._parent.hasTime : false;
      }
    }
    return this._cachedHasTime;
  }
  get time() {
    if (this._cachedTime === undefined) {
      if (this._value.hasTime) {
        this._cachedTime = this._value.time;
      } else {
        this._cachedTime = this._parent ? this._parent.time : this._value.time;
      }
    }
    return this._cachedTime;
  }
  get hasWeather() {
    if (this._cachedHasWeather === undefined) {
      if (this._value.hasWeather) {
        this._cachedHasWeather = true;
      } else {
        this._cachedHasWeather = this._parent ? this._parent.hasWeather : false;
      }
    }
    return this._cachedHasWeather;
  }
  get weather() {
    if (this._cachedWeather === undefined) {
      if (this._value.hasWeather) {
        this._cachedWeather = this._value.weather;
      } else {
        this._cachedWeather = this._parent ? this._parent.weather : this._value.weather;
      }
    }
    return this._cachedWeather;
  }
  update(current, parent) {
    const result = new WeatherSettings_WithParent(current, parent);
    return result;
  }
}
WeatherSettings_WithParent.default = new WeatherSettings_WithParent(WeatherSettings.default, null);
WeatherSettings.WithParent = WeatherSettings_WithParent;
class WeatherSettings_Descriptor {
  get hasRain() {
    if (!this._hasRain) {
      this._hasRain = {
        name: "hasRain",
        Name: "HasRain",
        number: 1,
        protoType: 8,
        protoName: "has_rain",
        type: JsonToBoolean,
        options: {
          comments: "Allows the rain effect to be used.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hasRain;
  }
  get hasSnow() {
    if (!this._hasSnow) {
      this._hasSnow = {
        name: "hasSnow",
        Name: "HasSnow",
        number: 2,
        protoType: 8,
        protoName: "has_snow",
        type: JsonToBoolean,
        options: {
          comments: "Allows the snow effect to be used.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hasSnow;
  }
  get hasCloud() {
    if (!this._hasCloud) {
      this._hasCloud = {
        name: "hasCloud",
        Name: "HasCloud",
        number: 3,
        protoType: 8,
        protoName: "has_cloud",
        type: JsonToBoolean,
        options: {
          comments: "Allows the cloud background effect to be used.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hasCloud;
  }
  get hasVoidStar() {
    if (!this._hasVoidStar) {
      this._hasVoidStar = {
        name: "hasVoidStar",
        Name: "HasVoidStar",
        number: 4,
        protoType: 8,
        protoName: "has_void_star",
        type: JsonToBoolean,
        options: {
          comments: "Allows the void star background effect to be used.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hasVoidStar;
  }
  get time() {
    if (!this._time) {
      this._time = {
        name: "time",
        Name: "Time",
        number: 5,
        protoType: 14,
        protoName: "time",
        type: WeatherSettings_Time,
        options: {
          comments: "Sets the game\'s initial lighting settings.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._time;
  }
  get weather() {
    if (!this._weather) {
      this._weather = {
        name: "weather",
        Name: "Weather",
        number: 6,
        protoType: 14,
        protoName: "weather",
        type: WeatherSettings_Weather,
        options: {
          comments: "Sets the game\'s initial weather settings.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._weather;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.hasRain,
        this.hasSnow,
        this.hasCloud,
        this.hasVoidStar,
        this.time,
        this.weather,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForHasRain",
        Name: "DummyOneofForHasRain",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHasSnow",
        Name: "DummyOneofForHasSnow",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHasCloud",
        Name: "DummyOneofForHasCloud",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHasVoidStar",
        Name: "DummyOneofForHasVoidStar",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTime",
        Name: "DummyOneofForTime",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForWeather",
        Name: "DummyOneofForWeather",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
WeatherSettings.descriptor = new WeatherSettings_Descriptor();
export class TriggerSettings {
  get descriptor() {
    return TriggerSettings.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._usedUnits = [];
    this._usedEffects = [];
    this._usedBehaviors = [];
    this._usedUpgrades = [];
    this._usedTags = [];
    this._usedSoundAssets = [];
    this._usedAtlasAssets = [];
    this._usedSpriteAssets = [];
    this._usedFontAssets = [];
  }
  isEmpty() {
    if (this._usedUnits.length > 0) return false;
    if (this._usedEffects.length > 0) return false;
    if (this._usedBehaviors.length > 0) return false;
    if (this._usedUpgrades.length > 0) return false;
    if (this._usedTags.length > 0) return false;
    if (this._usedSoundAssets.length > 0) return false;
    if (this._usedAtlasAssets.length > 0) return false;
    if (this._usedSpriteAssets.length > 0) return false;
    if (this._usedFontAssets.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TriggerSettings) {
      return value;
    }
    return TriggerSettings.fromJson(value);
  }
  static fromJson(json) {
    const result = new TriggerSettings();
    result._usedUnits = JsonToList(json.usedUnits, JsonToString);
    result._usedEffects = JsonToList(json.usedEffects, JsonToString);
    result._usedBehaviors = JsonToList(json.usedBehaviors, JsonToString);
    result._usedUpgrades = JsonToList(json.usedUpgrades, JsonToString);
    result._usedTags = JsonToList(json.usedTags, JsonToString);
    result._usedSoundAssets = JsonToList(json.usedSoundAssets, JsonToString);
    result._usedAtlasAssets = JsonToList(json.usedAtlasAssets, JsonToString);
    result._usedSpriteAssets = JsonToList(json.usedSpriteAssets, JsonToString);
    result._usedFontAssets = JsonToList(json.usedFontAssets, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._usedUnits.length > 0) {
      result.usedUnits = ArrayToJson(this._usedUnits, JsonToString);
    }
    if (this._usedEffects.length > 0) {
      result.usedEffects = ArrayToJson(this._usedEffects, JsonToString);
    }
    if (this._usedBehaviors.length > 0) {
      result.usedBehaviors = ArrayToJson(this._usedBehaviors, JsonToString);
    }
    if (this._usedUpgrades.length > 0) {
      result.usedUpgrades = ArrayToJson(this._usedUpgrades, JsonToString);
    }
    if (this._usedTags.length > 0) {
      result.usedTags = ArrayToJson(this._usedTags, JsonToString);
    }
    if (this._usedSoundAssets.length > 0) {
      result.usedSoundAssets = ArrayToJson(this._usedSoundAssets, JsonToString);
    }
    if (this._usedAtlasAssets.length > 0) {
      result.usedAtlasAssets = ArrayToJson(this._usedAtlasAssets, JsonToString);
    }
    if (this._usedSpriteAssets.length > 0) {
      result.usedSpriteAssets = ArrayToJson(this._usedSpriteAssets, JsonToString);
    }
    if (this._usedFontAssets.length > 0) {
      result.usedFontAssets = ArrayToJson(this._usedFontAssets, JsonToString);
    }
    return result;
  }
  /**
   * @returns {string[]}
   */
  get usedUnits() {
    return this._usedUnits;
  }
  addUsedUnits(path, value) {
    return {type: 'ADD', path: path.concat(['usedUnits']), value};
  }
  setUsedUnits(path, value) {
    return {type: 'SET', path: path.concat(['usedUnits']), value: ArrayToJson(value, JsonToString)};
  }
  setUsedUnitsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['usedUnits', key]), value};
  }
  deleteUsedUnits(path) {
    return {type: 'DELETE', path: path.concat(['usedUnits'])};
  }
  deleteUsedUnitsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['usedUnits', key])};
  }
  /**
   * @returns {string[]}
   */
  get usedEffects() {
    return this._usedEffects;
  }
  addUsedEffects(path, value) {
    return {type: 'ADD', path: path.concat(['usedEffects']), value};
  }
  setUsedEffects(path, value) {
    return {type: 'SET', path: path.concat(['usedEffects']), value: ArrayToJson(value, JsonToString)};
  }
  setUsedEffectsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['usedEffects', key]), value};
  }
  deleteUsedEffects(path) {
    return {type: 'DELETE', path: path.concat(['usedEffects'])};
  }
  deleteUsedEffectsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['usedEffects', key])};
  }
  /**
   * @returns {string[]}
   */
  get usedBehaviors() {
    return this._usedBehaviors;
  }
  addUsedBehaviors(path, value) {
    return {type: 'ADD', path: path.concat(['usedBehaviors']), value};
  }
  setUsedBehaviors(path, value) {
    return {type: 'SET', path: path.concat(['usedBehaviors']), value: ArrayToJson(value, JsonToString)};
  }
  setUsedBehaviorsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['usedBehaviors', key]), value};
  }
  deleteUsedBehaviors(path) {
    return {type: 'DELETE', path: path.concat(['usedBehaviors'])};
  }
  deleteUsedBehaviorsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['usedBehaviors', key])};
  }
  /**
   * @returns {string[]}
   */
  get usedUpgrades() {
    return this._usedUpgrades;
  }
  addUsedUpgrades(path, value) {
    return {type: 'ADD', path: path.concat(['usedUpgrades']), value};
  }
  setUsedUpgrades(path, value) {
    return {type: 'SET', path: path.concat(['usedUpgrades']), value: ArrayToJson(value, JsonToString)};
  }
  setUsedUpgradesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['usedUpgrades', key]), value};
  }
  deleteUsedUpgrades(path) {
    return {type: 'DELETE', path: path.concat(['usedUpgrades'])};
  }
  deleteUsedUpgradesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['usedUpgrades', key])};
  }
  /**
   * @returns {string[]}
   */
  get usedTags() {
    return this._usedTags;
  }
  addUsedTags(path, value) {
    return {type: 'ADD', path: path.concat(['usedTags']), value};
  }
  setUsedTags(path, value) {
    return {type: 'SET', path: path.concat(['usedTags']), value: ArrayToJson(value, JsonToString)};
  }
  setUsedTagsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['usedTags', key]), value};
  }
  deleteUsedTags(path) {
    return {type: 'DELETE', path: path.concat(['usedTags'])};
  }
  deleteUsedTagsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['usedTags', key])};
  }
  /**
   * @returns {string[]}
   */
  get usedSoundAssets() {
    return this._usedSoundAssets;
  }
  addUsedSoundAssets(path, value) {
    return {type: 'ADD', path: path.concat(['usedSoundAssets']), value};
  }
  setUsedSoundAssets(path, value) {
    return {type: 'SET', path: path.concat(['usedSoundAssets']), value: ArrayToJson(value, JsonToString)};
  }
  setUsedSoundAssetsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['usedSoundAssets', key]), value};
  }
  deleteUsedSoundAssets(path) {
    return {type: 'DELETE', path: path.concat(['usedSoundAssets'])};
  }
  deleteUsedSoundAssetsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['usedSoundAssets', key])};
  }
  /**
   * @returns {string[]}
   */
  get usedAtlasAssets() {
    return this._usedAtlasAssets;
  }
  addUsedAtlasAssets(path, value) {
    return {type: 'ADD', path: path.concat(['usedAtlasAssets']), value};
  }
  setUsedAtlasAssets(path, value) {
    return {type: 'SET', path: path.concat(['usedAtlasAssets']), value: ArrayToJson(value, JsonToString)};
  }
  setUsedAtlasAssetsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['usedAtlasAssets', key]), value};
  }
  deleteUsedAtlasAssets(path) {
    return {type: 'DELETE', path: path.concat(['usedAtlasAssets'])};
  }
  deleteUsedAtlasAssetsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['usedAtlasAssets', key])};
  }
  /**
   * @returns {string[]}
   */
  get usedSpriteAssets() {
    return this._usedSpriteAssets;
  }
  addUsedSpriteAssets(path, value) {
    return {type: 'ADD', path: path.concat(['usedSpriteAssets']), value};
  }
  setUsedSpriteAssets(path, value) {
    return {type: 'SET', path: path.concat(['usedSpriteAssets']), value: ArrayToJson(value, JsonToString)};
  }
  setUsedSpriteAssetsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['usedSpriteAssets', key]), value};
  }
  deleteUsedSpriteAssets(path) {
    return {type: 'DELETE', path: path.concat(['usedSpriteAssets'])};
  }
  deleteUsedSpriteAssetsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['usedSpriteAssets', key])};
  }
  /**
   * @returns {string[]}
   */
  get usedFontAssets() {
    return this._usedFontAssets;
  }
  addUsedFontAssets(path, value) {
    return {type: 'ADD', path: path.concat(['usedFontAssets']), value};
  }
  setUsedFontAssets(path, value) {
    return {type: 'SET', path: path.concat(['usedFontAssets']), value: ArrayToJson(value, JsonToString)};
  }
  setUsedFontAssetsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['usedFontAssets', key]), value};
  }
  deleteUsedFontAssets(path) {
    return {type: 'DELETE', path: path.concat(['usedFontAssets'])};
  }
  deleteUsedFontAssetsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['usedFontAssets', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "usedUnits": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TriggerSettings(this);
              copy._usedUnits = [];        for (let i of value) {
                copy._usedUnits.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TriggerSettings(this);
              copy._usedUnits = copy._usedUnits.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._usedUnits.length === 0) {
                return this;
              }
              const copy = new TriggerSettings(this);
              copy._usedUnits = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._usedUnits.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TriggerSettings(this);
              copy._usedUnits = copy._usedUnits.slice();
              copy._usedUnits[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TriggerSettings(this);
              copy._usedUnits = copy._usedUnits.slice(0, path[1]).concat(copy._usedUnits.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._usedUnits.length) {
            return this;
          }
          const oldValue = this._usedUnits[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TriggerSettings(this);
          copy._usedUnits = copy._usedUnits.slice();
          copy._usedUnits[key] = newValue;
          return copy;
        }
      }
      case "usedEffects": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TriggerSettings(this);
              copy._usedEffects = [];        for (let i of value) {
                copy._usedEffects.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TriggerSettings(this);
              copy._usedEffects = copy._usedEffects.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._usedEffects.length === 0) {
                return this;
              }
              const copy = new TriggerSettings(this);
              copy._usedEffects = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._usedEffects.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TriggerSettings(this);
              copy._usedEffects = copy._usedEffects.slice();
              copy._usedEffects[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TriggerSettings(this);
              copy._usedEffects = copy._usedEffects.slice(0, path[1]).concat(copy._usedEffects.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._usedEffects.length) {
            return this;
          }
          const oldValue = this._usedEffects[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TriggerSettings(this);
          copy._usedEffects = copy._usedEffects.slice();
          copy._usedEffects[key] = newValue;
          return copy;
        }
      }
      case "usedBehaviors": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TriggerSettings(this);
              copy._usedBehaviors = [];        for (let i of value) {
                copy._usedBehaviors.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TriggerSettings(this);
              copy._usedBehaviors = copy._usedBehaviors.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._usedBehaviors.length === 0) {
                return this;
              }
              const copy = new TriggerSettings(this);
              copy._usedBehaviors = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._usedBehaviors.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TriggerSettings(this);
              copy._usedBehaviors = copy._usedBehaviors.slice();
              copy._usedBehaviors[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TriggerSettings(this);
              copy._usedBehaviors = copy._usedBehaviors.slice(0, path[1]).concat(copy._usedBehaviors.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._usedBehaviors.length) {
            return this;
          }
          const oldValue = this._usedBehaviors[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TriggerSettings(this);
          copy._usedBehaviors = copy._usedBehaviors.slice();
          copy._usedBehaviors[key] = newValue;
          return copy;
        }
      }
      case "usedUpgrades": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TriggerSettings(this);
              copy._usedUpgrades = [];        for (let i of value) {
                copy._usedUpgrades.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TriggerSettings(this);
              copy._usedUpgrades = copy._usedUpgrades.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._usedUpgrades.length === 0) {
                return this;
              }
              const copy = new TriggerSettings(this);
              copy._usedUpgrades = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._usedUpgrades.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TriggerSettings(this);
              copy._usedUpgrades = copy._usedUpgrades.slice();
              copy._usedUpgrades[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TriggerSettings(this);
              copy._usedUpgrades = copy._usedUpgrades.slice(0, path[1]).concat(copy._usedUpgrades.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._usedUpgrades.length) {
            return this;
          }
          const oldValue = this._usedUpgrades[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TriggerSettings(this);
          copy._usedUpgrades = copy._usedUpgrades.slice();
          copy._usedUpgrades[key] = newValue;
          return copy;
        }
      }
      case "usedTags": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TriggerSettings(this);
              copy._usedTags = [];        for (let i of value) {
                copy._usedTags.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TriggerSettings(this);
              copy._usedTags = copy._usedTags.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._usedTags.length === 0) {
                return this;
              }
              const copy = new TriggerSettings(this);
              copy._usedTags = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._usedTags.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TriggerSettings(this);
              copy._usedTags = copy._usedTags.slice();
              copy._usedTags[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TriggerSettings(this);
              copy._usedTags = copy._usedTags.slice(0, path[1]).concat(copy._usedTags.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._usedTags.length) {
            return this;
          }
          const oldValue = this._usedTags[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TriggerSettings(this);
          copy._usedTags = copy._usedTags.slice();
          copy._usedTags[key] = newValue;
          return copy;
        }
      }
      case "usedSoundAssets": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TriggerSettings(this);
              copy._usedSoundAssets = [];        for (let i of value) {
                copy._usedSoundAssets.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TriggerSettings(this);
              copy._usedSoundAssets = copy._usedSoundAssets.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._usedSoundAssets.length === 0) {
                return this;
              }
              const copy = new TriggerSettings(this);
              copy._usedSoundAssets = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._usedSoundAssets.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TriggerSettings(this);
              copy._usedSoundAssets = copy._usedSoundAssets.slice();
              copy._usedSoundAssets[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TriggerSettings(this);
              copy._usedSoundAssets = copy._usedSoundAssets.slice(0, path[1]).concat(copy._usedSoundAssets.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._usedSoundAssets.length) {
            return this;
          }
          const oldValue = this._usedSoundAssets[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TriggerSettings(this);
          copy._usedSoundAssets = copy._usedSoundAssets.slice();
          copy._usedSoundAssets[key] = newValue;
          return copy;
        }
      }
      case "usedAtlasAssets": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TriggerSettings(this);
              copy._usedAtlasAssets = [];        for (let i of value) {
                copy._usedAtlasAssets.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TriggerSettings(this);
              copy._usedAtlasAssets = copy._usedAtlasAssets.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._usedAtlasAssets.length === 0) {
                return this;
              }
              const copy = new TriggerSettings(this);
              copy._usedAtlasAssets = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._usedAtlasAssets.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TriggerSettings(this);
              copy._usedAtlasAssets = copy._usedAtlasAssets.slice();
              copy._usedAtlasAssets[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TriggerSettings(this);
              copy._usedAtlasAssets = copy._usedAtlasAssets.slice(0, path[1]).concat(copy._usedAtlasAssets.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._usedAtlasAssets.length) {
            return this;
          }
          const oldValue = this._usedAtlasAssets[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TriggerSettings(this);
          copy._usedAtlasAssets = copy._usedAtlasAssets.slice();
          copy._usedAtlasAssets[key] = newValue;
          return copy;
        }
      }
      case "usedSpriteAssets": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TriggerSettings(this);
              copy._usedSpriteAssets = [];        for (let i of value) {
                copy._usedSpriteAssets.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TriggerSettings(this);
              copy._usedSpriteAssets = copy._usedSpriteAssets.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._usedSpriteAssets.length === 0) {
                return this;
              }
              const copy = new TriggerSettings(this);
              copy._usedSpriteAssets = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._usedSpriteAssets.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TriggerSettings(this);
              copy._usedSpriteAssets = copy._usedSpriteAssets.slice();
              copy._usedSpriteAssets[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TriggerSettings(this);
              copy._usedSpriteAssets = copy._usedSpriteAssets.slice(0, path[1]).concat(copy._usedSpriteAssets.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._usedSpriteAssets.length) {
            return this;
          }
          const oldValue = this._usedSpriteAssets[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TriggerSettings(this);
          copy._usedSpriteAssets = copy._usedSpriteAssets.slice();
          copy._usedSpriteAssets[key] = newValue;
          return copy;
        }
      }
      case "usedFontAssets": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TriggerSettings(this);
              copy._usedFontAssets = [];        for (let i of value) {
                copy._usedFontAssets.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TriggerSettings(this);
              copy._usedFontAssets = copy._usedFontAssets.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._usedFontAssets.length === 0) {
                return this;
              }
              const copy = new TriggerSettings(this);
              copy._usedFontAssets = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._usedFontAssets.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TriggerSettings(this);
              copy._usedFontAssets = copy._usedFontAssets.slice();
              copy._usedFontAssets[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TriggerSettings(this);
              copy._usedFontAssets = copy._usedFontAssets.slice(0, path[1]).concat(copy._usedFontAssets.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._usedFontAssets.length) {
            return this;
          }
          const oldValue = this._usedFontAssets[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TriggerSettings(this);
          copy._usedFontAssets = copy._usedFontAssets.slice();
          copy._usedFontAssets[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TriggerSettings} other
   * @returns {TriggerSettings}
   */
  merge(other) {
    const copy = new TriggerSettings(this);
    copy._usedUnits = this._usedUnits.concat(other._usedUnits);
    copy._usedEffects = this._usedEffects.concat(other._usedEffects);
    copy._usedBehaviors = this._usedBehaviors.concat(other._usedBehaviors);
    copy._usedUpgrades = this._usedUpgrades.concat(other._usedUpgrades);
    copy._usedTags = this._usedTags.concat(other._usedTags);
    copy._usedSoundAssets = this._usedSoundAssets.concat(other._usedSoundAssets);
    copy._usedAtlasAssets = this._usedAtlasAssets.concat(other._usedAtlasAssets);
    copy._usedSpriteAssets = this._usedSpriteAssets.concat(other._usedSpriteAssets);
    copy._usedFontAssets = this._usedFontAssets.concat(other._usedFontAssets);
    return copy;
  }
}
TriggerSettings.default = new TriggerSettings();
class TriggerSettings_Builder {
  constructor(value) {
    this._value = new TriggerSettings(value);
  }
  build() {
    return new TriggerSettings(this._value);
  }
  addAllUsedUnits(values) {
    this._value._usedUnits = this._value._usedUnits.concat(values);
    return this;
  }
  addUsedUnits(value) {
    this._value._usedUnits = this._value._usedUnits.concat([value]);
    return this;
  }
  setUsedUnits(index, value) {
    this._value._usedUnits = this._value._usedUnits.concat();
    this._value._usedUnits[index] = value;
    return this;
  }
  clearUsedUnits() {
    this._value._usedUnits = [];
    return this;
  }
  addAllUsedEffects(values) {
    this._value._usedEffects = this._value._usedEffects.concat(values);
    return this;
  }
  addUsedEffects(value) {
    this._value._usedEffects = this._value._usedEffects.concat([value]);
    return this;
  }
  setUsedEffects(index, value) {
    this._value._usedEffects = this._value._usedEffects.concat();
    this._value._usedEffects[index] = value;
    return this;
  }
  clearUsedEffects() {
    this._value._usedEffects = [];
    return this;
  }
  addAllUsedBehaviors(values) {
    this._value._usedBehaviors = this._value._usedBehaviors.concat(values);
    return this;
  }
  addUsedBehaviors(value) {
    this._value._usedBehaviors = this._value._usedBehaviors.concat([value]);
    return this;
  }
  setUsedBehaviors(index, value) {
    this._value._usedBehaviors = this._value._usedBehaviors.concat();
    this._value._usedBehaviors[index] = value;
    return this;
  }
  clearUsedBehaviors() {
    this._value._usedBehaviors = [];
    return this;
  }
  addAllUsedUpgrades(values) {
    this._value._usedUpgrades = this._value._usedUpgrades.concat(values);
    return this;
  }
  addUsedUpgrades(value) {
    this._value._usedUpgrades = this._value._usedUpgrades.concat([value]);
    return this;
  }
  setUsedUpgrades(index, value) {
    this._value._usedUpgrades = this._value._usedUpgrades.concat();
    this._value._usedUpgrades[index] = value;
    return this;
  }
  clearUsedUpgrades() {
    this._value._usedUpgrades = [];
    return this;
  }
  addAllUsedTags(values) {
    this._value._usedTags = this._value._usedTags.concat(values);
    return this;
  }
  addUsedTags(value) {
    this._value._usedTags = this._value._usedTags.concat([value]);
    return this;
  }
  setUsedTags(index, value) {
    this._value._usedTags = this._value._usedTags.concat();
    this._value._usedTags[index] = value;
    return this;
  }
  clearUsedTags() {
    this._value._usedTags = [];
    return this;
  }
  addAllUsedSoundAssets(values) {
    this._value._usedSoundAssets = this._value._usedSoundAssets.concat(values);
    return this;
  }
  addUsedSoundAssets(value) {
    this._value._usedSoundAssets = this._value._usedSoundAssets.concat([value]);
    return this;
  }
  setUsedSoundAssets(index, value) {
    this._value._usedSoundAssets = this._value._usedSoundAssets.concat();
    this._value._usedSoundAssets[index] = value;
    return this;
  }
  clearUsedSoundAssets() {
    this._value._usedSoundAssets = [];
    return this;
  }
  addAllUsedAtlasAssets(values) {
    this._value._usedAtlasAssets = this._value._usedAtlasAssets.concat(values);
    return this;
  }
  addUsedAtlasAssets(value) {
    this._value._usedAtlasAssets = this._value._usedAtlasAssets.concat([value]);
    return this;
  }
  setUsedAtlasAssets(index, value) {
    this._value._usedAtlasAssets = this._value._usedAtlasAssets.concat();
    this._value._usedAtlasAssets[index] = value;
    return this;
  }
  clearUsedAtlasAssets() {
    this._value._usedAtlasAssets = [];
    return this;
  }
  addAllUsedSpriteAssets(values) {
    this._value._usedSpriteAssets = this._value._usedSpriteAssets.concat(values);
    return this;
  }
  addUsedSpriteAssets(value) {
    this._value._usedSpriteAssets = this._value._usedSpriteAssets.concat([value]);
    return this;
  }
  setUsedSpriteAssets(index, value) {
    this._value._usedSpriteAssets = this._value._usedSpriteAssets.concat();
    this._value._usedSpriteAssets[index] = value;
    return this;
  }
  clearUsedSpriteAssets() {
    this._value._usedSpriteAssets = [];
    return this;
  }
  addAllUsedFontAssets(values) {
    this._value._usedFontAssets = this._value._usedFontAssets.concat(values);
    return this;
  }
  addUsedFontAssets(value) {
    this._value._usedFontAssets = this._value._usedFontAssets.concat([value]);
    return this;
  }
  setUsedFontAssets(index, value) {
    this._value._usedFontAssets = this._value._usedFontAssets.concat();
    this._value._usedFontAssets[index] = value;
    return this;
  }
  clearUsedFontAssets() {
    this._value._usedFontAssets = [];
    return this;
  }
}
TriggerSettings.Builder = TriggerSettings_Builder;
class TriggerSettings_WithParent {
  /**
   * @param {TriggerSettings} value
   * @param {TriggerSettings_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TriggerSettings.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfUsedUnits() {
    return this._value.usedUnits;
  }
  get inherentUsedUnits() {
    if (!this._inherentUsedUnits) {
      this._inherentUsedUnits = this._parent ? this._parent.usedUnits : [];
    }
    return this._inherentUsedUnits;
  }
  get usedUnits() {
    if (!this._allUsedUnits) {
      this._allUsedUnits = this._parent ? this._parent.usedUnits.concat(this.selfUsedUnits) : this.selfUsedUnits;
    }
    return this._allUsedUnits;
  }
  get selfUsedEffects() {
    return this._value.usedEffects;
  }
  get inherentUsedEffects() {
    if (!this._inherentUsedEffects) {
      this._inherentUsedEffects = this._parent ? this._parent.usedEffects : [];
    }
    return this._inherentUsedEffects;
  }
  get usedEffects() {
    if (!this._allUsedEffects) {
      this._allUsedEffects = this._parent ? this._parent.usedEffects.concat(this.selfUsedEffects) : this.selfUsedEffects;
    }
    return this._allUsedEffects;
  }
  get selfUsedBehaviors() {
    return this._value.usedBehaviors;
  }
  get inherentUsedBehaviors() {
    if (!this._inherentUsedBehaviors) {
      this._inherentUsedBehaviors = this._parent ? this._parent.usedBehaviors : [];
    }
    return this._inherentUsedBehaviors;
  }
  get usedBehaviors() {
    if (!this._allUsedBehaviors) {
      this._allUsedBehaviors = this._parent ? this._parent.usedBehaviors.concat(this.selfUsedBehaviors) : this.selfUsedBehaviors;
    }
    return this._allUsedBehaviors;
  }
  get selfUsedUpgrades() {
    return this._value.usedUpgrades;
  }
  get inherentUsedUpgrades() {
    if (!this._inherentUsedUpgrades) {
      this._inherentUsedUpgrades = this._parent ? this._parent.usedUpgrades : [];
    }
    return this._inherentUsedUpgrades;
  }
  get usedUpgrades() {
    if (!this._allUsedUpgrades) {
      this._allUsedUpgrades = this._parent ? this._parent.usedUpgrades.concat(this.selfUsedUpgrades) : this.selfUsedUpgrades;
    }
    return this._allUsedUpgrades;
  }
  get selfUsedTags() {
    return this._value.usedTags;
  }
  get inherentUsedTags() {
    if (!this._inherentUsedTags) {
      this._inherentUsedTags = this._parent ? this._parent.usedTags : [];
    }
    return this._inherentUsedTags;
  }
  get usedTags() {
    if (!this._allUsedTags) {
      this._allUsedTags = this._parent ? this._parent.usedTags.concat(this.selfUsedTags) : this.selfUsedTags;
    }
    return this._allUsedTags;
  }
  get selfUsedSoundAssets() {
    return this._value.usedSoundAssets;
  }
  get inherentUsedSoundAssets() {
    if (!this._inherentUsedSoundAssets) {
      this._inherentUsedSoundAssets = this._parent ? this._parent.usedSoundAssets : [];
    }
    return this._inherentUsedSoundAssets;
  }
  get usedSoundAssets() {
    if (!this._allUsedSoundAssets) {
      this._allUsedSoundAssets = this._parent ? this._parent.usedSoundAssets.concat(this.selfUsedSoundAssets) : this.selfUsedSoundAssets;
    }
    return this._allUsedSoundAssets;
  }
  get selfUsedAtlasAssets() {
    return this._value.usedAtlasAssets;
  }
  get inherentUsedAtlasAssets() {
    if (!this._inherentUsedAtlasAssets) {
      this._inherentUsedAtlasAssets = this._parent ? this._parent.usedAtlasAssets : [];
    }
    return this._inherentUsedAtlasAssets;
  }
  get usedAtlasAssets() {
    if (!this._allUsedAtlasAssets) {
      this._allUsedAtlasAssets = this._parent ? this._parent.usedAtlasAssets.concat(this.selfUsedAtlasAssets) : this.selfUsedAtlasAssets;
    }
    return this._allUsedAtlasAssets;
  }
  get selfUsedSpriteAssets() {
    return this._value.usedSpriteAssets;
  }
  get inherentUsedSpriteAssets() {
    if (!this._inherentUsedSpriteAssets) {
      this._inherentUsedSpriteAssets = this._parent ? this._parent.usedSpriteAssets : [];
    }
    return this._inherentUsedSpriteAssets;
  }
  get usedSpriteAssets() {
    if (!this._allUsedSpriteAssets) {
      this._allUsedSpriteAssets = this._parent ? this._parent.usedSpriteAssets.concat(this.selfUsedSpriteAssets) : this.selfUsedSpriteAssets;
    }
    return this._allUsedSpriteAssets;
  }
  get selfUsedFontAssets() {
    return this._value.usedFontAssets;
  }
  get inherentUsedFontAssets() {
    if (!this._inherentUsedFontAssets) {
      this._inherentUsedFontAssets = this._parent ? this._parent.usedFontAssets : [];
    }
    return this._inherentUsedFontAssets;
  }
  get usedFontAssets() {
    if (!this._allUsedFontAssets) {
      this._allUsedFontAssets = this._parent ? this._parent.usedFontAssets.concat(this.selfUsedFontAssets) : this.selfUsedFontAssets;
    }
    return this._allUsedFontAssets;
  }
  update(current, parent) {
    const result = new TriggerSettings_WithParent(current, parent);
    return result;
  }
}
TriggerSettings_WithParent.default = new TriggerSettings_WithParent(TriggerSettings.default, null);
TriggerSettings.WithParent = TriggerSettings_WithParent;
class TriggerSettings_Descriptor {
  get usedUnits() {
    if (!this._usedUnits) {
      this._usedUnits = {
        name: "usedUnits",
        Name: "UsedUnits",
        number: 1,
        protoType: 9,
        protoName: "used_units",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Units declared here can be created via script.",
          valueDropdown: "SupportedBaseUnitNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._usedUnits;
  }
  get usedEffects() {
    if (!this._usedEffects) {
      this._usedEffects = {
        name: "usedEffects",
        Name: "UsedEffects",
        number: 2,
        protoType: 9,
        protoName: "used_effects",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Effects declared here can be created via script.",
          valueDropdown: "SupportedEffectListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._usedEffects;
  }
  get usedBehaviors() {
    if (!this._usedBehaviors) {
      this._usedBehaviors = {
        name: "usedBehaviors",
        Name: "UsedBehaviors",
        number: 3,
        protoType: 9,
        protoName: "used_behaviors",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Behaviors declared here can be applied via script.",
          valueDropdown: "SupportedBehaviorNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._usedBehaviors;
  }
  get usedUpgrades() {
    if (!this._usedUpgrades) {
      this._usedUpgrades = {
        name: "usedUpgrades",
        Name: "UsedUpgrades",
        number: 5,
        protoType: 9,
        protoName: "used_upgrades",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "SupportedUpgrades",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._usedUpgrades;
  }
  get usedTags() {
    if (!this._usedTags) {
      this._usedTags = {
        name: "usedTags",
        Name: "UsedTags",
        number: 4,
        protoType: 9,
        protoName: "used_tags",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Tags declared here can be applied via script.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._usedTags;
  }
  get usedSoundAssets() {
    if (!this._usedSoundAssets) {
      this._usedSoundAssets = {
        name: "usedSoundAssets",
        Name: "UsedSoundAssets",
        number: 11,
        protoType: 9,
        protoName: "used_sound_assets",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Sound assets declared here can be created via script.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._usedSoundAssets;
  }
  get usedAtlasAssets() {
    if (!this._usedAtlasAssets) {
      this._usedAtlasAssets = {
        name: "usedAtlasAssets",
        Name: "UsedAtlasAssets",
        number: 12,
        protoType: 9,
        protoName: "used_atlas_assets",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Sprite assets that use the atlas declared here can be used in custom UI created with script. The atlas a sprite belongs to is displayed in the asset previewer. Note the required formatting: If an asset shows it belongs to the `UnitThumbnailsAtlas` atlas, the atlas must be declared as `Assets/Bundles/UI/Atlas/UnitThumbnailsAtlas.spriteatlas`.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._usedAtlasAssets;
  }
  get usedSpriteAssets() {
    if (!this._usedSpriteAssets) {
      this._usedSpriteAssets = {
        name: "usedSpriteAssets",
        Name: "UsedSpriteAssets",
        number: 13,
        protoType: 9,
        protoName: "used_sprite_assets",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Sprite assets without an atlas (indicated by `Other` in the asset previewer) must be declared directly before they can be used. For example to use the `gold_chest` asset, you would declare `gold_chest`.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._usedSpriteAssets;
  }
  get usedFontAssets() {
    if (!this._usedFontAssets) {
      this._usedFontAssets = {
        name: "usedFontAssets",
        Name: "UsedFontAssets",
        number: 14,
        protoType: 9,
        protoName: "used_font_assets",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Fonts assets declared here can be used in the project.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._usedFontAssets;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.usedUnits,
        this.usedEffects,
        this.usedBehaviors,
        this.usedUpgrades,
        this.usedTags,
        this.usedSoundAssets,
        this.usedAtlasAssets,
        this.usedSpriteAssets,
        this.usedFontAssets,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
TriggerSettings.descriptor = new TriggerSettings_Descriptor();
class DisplaySettings_Orientation {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "LANDSCAPE": return 0;
        case "PORTRAIT": return 1;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return DisplaySettings_Orientation.fromJson(value);
  }
  static fromReact(e) {
    return DisplaySettings_Orientation.fromJson(e);
  }
}
DisplaySettings_Orientation.LANDSCAPE = 0;
DisplaySettings_Orientation.PORTRAIT = 1;
DisplaySettings_Orientation.default = 0;
DisplaySettings_Orientation.values = {
  LANDSCAPE: 0,
  PORTRAIT: 1,
};
DisplaySettings_Orientation.names = {
  0: "LANDSCAPE",
  1: "PORTRAIT",
};
export class DisplaySettings {
  get descriptor() {
    return DisplaySettings.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasOrientation = false;
    this._orientation = null;
  }
  isEmpty() {
    if (this._hasOrientation) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DisplaySettings) {
      return value;
    }
    return DisplaySettings.fromJson(value);
  }
  static fromJson(json) {
    const result = new DisplaySettings();
    if (json.orientation != null) {
      result._hasOrientation = true;
      result._orientation = DisplaySettings_Orientation.fromJson(json.orientation);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasOrientation) {
      result.orientation = DisplaySettings_Orientation.toJson(this._orientation);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get orientation() {
    return this._hasOrientation ? this._orientation : DisplaySettings_Orientation.default;
  }
  get hasOrientation() {
    return this._hasOrientation;
  }
  setOrientation(path, value) {
    return {type: 'SET', path: path.concat(['orientation']), value};
  }
  deleteOrientation(path) {
    return {type: 'DELETE', path: path.concat(['orientation'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "orientation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DisplaySettings(this);
              copy._hasOrientation = true;
              copy._orientation = DisplaySettings_Orientation.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOrientation) {
                return this;
              }
              const copy = new DisplaySettings(this);
              copy._hasOrientation = false;
              copy._orientation = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DisplaySettings} other
   * @returns {DisplaySettings}
   */
  merge(other) {
    const copy = new DisplaySettings(this);
    if (other._hasOrientation) {
      copy._hasOrientation = true;
      copy._orientation = other._orientation;
    }
    return copy;
  }
}
DisplaySettings.default = new DisplaySettings();
DisplaySettings.Orientation = DisplaySettings_Orientation;
class DisplaySettings_Builder {
  constructor(value) {
    this._value = new DisplaySettings(value);
  }
  build() {
    return new DisplaySettings(this._value);
  }
  setOrientation(value) {
    this._value._hasOrientation = true;
    this._value._orientation = value;
    return this;
  }
  deleteOrientation() {
    this._value._hasOrientation = false;
    this._value._orientation = null;
    return this;
  }
}
DisplaySettings.Builder = DisplaySettings_Builder;
class DisplaySettings_WithParent {
  /**
   * @param {DisplaySettings} value
   * @param {DisplaySettings_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DisplaySettings.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasOrientation() {
    if (this._cachedHasOrientation === undefined) {
      if (this._value.hasOrientation) {
        this._cachedHasOrientation = true;
      } else {
        this._cachedHasOrientation = this._parent ? this._parent.hasOrientation : false;
      }
    }
    return this._cachedHasOrientation;
  }
  get orientation() {
    if (this._cachedOrientation === undefined) {
      if (this._value.hasOrientation) {
        this._cachedOrientation = this._value.orientation;
      } else {
        this._cachedOrientation = this._parent ? this._parent.orientation : this._value.orientation;
      }
    }
    return this._cachedOrientation;
  }
  update(current, parent) {
    const result = new DisplaySettings_WithParent(current, parent);
    return result;
  }
}
DisplaySettings_WithParent.default = new DisplaySettings_WithParent(DisplaySettings.default, null);
DisplaySettings.WithParent = DisplaySettings_WithParent;
class DisplaySettings_Descriptor {
  get orientation() {
    if (!this._orientation) {
      this._orientation = {
        name: "orientation",
        Name: "Orientation",
        number: 1,
        protoType: 14,
        protoName: "orientation",
        type: DisplaySettings_Orientation,
        options: {
          comments: "Sets the display mode to be landscape (default) or portrait.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._orientation;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.orientation,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForOrientation",
        Name: "DummyOneofForOrientation",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
DisplaySettings.descriptor = new DisplaySettings_Descriptor();
class FontSettings_FontSetting {
  get descriptor() {
    return FontSettings_FontSetting.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasLanguage = false;
    this._language = null;
    this._hasFont = false;
    this._font = null;
  }
  isEmpty() {
    if (this._hasLanguage) return false;
    if (this._hasFont) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof FontSettings_FontSetting) {
      return value;
    }
    return FontSettings_FontSetting.fromJson(value);
  }
  static fromJson(json) {
    const result = new FontSettings_FontSetting();
    if (json.language != null) {
      result._hasLanguage = true;
      result._language = JsonToString.fromJson(json.language);
    }
    if (json.font != null) {
      result._hasFont = true;
      result._font = JsonToString.fromJson(json.font);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasLanguage) {
      result.language = JsonToString.toJson(this._language);
    }
    if (this._hasFont) {
      result.font = JsonToString.toJson(this._font);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get language() {
    return this._hasLanguage ? this._language : JsonToString.default;
  }
  get hasLanguage() {
    return this._hasLanguage;
  }
  setLanguage(path, value) {
    return {type: 'SET', path: path.concat(['language']), value};
  }
  deleteLanguage(path) {
    return {type: 'DELETE', path: path.concat(['language'])};
  }
  /**
   * @returns {string}
   */
  get font() {
    return this._hasFont ? this._font : JsonToString.default;
  }
  get hasFont() {
    return this._hasFont;
  }
  setFont(path, value) {
    return {type: 'SET', path: path.concat(['font']), value};
  }
  deleteFont(path) {
    return {type: 'DELETE', path: path.concat(['font'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "language": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FontSettings_FontSetting(this);
              copy._hasLanguage = true;
              copy._language = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLanguage) {
                return this;
              }
              const copy = new FontSettings_FontSetting(this);
              copy._hasLanguage = false;
              copy._language = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "font": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FontSettings_FontSetting(this);
              copy._hasFont = true;
              copy._font = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFont) {
                return this;
              }
              const copy = new FontSettings_FontSetting(this);
              copy._hasFont = false;
              copy._font = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {FontSettings_FontSetting} other
   * @returns {FontSettings_FontSetting}
   */
  merge(other) {
    const copy = new FontSettings_FontSetting(this);
    if (other._hasLanguage) {
      copy._hasLanguage = true;
      copy._language = other._language;
    }
    if (other._hasFont) {
      copy._hasFont = true;
      copy._font = other._font;
    }
    return copy;
  }
}
FontSettings_FontSetting.default = new FontSettings_FontSetting();
class FontSettings_FontSetting_Builder {
  constructor(value) {
    this._value = new FontSettings_FontSetting(value);
  }
  build() {
    return new FontSettings_FontSetting(this._value);
  }
  setLanguage(value) {
    this._value._hasLanguage = true;
    this._value._language = value;
    return this;
  }
  deleteLanguage() {
    this._value._hasLanguage = false;
    this._value._language = null;
    return this;
  }
  setFont(value) {
    this._value._hasFont = true;
    this._value._font = value;
    return this;
  }
  deleteFont() {
    this._value._hasFont = false;
    this._value._font = null;
    return this;
  }
}
FontSettings_FontSetting.Builder = FontSettings_FontSetting_Builder;
class FontSettings_FontSetting_WithParent {
  /**
   * @param {FontSettings_FontSetting} value
   * @param {FontSettings_FontSetting_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return FontSettings_FontSetting.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasLanguage() {
    if (this._cachedHasLanguage === undefined) {
      if (this._value.hasLanguage) {
        this._cachedHasLanguage = true;
      } else {
        this._cachedHasLanguage = this._parent ? this._parent.hasLanguage : false;
      }
    }
    return this._cachedHasLanguage;
  }
  get language() {
    if (this._cachedLanguage === undefined) {
      if (this._value.hasLanguage) {
        this._cachedLanguage = this._value.language;
      } else {
        this._cachedLanguage = this._parent ? this._parent.language : this._value.language;
      }
    }
    return this._cachedLanguage;
  }
  get hasFont() {
    if (this._cachedHasFont === undefined) {
      if (this._value.hasFont) {
        this._cachedHasFont = true;
      } else {
        this._cachedHasFont = this._parent ? this._parent.hasFont : false;
      }
    }
    return this._cachedHasFont;
  }
  get font() {
    if (this._cachedFont === undefined) {
      if (this._value.hasFont) {
        this._cachedFont = this._value.font;
      } else {
        this._cachedFont = this._parent ? this._parent.font : this._value.font;
      }
    }
    return this._cachedFont;
  }
  update(current, parent) {
    const result = new FontSettings_FontSetting_WithParent(current, parent);
    return result;
  }
}
FontSettings_FontSetting_WithParent.default = new FontSettings_FontSetting_WithParent(FontSettings_FontSetting.default, null);
FontSettings_FontSetting.WithParent = FontSettings_FontSetting_WithParent;
class FontSettings_FontSetting_Descriptor {
  get language() {
    if (!this._language) {
      this._language = {
        name: "language",
        Name: "Language",
        number: 1,
        protoType: 9,
        protoName: "language",
        type: JsonToString,
        options: {
          comments: "The language to override.",
          valueDropdown: "Languages",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._language;
  }
  get font() {
    if (!this._font) {
      this._font = {
        name: "font",
        Name: "Font",
        number: 2,
        protoType: 9,
        protoName: "font",
        type: JsonToString,
        options: {
          comments: "The font to use for this language.",
          valueDropdown: "Fonts",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._font;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.language,
        this.font,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForLanguage",
        Name: "DummyOneofForLanguage",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFont",
        Name: "DummyOneofForFont",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
FontSettings_FontSetting.descriptor = new FontSettings_FontSetting_Descriptor();
export class FontSettings {
  get descriptor() {
    return FontSettings.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._overrideFonts = [];
  }
  isEmpty() {
    if (this._overrideFonts.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof FontSettings) {
      return value;
    }
    return FontSettings.fromJson(value);
  }
  static fromJson(json) {
    const result = new FontSettings();
    result._overrideFonts = JsonToList(json.overrideFonts, FontSettings_FontSetting);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._overrideFonts.length > 0) {
      result.overrideFonts = ArrayToJson(this._overrideFonts, FontSettings_FontSetting);
    }
    return result;
  }
  /**
   * @returns {FontSettings_FontSetting[]}
   */
  get overrideFonts() {
    return this._overrideFonts;
  }
  addOverrideFonts(path, value) {
    return {type: 'ADD', path: path.concat(['overrideFonts']), value: value.toJson()};
  }
  setOverrideFonts(path, value) {
    return {type: 'SET', path: path.concat(['overrideFonts']), value: ArrayToJson(value, FontSettings_FontSetting)};
  }
  setOverrideFontsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['overrideFonts', key]), value: value.toJson()};
  }
  deleteOverrideFonts(path) {
    return {type: 'DELETE', path: path.concat(['overrideFonts'])};
  }
  deleteOverrideFontsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['overrideFonts', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "overrideFonts": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new FontSettings(this);
              copy._overrideFonts = [];        for (let i of value) {
                copy._overrideFonts.push(FontSettings_FontSetting.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new FontSettings(this);
              copy._overrideFonts = copy._overrideFonts.concat([FontSettings_FontSetting.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._overrideFonts.length === 0) {
                return this;
              }
              const copy = new FontSettings(this);
              copy._overrideFonts = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._overrideFonts.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new FontSettings(this);
              copy._overrideFonts = copy._overrideFonts.slice();
              copy._overrideFonts[path[1]] = FontSettings_FontSetting.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new FontSettings(this);
              copy._overrideFonts = copy._overrideFonts.slice(0, path[1]).concat(copy._overrideFonts.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._overrideFonts.length) {
            return this;
          }
          const oldValue = this._overrideFonts[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new FontSettings(this);
          copy._overrideFonts = copy._overrideFonts.slice();
          copy._overrideFonts[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {FontSettings} other
   * @returns {FontSettings}
   */
  merge(other) {
    const copy = new FontSettings(this);
    copy._overrideFonts = this._overrideFonts.concat(other._overrideFonts);
    return copy;
  }
}
FontSettings.default = new FontSettings();
FontSettings.FontSetting = FontSettings_FontSetting;
class FontSettings_Builder {
  constructor(value) {
    this._value = new FontSettings(value);
  }
  build() {
    return new FontSettings(this._value);
  }
  addAllOverrideFonts(values) {
    this._value._overrideFonts = this._value._overrideFonts.concat(values);
    return this;
  }
  addOverrideFonts(value) {
    this._value._overrideFonts = this._value._overrideFonts.concat([value]);
    return this;
  }
  setOverrideFonts(index, value) {
    this._value._overrideFonts = this._value._overrideFonts.concat();
    this._value._overrideFonts[index] = value;
    return this;
  }
  clearOverrideFonts() {
    this._value._overrideFonts = [];
    return this;
  }
}
FontSettings.Builder = FontSettings_Builder;
class FontSettings_WithParent {
  /**
   * @param {FontSettings} value
   * @param {FontSettings_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return FontSettings.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfOverrideFonts() {
    if (!this._selfOverrideFonts) {
      this._selfOverrideFonts = [];
      for (let i of this._value.overrideFonts) {
        this._selfOverrideFonts.push(new FontSettings_FontSetting.WithParent(i, null));
      }
    }
    return this._selfOverrideFonts;
  }
  get inherentOverrideFonts() {
    if (!this._inherentOverrideFonts) {
      this._inherentOverrideFonts = this._parent ? this._parent.overrideFonts : [];
    }
    return this._inherentOverrideFonts;
  }
  get overrideFonts() {
    if (!this._allOverrideFonts) {
      this._allOverrideFonts = this._parent ? this._parent.overrideFonts.concat(this.selfOverrideFonts) : this.selfOverrideFonts;
    }
    return this._allOverrideFonts;
  }
  update(current, parent) {
    const result = new FontSettings_WithParent(current, parent);
    if (this._selfOverrideFonts) {
      if (this._value.overrideFonts === current.overrideFonts) {
        result._selfOverrideFonts = this._selfOverrideFonts;
      } else {
        result._selfOverrideFonts = [];
        for (let i = 0; i < current.overrideFonts.length; i++) {
          const oldValue = this._value.overrideFonts[i];
          if (oldValue) {
            const oldCache = this._selfOverrideFonts[i];
            if (oldValue === current.overrideFonts[i]) {
              result._selfOverrideFonts[i] = oldCache;
            } else {
              result._selfOverrideFonts[i] = oldCache.update(current.overrideFonts[i], null);
            }
          } else {
            result._selfOverrideFonts[i] = new FontSettings_FontSetting.WithParent(current.overrideFonts[i], null);
          }
        }
      }
    }
    return result;
  }
}
FontSettings_WithParent.default = new FontSettings_WithParent(FontSettings.default, null);
FontSettings.WithParent = FontSettings_WithParent;
class FontSettings_Descriptor {
  get overrideFonts() {
    if (!this._overrideFonts) {
      this._overrideFonts = {
        name: "overrideFonts",
        Name: "OverrideFonts",
        number: 1,
        protoType: 11,
        protoName: "override_fonts",
        type: FontSettings_FontSetting,
        isRepeated: true,
        options: {
          comments: "Allows you to override the default text font per-language.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._overrideFonts;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.overrideFonts,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
FontSettings.descriptor = new FontSettings_Descriptor();
export class CustomAssetSettings {
  get descriptor() {
    return CustomAssetSettings.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasImageCompressionQuality = false;
    this._imageCompressionQuality = null;
  }
  isEmpty() {
    if (this._hasImageCompressionQuality) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CustomAssetSettings) {
      return value;
    }
    return CustomAssetSettings.fromJson(value);
  }
  static fromJson(json) {
    const result = new CustomAssetSettings();
    if (json.imageCompressionQuality != null) {
      result._hasImageCompressionQuality = true;
      result._imageCompressionQuality = JsonToInt32.fromJson(json.imageCompressionQuality);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasImageCompressionQuality) {
      result.imageCompressionQuality = JsonToInt32.toJson(this._imageCompressionQuality);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get imageCompressionQuality() {
    return this._hasImageCompressionQuality ? this._imageCompressionQuality : JsonToInt32.default;
  }
  get hasImageCompressionQuality() {
    return this._hasImageCompressionQuality;
  }
  setImageCompressionQuality(path, value) {
    return {type: 'SET', path: path.concat(['imageCompressionQuality']), value};
  }
  deleteImageCompressionQuality(path) {
    return {type: 'DELETE', path: path.concat(['imageCompressionQuality'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "imageCompressionQuality": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CustomAssetSettings(this);
              copy._hasImageCompressionQuality = true;
              copy._imageCompressionQuality = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasImageCompressionQuality) {
                return this;
              }
              const copy = new CustomAssetSettings(this);
              copy._hasImageCompressionQuality = false;
              copy._imageCompressionQuality = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CustomAssetSettings} other
   * @returns {CustomAssetSettings}
   */
  merge(other) {
    const copy = new CustomAssetSettings(this);
    if (other._hasImageCompressionQuality) {
      copy._hasImageCompressionQuality = true;
      copy._imageCompressionQuality = other._imageCompressionQuality;
    }
    return copy;
  }
}
CustomAssetSettings.default = new CustomAssetSettings();
class CustomAssetSettings_Builder {
  constructor(value) {
    this._value = new CustomAssetSettings(value);
  }
  build() {
    return new CustomAssetSettings(this._value);
  }
  setImageCompressionQuality(value) {
    this._value._hasImageCompressionQuality = true;
    this._value._imageCompressionQuality = value;
    return this;
  }
  deleteImageCompressionQuality() {
    this._value._hasImageCompressionQuality = false;
    this._value._imageCompressionQuality = null;
    return this;
  }
}
CustomAssetSettings.Builder = CustomAssetSettings_Builder;
class CustomAssetSettings_WithParent {
  /**
   * @param {CustomAssetSettings} value
   * @param {CustomAssetSettings_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CustomAssetSettings.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasImageCompressionQuality() {
    if (this._cachedHasImageCompressionQuality === undefined) {
      if (this._value.hasImageCompressionQuality) {
        this._cachedHasImageCompressionQuality = true;
      } else {
        this._cachedHasImageCompressionQuality = this._parent ? this._parent.hasImageCompressionQuality : false;
      }
    }
    return this._cachedHasImageCompressionQuality;
  }
  get imageCompressionQuality() {
    if (this._cachedImageCompressionQuality === undefined) {
      if (this._value.hasImageCompressionQuality) {
        this._cachedImageCompressionQuality = this._value.imageCompressionQuality;
      } else {
        this._cachedImageCompressionQuality = this._parent ? this._parent.imageCompressionQuality : this._value.imageCompressionQuality;
      }
    }
    return this._cachedImageCompressionQuality;
  }
  update(current, parent) {
    const result = new CustomAssetSettings_WithParent(current, parent);
    return result;
  }
}
CustomAssetSettings_WithParent.default = new CustomAssetSettings_WithParent(CustomAssetSettings.default, null);
CustomAssetSettings.WithParent = CustomAssetSettings_WithParent;
class CustomAssetSettings_Descriptor {
  get imageCompressionQuality() {
    if (!this._imageCompressionQuality) {
      this._imageCompressionQuality = {
        name: "imageCompressionQuality",
        Name: "ImageCompressionQuality",
        number: 1,
        protoType: 5,
        protoName: "image_compression_quality",
        type: JsonToInt32,
        options: {
          max: 10,
          min: 1,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._imageCompressionQuality;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.imageCompressionQuality,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForImageCompressionQuality",
        Name: "DummyOneofForImageCompressionQuality",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
CustomAssetSettings.descriptor = new CustomAssetSettings_Descriptor();
export class GraphicsSettings {
  get descriptor() {
    return GraphicsSettings.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUseSimpleShadows = false;
    this._useSimpleShadows = null;
  }
  isEmpty() {
    if (this._hasUseSimpleShadows) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof GraphicsSettings) {
      return value;
    }
    return GraphicsSettings.fromJson(value);
  }
  static fromJson(json) {
    const result = new GraphicsSettings();
    if (json.useSimpleShadows != null) {
      result._hasUseSimpleShadows = true;
      result._useSimpleShadows = JsonToBoolean.fromJson(json.useSimpleShadows);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUseSimpleShadows) {
      result.useSimpleShadows = JsonToBoolean.toJson(this._useSimpleShadows);
    }
    return result;
  }
  /**
   * @returns {boolean}
   */
  get useSimpleShadows() {
    return this._hasUseSimpleShadows ? this._useSimpleShadows : JsonToBoolean.default;
  }
  get hasUseSimpleShadows() {
    return this._hasUseSimpleShadows;
  }
  setUseSimpleShadows(path, value) {
    return {type: 'SET', path: path.concat(['useSimpleShadows']), value};
  }
  deleteUseSimpleShadows(path) {
    return {type: 'DELETE', path: path.concat(['useSimpleShadows'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "useSimpleShadows": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new GraphicsSettings(this);
              copy._hasUseSimpleShadows = true;
              copy._useSimpleShadows = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUseSimpleShadows) {
                return this;
              }
              const copy = new GraphicsSettings(this);
              copy._hasUseSimpleShadows = false;
              copy._useSimpleShadows = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {GraphicsSettings} other
   * @returns {GraphicsSettings}
   */
  merge(other) {
    const copy = new GraphicsSettings(this);
    if (other._hasUseSimpleShadows) {
      copy._hasUseSimpleShadows = true;
      copy._useSimpleShadows = other._useSimpleShadows;
    }
    return copy;
  }
}
GraphicsSettings.default = new GraphicsSettings();
class GraphicsSettings_Builder {
  constructor(value) {
    this._value = new GraphicsSettings(value);
  }
  build() {
    return new GraphicsSettings(this._value);
  }
  setUseSimpleShadows(value) {
    this._value._hasUseSimpleShadows = true;
    this._value._useSimpleShadows = value;
    return this;
  }
  deleteUseSimpleShadows() {
    this._value._hasUseSimpleShadows = false;
    this._value._useSimpleShadows = null;
    return this;
  }
}
GraphicsSettings.Builder = GraphicsSettings_Builder;
class GraphicsSettings_WithParent {
  /**
   * @param {GraphicsSettings} value
   * @param {GraphicsSettings_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return GraphicsSettings.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUseSimpleShadows() {
    if (this._cachedHasUseSimpleShadows === undefined) {
      if (this._value.hasUseSimpleShadows) {
        this._cachedHasUseSimpleShadows = true;
      } else {
        this._cachedHasUseSimpleShadows = this._parent ? this._parent.hasUseSimpleShadows : false;
      }
    }
    return this._cachedHasUseSimpleShadows;
  }
  get useSimpleShadows() {
    if (this._cachedUseSimpleShadows === undefined) {
      if (this._value.hasUseSimpleShadows) {
        this._cachedUseSimpleShadows = this._value.useSimpleShadows;
      } else {
        this._cachedUseSimpleShadows = this._parent ? this._parent.useSimpleShadows : this._value.useSimpleShadows;
      }
    }
    return this._cachedUseSimpleShadows;
  }
  update(current, parent) {
    const result = new GraphicsSettings_WithParent(current, parent);
    return result;
  }
}
GraphicsSettings_WithParent.default = new GraphicsSettings_WithParent(GraphicsSettings.default, null);
GraphicsSettings.WithParent = GraphicsSettings_WithParent;
class GraphicsSettings_Descriptor {
  get useSimpleShadows() {
    if (!this._useSimpleShadows) {
      this._useSimpleShadows = {
        name: "useSimpleShadows",
        Name: "UseSimpleShadows",
        number: 1,
        protoType: 8,
        protoName: "use_simple_shadows",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._useSimpleShadows;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.useSimpleShadows,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUseSimpleShadows",
        Name: "DummyOneofForUseSimpleShadows",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
GraphicsSettings.descriptor = new GraphicsSettings_Descriptor();
